import common from './jwys/common_zh';
import footer from './jwys/system/footer_zh';
import waybillFill from './jwys/send/waybillFill_zh';
import emptyVanBook from './jwys/send/emptyVanBook_zh';
import transportStatistics from './jwys/order/transportStatistics_zh';

//按照菜单顺序从左到右，子菜单从上到下排序
export default {
  //公共部分
  common,

  //TODO 首页


  //TODO 首页end


  //TODO 发送业务
  emptyVanBook,//铁路箱预定
  waybillFill,//自备箱发货

  //TODO 发送业务end


  //TODO 到达业务
  arrivalBusiness: {
    cxtj: '重新提交',
    sfjz: '是否进站',
    wjz: '未进站',
    yjz: '已进站',
    sczt: '删除状态',
    ysc: '已删除',
    yscz: '已撤销',
    wsc: '未删除',
    pdr: '派单人',
    ygq: '已过期'
  },
  //TODO 到达业务end


  //TODO 货运服务

  //TODO 货运服务end


  //TODO 办理指南

  //TODO 办理指南end


  //TODO 联系我们

  //TODO 联系我们end


  //TODO 我的订单
  transportStatistics,
  //TODO 我的订单end


  //TODO 系统设置
  footer,
  //TODO 系统设置end

  jzxyz: {
    hxzt: '还箱状态',
    cmrq: '出门日期',
    sscz: '所属车站',
    hxsq: '还箱申请',
    hxqr: '还箱确认',
    jkh: '集卡号',
    qrm: '确认码',
    yqrhx: '已确认还箱'

  },
  roleManagement: {
    czlx: '操作类型',
    czjg: '操作结果',
    cznr: '操作内容',
    // bbh:'版本号',
    // bbmc:'版本名称',
    // bbxt:'版本系统',
    // gxtsy:'更新提示语',
    // sfqz:'是否强制',
    // bxy:'不需要',
    // xy:'需要',

    czsj: '操作时间',
    jsmc: '角色名称',
    ms: '描述',
    czysl: '操作员数量',
    cjsj: '创建时间',
    jsxx: '角色信息',
    qxxx: '权限信息',
    zs1: '请输入不超过50字数的角色名称',
    zs2: '请输入不超过50字数的描述',
    czyh: '操作员号',
    czyxm: '操作员姓名',
    czylx: '操作员类型',
    tlj: '铁路局',
    qsrtlj: '请输入铁路局',
    zm: '站名',
    qsrzm: '请输入站名',
    tjsj: '添加时间',
    mmcz: '密码重置',
    zhxx: '账号信息',
    ssj: '所属局',
    ssz: '所属站',
    zcyjs: '操作员角色',
    qtxx: '其他信息',
    sjh: '手机号',
    sfzhm: '身份证号码',

  },
  index: {
    jzxYz: '集装箱运转',
    zwhx: '站外还箱',
    sy: '首页',
    ysfw: '运输服务',
    smjy: '商贸交易',
    tsyjy: '投诉与建议',
    gjfw: '国际服务',
    tlxyd: '铁路箱预定',
    tlxydllys: '铁路箱预定-冷链运输',
    glydtx: '国联运单填写',
    rxqtx: '日需求填写',
    gjfw1: '为您提供“',
    gjfw2: '快速、可靠、稳定',
    gjfw3: '”的高品质、跨境铁路运输服务',
    gnfw: '”的高品质、老挝境内独家铁路运输服务。',
    zbxfh: '自备箱发货',
    zbxfhllys: '自备箱发货-冷链运输',
    gnfwt: '国内服务',
    lyfwp: '”的高品质、铁路冷链运输服务。',
    lyfwt: '冷运服务',
    title: '老中铁路国际物流平台',
    hello: '您好',
    grsz: '个人设置',
    yhxxwh: '用户信息维护',
    shxx: '收货信息',
    fhxx: '发货信息',
    hz_hdbd: '货主/货代绑定',
    jbrgl: '经办人管理',
    xgmm: '修改密码',
    tcdl: '退出登录',
    fsyw: '发送业务',
    gjly: '国际联运',
    gnys: '国内运输',
    yxqtb: '月需求提报',
    rxqtb: '日需求提报',
    glydtb: '国联运单填报',
    zx: '装箱',
    ddyw: '到达业务',
    yylx: '预约领货',
    yyhx: '预约还箱',
    hyfw: '货运服务',
    hwzz: '货物追踪',
    glhwzz: '国联货物追踪',
    gnhwzz: '国内货物追踪',
    ddyc: '到达预测',
    zxcxx: '装卸车信息',
    yfcx: '运费查询',
    hwlp: '货物理赔',
    blzn: '办理指南',
    baox: '保险',
    lxwm: '联系我们',
    tsjy: '投诉建议',
    myOrders: '我的订单',
    ddzx: '订单中心',
    yxqlb: '月需求列表',
    ydxlb: '预定箱列表',
    rxqlb: '日需求列表',
    glydlb: '国联运单列表',
    ydzf: '运单作废',
    czyxglyd: "存在有效状态的国联运单,不允许作废",
    hytj: '货运统计',
    jqsddcx: '接取送达单查询',
    jqsddcqr: '接取送达单签认',
    wdpj: '我的票据',
    yfkjymx: '预付款交易明细',
    pjqr: '票据确认',
    qrtczh: '确认退出当前账户吗?',
    tis: '提示?',
    qd: '确定',
    qx: '取消',

    ydh_xh: '运单号/箱号',
    qsrydh_xh: '请输入运单号/箱号',
    sjhm: '手机号码',
    yzm: '验证码',
    djhq: '点击获取',
    ljcx: '立即查询',
    wyfh: '我要发货',
    wylh: '我要领货',
    ywzd: '业务指导',
    czfw: '车站服务',
    xwzx: '新闻资讯',
    ckqb: '查看全部',
    tzgg: '通知公告',
    xxcxblzn: '信息查询及办理指南',
    qsryzm: '请输入验证码',
    appxz: 'App下载',
    fwcx: '服务查询',
    fwrx: '服务热线',
    wtfk: '问题反馈',
    yyxz: '语言选择',
    glydtbllys: '国联运单填报-冷链运输',
    cxfy: '查询费用',
    czxx: '车站信息',
    bllc: '办理流程'
  },
  oneClickDelivery: {
    tip255: '空箱',
    tip476: '重箱',
    tip260: '空重状态',
    qxzkhmc: '请选择客户名称',
    yjfh: '一键发货',
    apxs: '安排箱数',
    fh: '发货',
    kxxx: '空箱信息',
    bjzz: '标记总重(KG)',
    tpinfo: '以下内容必须与报关单上保持一致，请谨慎填写',
    ghhthm: '供货合同号码',
    fhrsm: '发货人声明',
    ycyrwgxx: '与承运人无关的信息',
    blhg: '办理海关和其他行政手续的记载',
    dpx: '待配箱',
    ypx: '已配箱',
    txw: '配箱完',
    lxtz: '领箱通知',
    jzyy: '进站预约',
    jzxydh: '集装箱预订号',
    lxlx: '领箱类型',
    xxx: '箱信息',
    tzsj: '通知时间',
    qyyjz: '去预约进站',
    yylx: '预约类型',
    yyjzrq: '预约进站日期',
    cheh: '撤回',
    ckjzm: '查看进站码',
    lx: '领箱',
    sx: '送箱',
    jzlx: '进站类型',
    jzrq: '进站日期',
    xzxqd: '选择需求单',
    jqsdfw: '接取送达服务',
    wlgs: '物流公司',
    qsdz: '取送地址',
    kch: '卡车号',
    siji: '司机',
    xzmdzshqkkchhsj: '当选择门到站时，会清空卡车号和司机内容,是否确认继续?',
    txrqddrq: '提箱日期/到达日期',
    qxzcz: '请选择车站',
    qwsjzyyxx: '请完善进站预约详细信息',
    jzm: '进站码',
    yxqx: '有效期限',
    lckm: '里程(km)',
    ysrqts: '如果已确定运输日期，请填写。',
    dxxx: '订箱信息',
    dxxxts: '请选择月需求后填写',
    kxxxts: '车站受理后显示',
    ysxxts: '请确定运输日期后填写',
    sfch: "是否撤回",
    bljd: "办理进度",
    yjzlkx: "已进站(领空箱)",
    yczlkx: "待进站(送重箱)",
    yjzszx: "已进站(送重箱)",
    yczszx: "已出站(送重箱)",
    yjzlzx: "已进站(领重箱)",
    yczlzx: "待进站(送空箱)",
    yjzskx: "已进站(送空箱)",
    yczskx: "已出站(送空箱)",
  },
  accept: {
    tbsj: '提报时间',
    qxz: '请选择',
    zt: '状态',
    dsl: '待受理',
    sltg: '受理通过',
    yzf: '已作废',
    cx: '查询',
    qk: '清空',
    tjjy: '提交建议',
    dsltsjy: '待受理投诉建议',
    t: '条',
    slsj: '受理时间',
    tszt: '投诉主题',
    tsnr: '投诉内容',
    fj: '附件',
    ck: '查看',
    tsz: '投诉站',
    tsrxm: '投诉人姓名',
    tsrsfzhm: '投诉人身份证号码',
    lxfs: '联系方式',
    yx: '邮箱',
    yb: '邮编',
    tsrdz: '投诉人地址',
    cz: '操作',
    slxq: '受理详情',
    sl: '受理',
    zf: '作废',
    slyj: '受理意见',
    qx: '取 消',
    qd: '确 定',
    qsrnr: '请输入内容',
    jdxq: '进度详情',
    sljg: '受理结果',
    czy: '操作员',
    fjlb: '附件列表',
    zxyl: '在线预览',
    xz: '下载',
    tsjy: '投诉建议',
    jbxx: '基本信息',
    tsxx: '投诉信息',
    scfj: '上传附件',
    jwjtdcc: '将文件拖到此处，或',
    djsc: '点击上传',
    tj: '提交',
    fh: '返回',

  },
  backlog: {
    fhf: '发货方',
    shf: '收货方',
    hydl: '欢迎登录',
    nscdlsjs: '您上次登录时间是',
    dbsx: '代办事项',
    zcsh: '注册审核',
    qyxxxgsh: '企业信息修改审核',
    jdxqsl: '阶段需求受理',
    rxqsl: '日需求受理',
    zcxhtsh: '中长协合同审核',
    lpsl: '理赔受理',
    tsjy: '投诉建议',
    ycktx: '预存款提现',
    ltgl: '论坛管理',
    zxhf: '最新回复',
    htzs: '话题总数',
    t: '条',
    xh: '序号',
    tbsj: '提报时间',
    xm: '姓名',
    sfzh: '身份证号',
    js: '角色',
    qymc: '企业名称',
    cz: '操作',
    sh: '审核',
    yhmc: '用户名称',
    jdxqh: '阶段需求号',
    hwpm: '货物品名',
    ds: '吨数',
    tyf: '托运方',
    sl: '受理',
    rxqtbsl: '日需求提报受理',
    xqdh: '需求单号',
    xqcs: '需求车数',
    fz: '发站',
    dz: '到站',
    ddbgsl: '到达变更受理',
    cc: '车次',
    clzt: '车辆状态',
    bgdz: '变更到站',
    bgshf: '变更收货方',
    hth: '合同号',
    tbqy: '提报企业',
    ydh: '运单号',
    ht: '话题',
    xq: '详情',
    ycktxsh: '预存款提现审核',
    txje: '提现金额(元)',

  },
  containerDelate: {
    crumbs0: '集装箱',
    crumbs1: '运单作废',
    xqdgl: '需求单管理',
    ydzfts: '铁路箱补填箱号后不可作废!请去退箱',
    ydhw: '运单号为',
    jdjhh: '阶段计划号',
    hyxhdsjbkzf: "铁路箱且有箱号的数据不允许作废",
    xgjdjh: "修改阶段计划",
    qxzxtydhsj: "请选择相同的预定号数据"
  },
  freightInfo: {
    zfrq: '支付日期',
    pjlx: '票据类型',
    zf: '杂费',
    yf: '运费',
    zt: '杂退',
    yt: '运退',
    zhuangt: '状态',
    yzf: '已支付',
    dzf: '待支付',
    zfzt: '支付状态',
    fkr: '付款人',
    zfsj: '支付时间',
    zhifu: '支付',
    tk: '退款',
    ytk: '已退款',
    plzf: '批量支付',
    fy: '费用',
    yck: '预存款',
    xj: '现金',
    bczf: '本次支付',
    yebz: '余额不足，请前往预存款管理界面充值！',

    hsxx: '核实信息',
    he: '核',
    jq: '接取',
    sd: '送达',
    nr: '内容',
    gxrq: '更新日期',
    qsrfplx: '请输入发票类型',
    xxxxrxdz: '详细信息如下,地址',
    qsrtlj: '请输入铁路局',
    wjlqywd: '为了建立企业档案，以及商贸交易平台企业展示，请详细填写企业简介',
    sczj: '上传证件',
    shtg: '审核通过',
    swdjdz: '税务登记地址',
    qygflj: '企业官方链接',
    sh: '审核',
    jymx: '交易明细',
    czje: '充值金额',
    ydbs: '运单笔数',
    ydfy: '运单费用',
    hzbs: '货杂笔数',
    hzfy: '货杂费用',
    tkbs: '退款笔数',
    tkfy: '退款费用',
    ckpz: '查看凭证',
    yfzf: '运费支付',
    tbr: '填报人',
    ptjl: '普通记录',
    fhjbr: '发货经办人',
    fhjbrdh: '发货经办人电话',
    xxxh: '箱型箱号',
    zj: '主键',
    dfrq: '到发日期',
    cljjd: '车辆交接单',
    glyd: '国联运单',
    cljjdh: '车辆交接单号',
    nf: '年份',
    gjzmc: '国境站名称',
    jfcyrmc: '交付承运人名称',
    jscyrmc: '接收承运人名称',
    zcs: '重车数',
    kcs: '空车数',
    hwjjdh: '货物交接单号',
    jjdmc: '交接站名称',
    lccc: '列车车次'

  },
  advancePayStation: {
    khmc: '客户名称',
    qsrkhmc: '请输入客户名称',
    yckye: '预存款余额',
    cz: '充值',
    tx: '提现',
    khxxsc: '客户信息删除',
    khmcxg: '客户名称修改',
    khxxbd: '客户信息绑定',
    jymx: '交易明细',
    jylx: '交易类型',
    qxzxqlx: '请选择需求类型',
    jysj: '交易时间',
    jyls: '交易流水',
    pjh: '票据号',
    dycz: '抵用车站',
    bz: '币种',
    je: '金额（元）',
    fh: '返回',
    bjpz: '编辑凭证',
    czje: '充值金额',
    qsrzcje: '请输入充值金额',
    qx: '取消',
    qd: '确定',
    xdkhmc: '新的客户名称',
    khbd: '客户绑定',
    txje: '提现金额',
    qsrtxje: '请输入提现金额',
    yckglyz: '预存款管理验证',
    qsrmm: '请输入密码',
    xgmm: '修改密码',
    qsrymm: '请输入原密码',
    qsrxmm: '请输入现密码',
    qzcsrxmm: '请再次输入现密码',
    jyxq: '交易详情',
    czmc: '车站名称',
    rq: '日期',
    ydbs: '运单笔数',
    ydfy: '运单费用',
    hzbs: '货杂笔数',
    hzfy: '货杂费用',
    tkbs: '退款笔数',
    tkfy: '退款费用',
    ckpz: '查看凭证',
  },
  login: {
    bgctext1: '跨国运输·货运全球',
    sjh: '手机号',
    wyydty: '我已阅读并同意',
    yhxy: '用户服务协议',
    he: '和',
    ysqtk: '隐私权条款',
    hmzh: '还没账号',
    ljzc: '立即注册',
    qnydty: '请您阅读并同意',
    xxts: '信息提示',
    xyhdwcyz: '向右滑动完成验证',

    title: '登 录',
    user: '用户名',
    pwd: '密码',
    code: '验证码',
    word1: '中老铁路',
    jzw: '记住我',
    wjmm: '忘记密码',
    word2: '概况',
    word3: '中老昆万铁路是国家”一带一路“面向南亚、东南亚建设基础设施互联互通的重要项目，第一个以中方为主投资建设并运营 与中国铁路网直接连通的境外铁路项目。全线采用中国技术标准，使用中国技术设备，使用中国设备。',
    text1T: '昆明至玉溪段(已运营）',
    text1: '正线全长88公里，双线电气化铁路，设计速度200kn/h。',
    text2T: '玉溪至磨憨段（玉磨段）',
    text2: '线路全长508.5公里，国铁级，160km/h电气化铁路。',
    text3T: '磨丁至万象段（磨万段）',
    text3: '线路全长414.516公里，单线电气化，自动站间闭塞，设计速度160km/h。',

    logintip1: '注册审核未通过，是否前往注册页修改信息',
    logintip2: '该账户已被冻结,请联系管理员',
    logintip3: '该账户已被锁定,请联系管理员',
    mmdl: '密码登录',
    dxdl: '短信登录',
    lztlhy: "老中铁路货运办理平台"

  },
  forgetPW: {
    wjmm: '忘记密码',
    sjqjh: '手机区间号',
    sjh: '手机号',
    sjyzm: '手机验证码',
    xzmm: '新置密码',
    qrmm: '确认密码',
    qxz: '请选择',
    qsr: '请输入',
    back: '返回',
    next: '下一步',
    qd: '确定',
    qsrmm: '请输入密码',
    qzcsrmm: '请再次输入密码',
    lcsrmmbyz: '两次输入密码不一致',
    qsrsjhm: '请输入手机号码',
    qxzsjqh: '请选择手机区号',
    qsrdxyzm: '请输入短信验证码',
    hcxhq: '后重新获取',
    hqyzm: '获取验证码',
    xgcg: '修改成功',
    qdl: '去登陆',
    qx: '取消',
    mmxgsb: '密码修改失败!',
  },
  dayDemandApply: {
    rxqtb: '日需求提报',
    qxzysfs: '请选择运输方式',
    jzx: '集装箱',
    zc: '整车',
  },
  containerPreOrder: {
    shzt: "审核状态",
    zti: '自提',
    crumbs0: '集装箱',
    crumbs1: '空箱预定',
    khxxt: '客',
    khxx: '客户信息',
    ssqy: '所属企业',
    select: '请选择',
    fhxxt: '发',
    fhxx: '发货信息',
    tyr: '托运人',
    fz: '发站',
    fj: '发局',
    zcdd: '装车地点',
    txz: '提箱站',
    txdz: '通信地址',
    jbr: '经办人',
    sfzh: '身份证号',
    jbrsj: '经办人手机',
    shxxt: '收',
    shxx: '收货信息',
    shr: '收货人',
    dz: '到站',
    zdz: '终到站',
    dj: '到局',
    xcdd: '卸车地点',
    bllx: '班列类型',
    blcc: '班列车次',
    dxxxt: '订',
    dxxx: '订箱信息',
    xl: '箱类',
    xlmx: '箱类明细',
    xx: '箱型',
    txrq: '提箱日期',
    sfyx: '是否有效',
    yx: "有效",
    wx: "无效",
    syxs: '剩余箱数',
    xs: '箱数',
    hwmc: '货物名称',
    ysxxt: '运',
    ysxx: '运输信息',
    zzjgcl: '装载加固材料',
    cc: '仓储',
    lc: '冷藏(保温)',
    bxys: '保险运输',
    jtxcd: '具体卸车点',
    jzsx: '记载事项',
    zfszt: '支',
    zfsz: '支付设置',
    zffs: '支付方式',
    yfk: '预付款',
    xj: '现金',
    zp: '支票',
    yhk: '银行卡',
    hzzf: '汇总支付',
    bzxz: '币种选择',
    jp: '基普',
    rmb: '人民币',
    my: '美元',
    kydje: '可预订金额',
    ldwlt: '两',
    ldwl: '两端物流',
    ldwlw: '可根据您的需求，选择录入发到站接取，送达，仓储等物流服务信息。',
    mdz: '门到站',
    zdm: '站到门',
    smqh: '上门取货',
    smsh: '上门送货',
    licheng: '里程(km)',
    qianmi: '千米',
    shdd: '送货地址',
    dianhua: '电话',
    lxrxm: '联系人姓名',
    xqsm: '需求说明',
    qhdd: '取货地址',
    tyrqdjs: '托运人确定件数',
    qhgsfy: '取货估算费用',
    tijiao: '提交',
    qink: '清空',
    qkxzy: '取空箱资源',
    //parents
    qsrxs: '请填入箱数',
    xsw: '箱数为',
    syxsw: '剩余箱数为',
    xsbjdysyxs: '箱数不可大于剩余箱数',
    ktxsbndy: '可提箱数不能大于',
    shxxts: '国际联运业务到站选择 “磨丁(境)”，终到站选择实际到站，例如"王家营西"',
    qsrfj: '请输入发局',
    qsrtxz: '请输入提箱站',
    qsrdj: '请输入到局',
    qsrxshu: '请输入箱数',
    qxzhwmc: '请选择货物名称',
    yjxmhjy: '运价项目号只能输入9位数字',
    khhjy: '开户行不能为空,并且不超过85汉字或170字符',
    nsdzjy: '纳税地址,不能为空且少于100汉字或200字符',
    qxzqsdz: '请选择起始地址',
    qtxqsdz: '请填写起始地址街道门牌号等详细地址',
    xxdzcd: '详细地址长度必须介于 8-200位字符 之间(一个汉字算两位字符)',
    qxzmddz: '请选择目的地址',
    qtxmddz: '请填写目的地址街道门牌号等详细地址',
    fsdlxrxm: '发送端联系人姓名不能为空',
    fsdhbnwk: '发送端电话不能为空！',
    qxzzffs: '请选择支付方式',
    qxzbz: '请选择币种',
    qtxjd: '请填写街道门牌号等详细地址',
    qtxmdz: '请填写门到站的里程信息！',
    mdzlcxx: '门到站的里程信息只能输入数字！',
    qtxmdztyr: '请填写门到站的托运人确定件数！',
    mdztyr: '门到站的托运人确定件数只能输入数字！',
    mdzqhfy: '门到站的取货费用估算只能输入数字！',
    dddlxr: '到达端联系人姓名不能为空',
    dddlxrcw: '到达端联系人姓名填写错误',
    ddddh: '到达端电话不能为空！',
    qtxzdm: '请填写站到门的里程信息!',
    zdmlcxx: '站到门的里程信息只能输入数字！',
    qxzyxsfzj: '请选择有效身份证件类型',
    qtxyxsfzj: '请填写有效身份证件号码',
    qtxtyrdm: '请填写托运人统一社会信用代码',
    qsrtydm: '请输入正确的统一信用代码',
    qxzdcrq: '请选择订车日期',
    qsrsjshr: '请输入实际收货人名称',
    qtxtyjbrxm: '请填写托运经办人姓名',
    qtxtyjbrsfz: '请填写托运经办人身份证号',
    qtxtyjbrsjh: '请填写托运经办人手机号',
    qtxshjbrxm: '请填写收货经办人姓名',
    qtxshjbrsfz: '请填写收货经办人身份证号',
    qtxshjbrsjh: '请填写收货经办人手机号',
    qsrxl: '请输入箱类',
    qsrxlmx: '请输入箱类明细',
    qsrxx: '请输入箱型',
    tyrthmmyz: '只能输入六位数字密码',
    qsrtyrmc: '请输入托运人名称',
    qtxtyrqdjs: '请填写托运人确定件数信息！',
    xxxsjy: '箱型是20英尺的话箱数必须是偶数！',
    fdzbuxt: '发到站不能是同一个站',
    qxzzfr: '请选择支付人',
    zfr: '支付人',
    qxxztyr: '请先选择托运人',
    yfkyebz: '预付款余额不足！',
    zfrid: '支付人ID不可为空',
    dzmdzdz: '到站是磨丁(境)时，请选择终到站',
    xhzzdy: '箱货总重需要大于承运人重量',
    shenher: '审核人',
    zt: '状态',
  },
  dailyTransportDemand: {
    qxzbgrxqhchec: '请选择需要进行到达变更的日需求或车次',
    dtslrxqbg: '请选择单条受理通过装车前的日需求到达变更',
    rxqbnbg: '待受理/已拒绝/已卸车/已交付状态的日需求不能进行到达变更',
    dslrxq: '请选择待受理状态的日需求',
    td1: '需求正在受理，暂不支持退订',
    td2: '请选择待受理状态的日需求进行退订',
    yqxtd: '已取消退订',
    yqx: "已取消",
    tdcg: '退订成功',
    sfqrtd: '是否确认退订？',
    yjf: '已交付',
    yxc: '已卸车',
    yzc: '已装车',
    tb: '提报',
    xqgj: '需求轨迹',
    t: '条',
    qsr: '请输入',
    qxzqsrq: '请选择起始日期',
    qxzzzrq: '请选择终止日期',
    qxz: '请选择',
    qb: '全部',
    zzjg: '装载加固',
    bx: '保险',
    cc: '仓储',
    gjly: '国际联运',
    ptys: '普通运输',
    ytd: '已退订',
    crumbs0: '运输服务',
    crumbs1: '日需求',
    ydlx: '运单类型',
    yyh: '预约号',
    xqh: '需求号',
    jzxydh: '集装箱预定号',
    fz: '发站',
    tyr: '托运人',
    zyrq: '装运日期',
    wpmc: '物品名称',
    shr: '收货人',
    tbsj: '提报时间',
    rxqzt: '日需求状态',
    dsl: '待受理',
    dddsl: '待调度受理',
    sltg: '受理通过',
    yjj: '已拒绝',
    cx: '查询',
    rxqxj: '日需求新建',
    wxts1: '温馨提示：已提交的日需求可根据条件查询',
    wxts2: '如需新建请点击日需求新建',
    qsryyh: '请输入预约号',
    qsrxqh: '请输入需求号',
    dcexcel: '导出excel',
    pldy: '批量打印',
    ck: '查看',
    ckxq: '查看详情',
    drzj: '当日总计',
    zt: '状态',
    yslx: '运输类型',
    blzb: '办理种别',
    qqlx: '请求类型',
    zcdd: '装车地点',
    xcdd: '卸车地点',
    hwmc: '货物名称',
    wptz: '物品特征',
    xqcs_slcs: '需求车数/受理车数',
    xqds_slds: '需求吨数/受理吨数',
    cz: '车种',
    ystz: '运输特征',
    jzsx: '记载事项',
    caozuo: '操作',
    dslyyd: '多式联运预定',
    yszyyd: '运输资源预定',
    td: '退订',
    zc: '整车',
    jzx: '集装箱',
    zq: '正请',
    bq: '补请',
    drgj: '当日总计',
    ksrq: '开始日期',
    jsrq: '结束日期',

    qsryxq: '请输入月需求号',
    qsrtyr: '请输入托运人',
    hztip: '若不填写货主，则货主将无法查询货物发送状态',
    qsrzmwjmc: '请输入证明文件名称',
    qsczmwjtp: '请上传证明文件图片',
    qsrddgj: '请输入到达国家',
    qsrkaz: '请输入口岸站',
    qsrshr: '请输入收货人',

  },
  dailyTransportDemandDetail: {
    gjz: '国境站',
    ddgj: '到达国家',
    ysfw: '运输服务',
    rysxq: '日运输需求',
    ysrq: '运输日期',
    yyh: '预约号',
    yslx: '运输类型',
    xqxx: '详情信息',
    hwxx: '货物信息',
    hwpm: '货物品名',
    hwtz: '货物特征',
    ysfs: '运输方式',
    fhxx: '发货信息',
    tyr: '托运人',
    fz: '发站',
    fj: '发局',
    txdz: '通讯地址',
    jbr: '经办人',
    zcdd: '装车地点',
    sj: '手机',
    shxx: '收货信息',
    shr: '收货人',
    dz: '到站',
    dj: '到局',
    xcdd: '卸车地点',
    jqsdxx: '接取送达信息',
    mdz: '门到站',
    zdm: '站到门',
    ysxx: '运输信息',
    xqds: '需求吨数',
    xqcs: '需求车数',
    cz: '车种',
    fw: '服务',
    jzsx: '记载事项',
    dzzfyhfzf: '到站杂费由何方支付',
    zffs: '支付方式',
    bz: '币种',
    yszyyd: '运输资源预定',
    w: '无',
    zzsxx: '增值税信息',
    fplx: '发票类型',
    spfmc: '受票方名称',
    nsrsbh: '纳税人识别号',
    zh: '账号',
    khh: '开户行',
    dh: '电话',
    diz: '地址',
    fh: '返回'
  },
  dailyTransportDemandDetailNew: {
    mz: '名字：',
    yjxqduns: '预计需求吨数',
    xqzjxqchec: '您本次需求总计为:需求车次:',
    qxzscsj: '请选择删除数据',
    hsds: '核实吨数',
    qsrbxje: '请输入保险金额',
    scfjgsbk: '上传附件格式包括上传附件格式包括：图片，PDF，word，excel，txt',
    zzwjsc: '资质文件上传',
    xxxxrx: '详细信息如下，地址',
    ksrq: '开始日期',
    jsrq: '结束日期',
    jdxqdb: '阶段需求代报',
    jdqxh: '阶段需求号',
    qsrjdxqh: '请输入阶段需求号',
    qsrhthyyxyxj: '输入合同号有以下优先级',
    qdzccxt: '1、签定中长协合同，可提高资源分配优先级；',
    qdsmjyht: '2、签订商贸交易合同，保证运输服务。',
    yddcx: '预订单查询',
    ysrq: '运输日期:',
    qxzzyrq: '请选择装运日期',
    xqlx: '需求类型',
    qxzxqlx: '请选择需求类型',
    gjly: '国际联运',
    ptys: '普通运输',
    excelImp: 'excel导入',
    xzmb: '下载模板',
    lsxqImp: '历史需求导入',
    impLsxq: '导入历史需求',
    drwj: '导入文件',
    send: '发',
    fhxx: '发货信息',
    cyfhr: '常用发货人',
    tyr: '托运人',
    qsrtyf: '请输入托运方',
    qsr: '请输入',
    fz: '发站',
    fj: '发局',
    dj: '到局',
    zcdd: '装车地点',
    zyx: '专用线',
    tlhc: '铁路货场',
    lxr: '联系人',
    qsrlxr: '请输入联系人',
    dh: '电话',
    qsrdh: '请输入电话',
    txdz: '通信地址',
    qsrtxdz: '请输入通信地址',
    jbr: '经办人',
    qsrjbr: '请输入经办人',
    sfz: '身份证',
    qsrsfz: '请输入身份证',
    sj: '手机',
    qsrsj: '请输入手机',
    zffs: '支付方式',
    collect: '收',
    shxx: '收货信息',
    cyshf: '常用收货方',
    ddgj: '到达国家',
    gjz: '国境站',
    qxzgjz: '请选择国境站',
    shr: '收货人',
    qsrshf: '请输入收货方',
    dz: '到站',
    xcdd: '卸车地点',
    goods: '货',
    hwxx: '货物信息',
    hwpm: '货物品名',
    qxzhwm: '请选择货物品名',
    hwtzfrl: '货物特征:发热量(kcal/kg)',
    ps: '怕湿',
    bps: '不怕湿',
    sdz: '散堆装',
    fsdz: '非散堆装',
    hwms: '货物描述',
    wpqd: '物品清单',
    qsrhwms: '请输入货物描述',
    jzzx: '集箱箱型:',
    qxzcx: '请选择车型',
    cx1: '20英尺35吨敞顶箱',
    cx2: '20英尺通用标准箱',
    cx3: '40英尺通用标准箱',
    cx4: '20英尺35吨通用箱',
    cx5: '45英尺35吨通用箱',
    hwbz: '货物包装',
    maxzl: '最大件重量(kg)',
    bz: '备注',
    qsrbz: '请输入备注',
    yszyyd: '运输资源预定',
    yszycz: '运输资源查找',
    lcId: '列车ID',
    sfzsfsj: '始发站/始发时间',
    zdzzdsj: '终到站/终到时间',
    ls: '历时',
    hours: '小时',
    min: '分钟',
    move: '运',
    ysxx: '运输信息',
    syds: '剩余吨数',
    sycs: '剩余车数',
    tbfs: '提报方式:',
    anc: '按车',
    anD: '按吨',
    zclc: '成组列车',
    xqcs: '需求车数',
    qsrxqcs: '请输入需求车数',
    ds: '吨数',
    qsrds: '请输入吨数',
    cz: '车种',
    qsrcz: '请选择车型',
    peng: '棚',
    chang: '敞',
    ping: '平',
    guan: '罐',
    jzx: '集装箱',
    liangshi: '粮食',
    cs: '车数',
    sqrcs: '请输入车数',
    zzjg: '装载加固',
    bx: '保险',
    cc: '仓储',
    bxje: '保险金额',
    sqrbxje: '请输入保险金额',
    zyrq: '装运日期',
    cx: '车型',
    dzzfyhzf: '到站杂费由何方支付',
    yfk: '预付款',
    xj: '现金',
    mtype: '币种',
    jp: '基普',
    rmb: '人民币',
    my: '美元',
    jzsxxz: '记载事项须知',
    jzsx: '记载事项',
    qsrjzsx: '请输入记载事项',
    duo: '多',
    dsly: '多式联运',
    qxzlylb: '请选择联运类别',
    tsly: '铁水联运',
    ggndxqxzgyly: '根据您的需求，选择多式联运',
    ssjd: '所属基地',
    qxzssjd: '请选择所属基地',
    fglb: '发港列表',
    qxzfglb: '请选择发港列表',
    dglb: '到港列表',
    qxzdglb: '请选择到港列表',
    cm: '船名',
    cbdw: '船舶吨位',
    cblx: '船舶类型',
    fg: '发港',
    dg: '到港',
    hxlx: '航线类型',
    yj: '运价',
    zyqzrq: '装运起止日期',
    zzsxx: '增值税信息',
    zen: '增',
    fplx: '发票类型',
    qxzfplx: '请选择发票类型',
    ptfp: '普通发票',
    zyfp: '专用发票',
    spfmc: '受票方名称',
    qsrspfmc: '请输入受票方名称',
    khh: '开户行',
    qsrkhhmc: '请输入开户行名称',
    nsrsbh: '纳税人识别号',
    qsrnsrsbh: '请输入纳税人识别号',
    khhzh: '账号',
    qsrkhhzh: '请输入开户行账号',
    zcdz: '注册地址',
    qsrzcdiz: '请输入注册地址',
    lxdh: '联系电话',
    qsrlxdh: '请输入联系电话',
    jie: '接',
    jqsdxx: '接取送达信息',
    mdz: '门到站',
    cyjqxx: '常用接取信息',
    address: '地址',
    qxzsheng: '请选择省',
    qsrsheng: '请输入省',
    qxzshi: '请选择市',
    qsrshi: '请输入市',
    qxzq: '请选择区',
    qsrq: '请输入区',
    qsrxxdz: '请输入详细地址',
    lc: '里程',
    smzc: '上门装车',
    smxc: '上门卸车',
    xqsm: '需求说明',
    tyrqdjs: '托运人确定件数',
    qhfygs: '取货费用估算',
    zdm: '站到门',
    cysdxx: '常用送达信息',
    fyss: '运费试算',
    bc: '保存',
    qk: '清空',
    glyjyf: '公里，预计运费',
    yysjydwz: '以实际运单为准',
    dtbxx: '待提报信息',
    xqh: '需求号',
    yyh: '预约号',
    hwmc: '货物名称',
    wptz: '物品特征',
    xqcs_slcs: '需求车数/受理车数',
    xqds_slds: '需求吨数/受理吨数',
    ystz: '运输特征',
    hqhw: '货区货位',
    tbrq: '提报时间',
    xqly: '需求来源',
    qt: '其他',
    xg: '修改',
    sc: '删除',
    ckxq: '查看详情',
    tj: '提交',
    dc: '导出',
    plsc: '批量删除',
    fh: '返回',
    ydd: '预订单',
    jdxqh: '阶段需求号',
    chax: '查询',
    yslx: '运输类型',
    zhi: '至',
    wccs: '完成车数',
    tbsj: '提报时间',
    operation: '操作',
    sl: '受理',
    cyjqdz: '常用接取地址',
    sheng: '省',
    shi: '市',
    qu: '区',
    cysddz: '常用送达地址',
    lxrdh: '联系人电话',
    yddh: '移动电话',
    jbrsfz: '经办人身份证',
    jbrsjhm: '经办人手机号码',
    zzl: '总重量',
    hlbj: '浩勒报吉',
    zwsj: '暂无数据',
    pyyyrdhwxx: '派有押运人的货物，注明押运人的姓名和证明文件名称及号码',
    hg: '货柜',
    wxpl: '危险品类',
    wxxhwystyrzzzh: '危险货物运输托运人资质证号，经办人身份证号码、培训合格证号',
    wxz: '万象站',
    mdj: '磨丁(境)',
    tbrxq: '提报日需求',
    rxqsltg: '日需求受理通过',
    rxqyzc: '日需求已装车',
    rxqyfc: '日需求已发车',
    rxqzt: '日需求在途',
    rqxydd: '日需求已到达',
    rxqyxc: '日需求已卸车',
    rxqyjf: '日需求已交付',
    rxqyjj: '日需求已拒绝',
    rxqytd: '日需求已退订',
    yfc: '已发车',
    ydz: '已到达',
    qsrhscs: '请输入核实车数',
    qsrhsyy: '请输入核实原因',
    qsrhsds: '请输入核实吨数',
    qxzjzxx: '请选择集箱箱型',
    ghsjgsbzq: '固话或者手机号格式不正确',
    qsryhm: '请输入用户名',
    qyzyhm: '请验证用户名',
    qxzysrq: '请选择运输日期',
    qxzhwpm: '请选择货物品名',
    qxz: '请选择',
    qsrcs: '请输入车数',
    xqcsbw0: '需求车数不能为0',
    xqdsbmcg9999: '需求吨数不能超过9999',
    qsrbjje: '请输入保价金额',
    qxzfz: '请选择发站',
    qsrzcdd: '请输入装车地点',
    qsrzcddszjy: '请输入2-400位装车地点',
    qsrzqsfzhm: '请输入15或18位身份证号码',
    qsrdhhm: '请输入电话号码',
    qxzdz: '请选择到站',
    qsrxcdd: '请输入卸车地点',
    qsrxcddszjy: '请输入2-400位卸车地点',
    qsrtyrqdjs: '请输入托运人确定件数',
    qsrqhfygs: '请输入取货费用估算',
    qsrsjhm: '请输入手机号码',
    qsrlc: '请输入里程',
    qsrxqsm: '请输入需求说明',
    qsrmc: '请输入名字',
    qsrkhh: '请输入开户行',
    qsrzh: '请输入账号',
    qsrdz: '请输入地址',
    lj: '鲁济',
    d6700: '6700吨',
    buxian: '不限',
    cj_nh: '长江-内河',
    jztlslymtcpjd: '荆州铁水联运煤炭储配基地',
    bjhhyxgs: '北京航海有限公司',
    tjg_shg: '天津港-上海港',
    day1: '1天',
    gzhhyxgs: '广州航海有限公司',
    acad: '按车按吨',
    qxzrxq: '请选择日需求',
    qxzsrzy: '请选择运输资源',
    qdsfsc: '此操作将永久删除该数据, 是否继续?',
    ts: '提示',
    qd: '确定',
    qx: '取消',
    sccg: '删除成功',
    yqxsc: '已取消删除',
    qxztjxqsq: '请选择待提交需求删除',
    tqcg: '提交成功',
    qxztjqqjxtj: '请选择待提交需求进行提交',
    qdjzxmktb: '请到集装箱模块提报',
    czcg: '操作成功',
    czsb: '操作失败',
    wxts: '温馨提示',
    sctpjy1: '上传图片大小不能超过2MB',
    sctpjy2: '该文件已存在',
    sctpjy3: '上传文件总共不能超过20M',
    sctpjy4: '当前限制选择3个文件，本次选择了',
    sctpjy5: ' 个文件，共选择了 ',
    sctpjy6: '个文件',
    qnqdtbxxtj: '请您去待提报信息提交！',
    drcg: '导入成功',
    rxq: '日需求',
    dtblbzdyz: '待提报列表最多保存20条数据，请对现有数据做处理后再进行提报',
    xgcg: '修改成功',
    xjcg: '新建成功',
    xqlx_gjly_ptys: '需求类型 0-国际联运 1-普通运输',
    qsrtbrxx: '请输入提报人信息。',
    qyzyhxx: '请验证用户信息',
    fzxxyz1: '默认发站非本站，请重新填写发站信息',
    fzxxyz2: '默认发站非本局管辖之内，请重新填写发站信息',
    dbxqyz1: '提示，只能代报发站为本站的需求',
    dbxqyz2: '提示，只能代报发站属于所属局的需求',
    dbxqyz3: '输入吨数不能大于此阶段需求的剩余吨数',
    dbxqyz4: '输入车数不能大于此阶段需求的剩余车数',
    qxzfzzd: '请选择发站站点',
    zyydyz1: '资源预定发到站站点不能相同',
    qxzdzzd: '请选择到站站点',
    zyydyz2: '没有找到运输资源',
    qxzscnr: '请选择删除内容',
    yhxxyz1: '用户信息不正确，请核对无误后再行代报',
    yhxxyz2: '请核对用户信息无误后进行合同导入',
    yhxxyz3: '请核对用户信息无误后进行历史需求导入',
    hscs: '核实车数',
    hsyy: '核实原因',
    yfss: '运费试算',
    ty: '同意',
    jj: '拒绝',

    ybtrxq: '已提报日需求',
    fhr: '发货人',
    kydcs: '可预订车数',
  },
  dailyTransportDemandDetailRes: {
    crumbs0: '运输服务',
    crumbs1: '日需求',
    crumbs2: '日需求新建结果'
  },
  multimodalTransport: {
    yxfhrq: '已选：发货日期：',
    crumbs0: '运输服务',
    crumbs1: '日需求',
    crumbs2: '多式联运预定',
    crumbs3: '我的需求单列表',
    qxz: '请选择',
    fhrq: '发货日期',
    fz: '发站',
    dz: '到站',
    hwpm: '货物品名',
    zzl: '总重量',
    tyr: '托运人',
    shr: '收货人',
    yyh: '预约号',
    xqh: '需求号',
    lylb: '联运类别:',
    thly: '铁水联运',
    ssjd: '所属基地:',
    fg: '发港:',
    dg: '到港:',
    cx: '查询',
    yd: '已定',
    lx: '类型',
    cc: '车次',
    yjfhsj: '预计出发时间',
    yjddsj: '预计到达时间',
    ls: '历时',
    sfz_sfsj: '始发站/始发时间',
    zdz_zdsj: '终到站/终到时间',
    cz: '车种',
    bc: '保存',
    zx: '站序',
    zm: '站名',
    dzsj: '到站时间',
    czsj: '出站时间',
    tlsj: '停留时间',
    dtjlylb: '待提交联运列表',
    tj: '提交',
    xg: '修改',
    sc: '删除',
    fh: '返回',
  },
  arriveChangeInput: {
    crumbs0: '运输服务',
    crumbs1: '日运输需求',
    crumbs2: '详情信息',
    xqdh: '需求单号',
    cc: '车次',
    huo: '货',
    hwxx: '货物信息',
    hwpm: '货物品名',
    hwtz: '货物特征',
    frl: '发热量',
    bz: '备注',
    yun: '运',
    ysxx: '运输信息',
    ds: '吨数',
    fw: '服务',
    zzjgcl: '装载加固材料',
    bjys: '保价运输',
    cangchu: '仓储',
    wu: '无',
    jzsx: '记载事项',
    cx: '车型',
    cs: '车数',
    fa: '发',
    fhxx: '发货信息',
    tyr: '托运人',
    fz: '发站',
    zcdd: '装车地点',
    lxdh: '联系电话',
    txdz: '通信地址',
    jbr: '经办人',
    jbrdh: '经办人电话',
    jbrsfz: '经办人身份证',
    jbrxm: '',
    jbrsfzh: '',
    sfz: '身份证',
    sj: '手机',
    bian: '变',
    bgxx: '变更信息',
    cyshr: '常用收货人',
    shr: '收货人',
    ysfw: '运输服务',
    dz: '到站',
    qsrdz: '请输入到站',
    xcdd: '卸车地点',
    tj: '提交',
    fh: '返回',
    cyshxx: '常用收货信息'
  },
  dailygoodsOrder: {
    crumbs0: '货物运单',
    lztlyxgs: '老钟铁路有限公司',
    hwydlc: '货物运单（列车）',
    xqh: '需求号',
    zyrq: '装运日期',
    tuo: '托',
    yun: '运',
    fan: '方',
    fz: '发站',
    zcd: '装车点',
    name: '名称',
    address: '地址',
    hwyd: '货物运单',
    dh: '电话',
    jbrxm: '经办人姓名',
    sfz: '身份证',
    sj: '手机',
    shou: '收',
    huo: '货',
    dz: '到站',
    xcd: '卸车点',
    hwpm: '货物品名',
    hwtz: '货物特征',
    frl: '发热量',
    ps: '怕湿',
    bps: '不怕湿',
    sdz: '散堆装',
    fsdz: '非散堆装',
    beiz: '备注',
    ysfw: '运输服务',
    zzdjcl: '装载加固材料',
    bjys: '保价运输',
    cangchu: '仓储',
    tyfjzsx: '托运方记载事项',
    zzsfplx: '增值税发票类型',
    ptfp: '普通发票',
    zyfp: '专用发票',
    spfmc: '受票方名称',
    nsrsbh: '纳税人识别号',
    khhjzh: '开户行及账号',
    fyhej: '费用合计（元）',
    chec: '车次',
    cs: '车数',
    ds: '吨数',
    ydmx: '运单明细',
    ydh: '运单号',
    cx: '车型',
    ch: '车号',
    bz: '标重',
    zz: '载重',
    lc: '里程',
    zfy: '总费用（元）',
    fymx: '费用明细',
    fh: '返回'
  },
  workbench: {
    crumbs0: '运输服务',
    crumbs1: '我的工作台',
    dbsx: '待办事项',
    xq: '需求',
    rxq: '日需求',
    jdxq: '阶段需求',
    sm: '商贸',
    gdyd: '挂单应单',
    dxjy: '定向交易',
    jmjm: '竞买竞卖',
    hetong: '合同',
    smht: '商贸合同',
    xx: '消息',
    zyxx: '重要消息',
    jhxx: '交互消息',
    wdlyb: '我的留言板',
    zxhf: '最新回复',
    yfbht: '已发布话题',
    tjfx: '统计分析',
    ntj: '年统计',
    ytj: '月统计',
    dyzj: '当月总计',
    xqcs: '需求车数',
    yscs: '运输车数',
    xqdxl: '需求兑现率',
    nzj: '年总计',
    wfqd_cjl: '我发起的-成交量',
    wcyd_cjl: '我参与的-成交量',
    yzj: '月总计',
    cjl: '成交量(吨)',
    cje: '成交额(元)',
    wfqd: '我发起的',
    wcyd: '我参与的',
    qdgs: '签订个数',
    zds: '总吨数(吨)',
    zhte: '总合同额(元)',
    ysht: '运输合同',
    zzl: '总重量(吨)',
    tiao: '条',
    dtb: '待提报',
    dzf: '待支付',
    sm_gdyd: '商贸-挂单应单',
    dfb: '待发布',
    dsl: '待受理',
    sm_dxjy: '商贸-定向交易',
    dqr: '待确认',
    sm_jmjm: '商贸-竞买竞卖',
    ht_smht: '合同-商贸合同',
    dqrsh: '待确认收货',
    lyb_zxhf: '留言板-最新回复'
  },
  transportDetil: {
    crumbs0: '运输服务',
    crumbs1: '浩吉铁路是国家《中长期铁路网规划》项目、国家铁路投融资体制改革示范项目，也是国家“北煤南运”战略新通道。铁路途经蒙、陕、晋、豫、鄂、湘、赣七省区，全线正线长1814公里。规划运输能力为2亿吨/年以上，计划投资概算1700亿元，是我国规模庞大的运煤专线和“北煤南运”新的国家战略运输通道，是衔接京沪、京九、京广、焦枝等多条铁路运输线和沿海、长江和京杭运河水路运输线的集疏线路，也是一次性建成的世界上最长的重载铁路。',
    ysfaxz: '运输方案选择',
    jdxqtb: '阶段需求提报',
    rxqtb: '日需求提报',
    hwzz: '货物追踪',
    xqtb: '需求提报',
    xqtb_text: '可分为阶段运输需求提报和日运输需求提报运输需求提报是客户根据自身运输需求提报运输计划即日运输需求。需求提报以后，客户可以查询到每一笔需求当前所在状态。',
    jdxqtb_text: '阶段需求提报是提报次月的煤炭运输需求，提报的阶段需求可直接转化为日需求进行运输。',
    rxqtb_text: '日需求提报是提报指定日期的煤炭运输需求，当日12点之前提报的日需求可以在当日18:00至次日18:00之间发货。在这个过程中可进行运输资源的预定和多式联运的选择。',
    yszyyd: '运输资源预订',
    yszyyd_text: '运输资源预定是浩吉铁路货运采取的一种高效、安全、环保的运输模式。通过定时、定点、定线、定价、定车次，统一服务标准、统一协调平台、强化机制和装备保障的原则，努力提升浩吉铁路运输资源的运行品质，确保按图正点运行。最终为客户打通物流瓶颈，降低物流成本，获得理想效益。与传统铁路运输相比,浩吉铁路运输资源具备以下优势： （1）服务保障---远程实现独特的优先权利：享有优先配车、优先装车、优先挂车、优先放行、优先卸车的优势；（2）运行保障---远程实现网络化跟踪查询：享有装车过程中不准停装、未到满载不准限装、铁道分界口不准拒接、运行中途不准停留、运行途中不准解体的优势；（3）运行速度快---浩吉铁路运输资源按图正点运行，高效便捷，尽可能为客户节省成本',
    ds: '定时',
    sjgd: '时间固定',
    dd: '定点',
    zchxczdgd: '装车和卸车站点固定',
    dx: '定线',
    qcysxlgd: '全程运输线路固定',
    dj: '定价',
    ysjggd: '运输价格固定',
    dcc: '定车次',
    ccgd: '车次固定',
    gslyxz: '多式联运选择',
    gslyxz_text: '多式联运是浩吉铁路在铁路运输服务充分提升的基础上，清晰掌握上下游企业供需情况和水运运输等信息，结合煤炭运输实际数据提供铁水联运方案选择运输方式。客户可根据船运企业在多式联运平台发布的船源信息并结合自身需求选择船源、航线进行日提需求提报。提报完成后，客户可在货物追踪中查询铁水联运的物流信息。',
    hwzz_text: '运输需求提报以后，由浩吉铁路生产平台进行调度、配车装运。货物运输途中，客户可以查询货物在途信息，包括货物所在位置、途经各站的报告信息以及预计到达时间。客户可以根据运输情况提前做好计划以便领货。'
  },
  workbenchInfo: {
    crumbs0: '运输服务',
    crumbs1: '我的工作台',
    crumbs2: '消息',
    xxlz: '消息类型:',
    zyxl: '重要消息',
    jhxx: '交互消息',
    xlly: '消息来源:',
    zt: '状态:',
    wd: '未读',
    yd: '已读',
    xqdh: '需求单号:',
    qsrxqdh: '请输入需求单号',
    shjyh: '商贸交易号:',
    qsrsmjyh: '请输入商贸交易号',
    tsksrq: '推送开始日期:',
    xzrq: '选择日期',
    tsjsrq: '推送结束日期:',
    cx: '查询',
    qk: '清空',
    qd: '确定',
    bjyd: '标记已读',
    sc: '删除',
    fh: '返回'
  },
  LoadUnloadVehicleInfo: {
    crumbs0: '运输服务',
    crumbs1: '装卸车信息',
    zcxx: '装车信息',
    xqdh: '需求单号',
    qsr: '请输入',
    fz: '发站',
    dz: '到站',
    zcrq: '装车日期',
    zhi: '至',
    ksrq: '开始日期',
    jsrq: '结束日期',
    zcrqzndekzrq: '装车日期指您的开装日期',
    zcz: '装车中',
    ywc: '已完成',
    cx: '查询',
    dc: '导出',
    qxz: '请选择',
    xcxx: '卸车信息',
    xcrq: '卸车日期',
    xcrqzndekxrq: '卸车日期指您的开卸日期',
    xcz: '卸车中',
    zt: '状态',
    kzsj: '开装时间',
    zwsj: '装完时间',
    hs: '耗时',
    hwpm: '货物品名',
    fz_dz: '发站-到站',
    tyr: '托运人',
    sgf: '收货方',
    jbr_jbrdh: '经办人/经办人电话',
    zckb: '装车看板',
    gj: '共计',
    che: '车',
    yz: '已装：',
    ch: '车号',
    jssj: '结束时间',
    kxsj: '开卸时间',
    xwsj: '卸完时间',
    xckb: '卸车看板',
    yx: '已卸'
  },
  cargoTracking: {
    crumbs0: '运输服务',
    crumbs1: '货物追踪',
    xqdh: '需求单号',
    qsrxqdh: '请输入需求单号',
    cx: '查询',
    fhyhlb: '返回运货列表',
    shi: '始',
    zong: '终',
    xh: '序号',
    cz: '车站',
    dzsj: '到站时间',
    czsj: '出站时间'
  },
  leagueOfNationsWaybill: {
    nwdsl: "内网待受理",
    qscjjddh: '请生成交接单单号',
    sfzfctyd: '是否作废此条运单?',
    tjqfsfcg: '提交启封实封成功',
    tjqfsfsb: '提交启封实封失败',
    qsrnrhqd: '请输入内容后确定',
    yxs: '已显示',
    qzsj: '起止时间',
    scjjddh: '生成交接单号',
    jzx1: '集装箱1',
    jzx2: '集装箱2',
    crumbs0: '运输服务',
    crumbs1: '国联运输',
    crumbs2: '国联运输查询',
    ph: '批号',
    yyh: '预约号',
    gjydh: '国联运单号',
    fz: '发站',
    qsrfz: '请输入发站',
    fhr: '发货人',
    qsrfhf: '请输入发货方',
    tbrq: '提报日期',
    ksrq: '开始日期',
    jsrq: '结束日期',
    zdz: '终到站',
    dz: '到站',
    qsrzdz: '请输入终到站',
    shr: '收货人',
    qsrshf: '请输入收货方',
    ch: '车号',
    xh: '箱号',
    ydzt: '运单状态',
    bllb: '办理类别',
    qxz: '请选择',
    cx: '查询',
    qk: '清空',
    xqxj: '需求新建',

    qx: '全选',
    zt: '状态',

    jgcx: '交付撤销',
    glydh: '国联运单号',
    zc: '整车',
    jzx: '集装箱',
    fhrmc: '发货人名称',
    fzzm: '发站站名',
    shrmc: '收货人名称',
    gjz: '国境站',
    tbsj: '提报时间',
    fhrtxdz: '发货人通信地址',
    shrtxdz: '收货人通信地址',
    bcqd: '补充清单（物品）',
    xz: '新增',
    ck: '查看',
    swjl: '商务记录',
    clqd: '车辆清单',
    ckxq: '查看详情',
    hwjjd: '货物交接单',
    jzxqd: '集装箱清单',
    sfbg: '是否变更',
    cz: '操作',
    bgdz: '变更到站',
    xzjcsdqfjl: '行政检查时的启封记录',
    ydzb: '运单正本',
    gshr: '给收货人',
    gxshrjfhwdcyr: '给向收货人交付货物的承运人',
    qb: '全部',
    d1l: '第一联',
    d2l: '第二联',
    d3l: '第三联',
    d4l: '第四联',
    d5l: '第五联',
    d6l: '第六联',
    dy: '打印',
    bc: '保存',
    zf: '作废',
    fh: '返回',
    tj: '提交',
    sc: '删除',
    qxiao: '取消',
    qr: '确认',
    qd: '确定',
    hwysbgyqs: '货物运输变更要求书',
    bgyqr: '变更要求人',
    yz: '印章',
    jbrsfzxx: '经办人身份信息',
    ddmlh: '调度命令号',
    khtj: '客户填记',
    bgsx: '变更事项',
    xdz: '新到站',
    xshr: '新收货人',
    yhwydjzsx: '原货物运单记载事项',
    ydhm: '运单号码',
    tyr: '托运人',
    blzb: '办理种别',
    czch: '车种车号',
    hwmc: '货物名称',
    js: '件数',
    zl: '重量',
    cyrq: '承运日期',
    bgyy: '变更原因',
    cyrtj: '承运人填记',
    jzsx: '记载事项',
    ydz: '原到站',
    yshr: '原收货人',
    wslyy: '未受理原因',
    bgclz: '变更处理站',
    jbr: '经办人',
    bgxxtx: '变更信息填写',
    xuh: '序号',
    wpmc: '物品名称',
    bz: '包装',
    tiji: '体积',
    jg: '价格',
    beizhu: '备注',
    congzhi: '重置',
    cyrjz: '承运人记载',
    qsr: '请输入',
    dsl: '待受理',
    ysl: '已受理',
    yzc: '已装车',
    yfc: '已发车',
    ydd: '已到达',
    yxc: '已卸车',
    yjf: '已交付',
    lkzf: '落空(作废)',
    zccx: '装车撤销',
    jfcx: '交付撤销',
    qxzcx: '请选择车型',
    hsds: '核实吨数',
    cyr: '承运人',
    wwdtj: '待提交',
    wwdsl: '待受理',
    luok: '落空',
    shjj: '审核拒绝',
    qxzdtjzt: '请选择“待提交”状态的国联运单进行提交',
    yxqh: '月需求号',
    cxcg: '查询成功',
    xhbky: '箱号不可用',
    jzxbtx: '请填写内容后点击确定，除‘承运人记载’项外都为必填项',
    zstxyt: '最少填写一条集装箱信息',
    jzxxhcx: '输入箱号不在本批次箱号信息中，是否清空列表后重新填写？',
    bltjyz: '已提交的国联运单不可再次提交。',
    sfhycz: '施封号不可以重复',
  },
  LNWayBillAdd: {
    yqctts: '当前国联运单对应的日需求已超出提出时间范围，请在修改国联运单之后选择新的运输日期并提交', // 允许重提标志提示
    fkjs: "付款记事:",
    dyil: "第一联",
    derl: "第二联",
    dsanl: "第三联",
    dsil: "第四联",
    dwul: "第五联",
    dliul: "第六联",
    qztitle: '提交之后会自动为您签名，请您确认',
    qxtxdygjzx: '请先填写第一个集装箱',
    ccaozjyjscsj: '此操作将永久删除数据',
    zdxqytsj: '最多选取一条数据',
    qsrhwmz: '请输入货物毛重',
    qsrjzxxh: '请输入集装箱箱号',
    bcz: '保存中...',
    qsrmbmc: '请输入模板名称',
    qzssrygziz: '请至少输入一个自重',
    qzssrygzaizl: '请至少输入一个载重量',
    qtxygjzxxh: '请填写一个集装箱箱号',
    qlryghwxx: '请录入一个货物信息',
    qzssrygchelxxhm: '请至少输入一个车辆信息号码',
    qsrdzmc: '请输入到站名称',
    qxzddl: '请选择到达路',
    qsrfzmc: '请输入发站名称',
    sfscbtshuj: '是否删除本条数据？',
    crumbs0: '运输服务',
    crumbs1: '国联运输',
    crumbs2: '国联运输新建',
    fh: '返回',
    yyh: '预约号',
    wdrxq: '我的日需求',
    bllb: '办理类别',
    jzx: '集装箱',
    zc: '整车',
    bgdz: '变更到站',
    ydzb: '运单正本',
    gshr: '给收货人',
    wdmb: '我的模板',
    ts1: '提示：长时间离开页面之前请保存填写内容，以防信息丢失。',
    bcwmb: '保存为模板',
    mbmc: '模板名称',
    bzjs: '标准记事',
    qxz: '请选择',
    qsr: '请输入',
    dtbxx: '待提报信息',
    quanx: '全选',
    zt: '状态',
    qr: '确认',
    qd: '确定',
    dsl: '待受理',
    ysl: '已受理',
    yzc: '已装车',
    yfc: '已发车',
    ydd: '已到达',
    yxc: '已卸车',
    yjf: '已交付',
    lkzf: '落空(作废)',
    zccx: '装车撤销',
    jgcx: '交付撤销',
    glydh: '国联运单号',
    xh: '箱号',
    hwzl: '货物重量',
    sfjh: '施封记号',
    fhrmc: '发货人名称',
    fzzm: '发站站名',
    xcdd: '卸车地点',
    shrmc: '收货人名称',
    gjz: '国境站',
    tbsj: '提报时间',
    cz: '操作',
    xg: '修改',
    tj: '提交',
    plsc: '批量删除',
    scmb: '删除模板',
    xzfhrdz: '选择发货人地址',
    xzfhr: '选择发货人',
    qsrfhrmc: '请输入发货人名称',
    cx: '查询',
    szdq: '所在地区',
    zg: '中国',
    lw: '老挝',
    jdmc: '街道名称',
    dh: '电话',
    yx: '邮箱',
    mail: '邮箱',
    sh: '使用',
    bj: '编辑',
    sc: '删除',
    xz: ' 新增',
    qxzshrdz: '选择收货人地址',
    xzshrdz: '新增收货人地址',
    qsrshrmc: '请输入收货人名称',
    xinzfhrdz: '新增发货人地址',
    xzyz: '选择语种',
    qxzyz: '请选择语种',
    gmswxtsbm: '公民税务系统识别码',
    qsrgmswxtsbm: '请输入公民税务系统识别码',
    qxzszqy: '请选择所在地区',
    xxdz: '详细地址',
    qsrgmxxdz: '请输入公民详细地址',
    csqh: '城市区号',
    qsrcsqh: ' 请输入城市区号',
    qsrdh: '请输入电话',
    chuanz: '传真',
    qsrcz: '请输入传真',
    qsryx: '请输入邮箱',
    ts2: '以上信息若不按要求填写，在通关时有可能造成积压。',
    bc: '保存',
    qx: '取消',
    xinzshrdz: '新增收货人地址',
    bgxxtx: '变更信息填写',
    ydz: '原到站',
    yshr: '原收货人',
    ddmlh: '调度命令号',
    bgyqr: '变更要求人',
    xshr: '新收货人',
    xdz: '新到站',
    bgyy: '变更原因',
    xzhwxx: '新增货物信息',
    xqdh: '需求单号',
    xh1: '箱号1',
    xh2: '箱号2',
    jzxxh: '集装箱型号',
    jzxzz: '集装箱自重(公斤)',
    bjzz: ' 标记总重(公斤)',
    bxje: '保险金额',
    sffbhsl: '施封/篷布号数量',
    sffbhjh: '施封/篷布号记号',
    xnhw: '箱内货物',
    zwmc: '中文名称',
    qsrhwmc: '请输入货物名称',
    zghgbm: '中国海关编码(HSCODE) ',
    wwmc: '外文名称',
    tyhwpmbm: '通用货物品名编码',
    tyyjhwtjbm: '统一运价货物统计编码（ET）',
    ptp: '普通品',
    wxp: '危险品',
    wxhwbm: '危险货物编码（ET）',
    bz: '备注',
    bzlx: '包装类型',
    bzmc: '包装名称',
    bzdm: '包装代码',
    js: '件数',
    dz: '堆装',
    sz: '散装',
    gz: '罐装',
    hwzzl: '货物总重量',
    ysyj: '运送用具',
    ysyjmc: '运送用具名称',
    ysyjsl: '运送用具数量',
    ysyjzl: '运送用具重量(公斤)',
    ysyjsm: '运输用具说明',
    rxqh: '日需求号',
    ysrq: '运输日期',
    blzb: '办理种别',
    tyf: ' 托运方',
    shf: '收货方',
    fz: '发站',
    daoz: '到站',
    hwpm: '货物品名',
    xqcs_slcs: '需求车数/受理车数',
    xqds_slds: '需求吨数/受理吨数',
    bjfhrdz: '编辑发货人地址',
    xzjck: '选择进出口',
    qxzjck: ' 请选择进出口',
    ck: ' 出口',
    jk: ' 进口',
    qtxzqdxh: '请填写正确的箱号',
    sfsl: '施封数量',
    hwmz: '货物毛重(kg)',
    zzh: '总重(kg)',
    xzjzxxx: '新增集装箱信息',
    bjjzxxx: '编辑集装箱信息',
    fhrqz: '发货人签章',
    czqz: '车站签章',
    zjxsz: "增加箱数至",
    cczjscytxsj: '此操作将删除已填写的数据,是否确认继续',
    zengjia: '增加',
    zdkzjzxh: '已超出最大箱数范围',
    zjxsxdydqxs: "增加至箱数需大于当前箱数"
  },
  phaseTransportDemand: {
    crumbs0: '运输服务',
    crumbs1: '阶段需求',
    crumbs2: '月需求',
    jdxqh: '阶段需求号',
    qsrjdxqh: '请输入阶段需求号',
    hwpm: '货物品名',
    qsr: '请输入',
    ysrq: '运输日期',
    qxzqsrq: '请选择起始日期',
    qxzzzrq: '请选择终止日期',
    fz: '发站',
    tyr: '托运人',
    qsrtyf: '请输入托运人',
    tbsj: '提报时间',
    dz: '到站',
    shr: '收货人',
    qsrshf: '请输入收货方',
    ydlx: '运单类型',
    qb: '全部',
    gjly: '国际联运',
    ptys: '普通运输',
    zt: '状态',
    dsl: '待受理',
    sltg: '受理通过',
    btg: '不通过',
    yzf: '已作废',
    chax: '查询',
    jdxqxj: '阶段需求新建',
    ts1: '温馨提示：已提交的月需求可根据条件查询',
    dcexcel: '导出excel',
    pldy: '批量打印',
    dyzj: '当月总计：',
    tiao: '条',
    yslx: '运输类型',
    blzb: '办理种别',
    zhenc: '整车',
    jzx: '集装箱',
    slh: '受理号',
    zhi: '至',
    zcdd: '装车地点',
    xcdd: '卸车地点',
    xqcs_wccs: '需求车数/完成车数',
    xqds_slds: '需求吨数/受理吨数',
    chez: '车种',
    cz: '操作',
    ckxq: '查看详情',
    xg: '修改',

    yxqh: '月需求号',
    jbr_lxdh: '经办人/联系电话',
    xqxs_wcxs: '需求箱数/完成箱数',
    xx_xl: '箱型/箱类',
    xs: '箱属',
    td: '退订',
    tdyy: '退订原因',
    jzxyd: '集装箱运单',
    xyb: '下一步',
    rxqtb: '日需求填报',
    pltj: '批量提交',
    bytb: '本月提报',
    byysxq: '本月运输需求',
  },
  phaseTransportDemandNew: {
    jdxqtb: '阶段需求提报的吨数范围是10万吨至50万吨',
    xqdsbnw0: '需求吨数不能为0',
    crumbs0: '运输服务',
    crumbs1: '阶段需求',
    crumbs2: '需求新建',
    jie: '阶',
    jdxqlx: '阶段需求类型',
    xqlx: '需求类型',
    qxzxqlx: '请选择需求类型',
    gjly: '国际联运',
    ptys: '普通运输',
    ysyf: '运输月份',
    qxzyf: '请选择月份',
    tjrq: '提交日期',
    ysrq: '运输日期',
    ksrq: '开始日期',
    jsrq: '结束日期',
    tis: '提示：请于本月20号以前提报下月需求',
    huo: '货',
    hwxx: '货物信息',
    hwpm: '货物品名',
    qxzhwpm: '请选择货物品名',
    hwpmtis: '没有这个货物品名',
    blzb: '办理种别',
    zhenc: '整车',
    jzx: '集装箱',
    pashi: '怕湿',
    bupashi: '不怕湿',
    sdz: '散堆装',
    fsdz: '非散堆装',
    hwbz: '货物包装',
    qsr: '请输入',
    qxz: '请选择',
    zdjzl: '最大件重量(kg)',
    jxxx: '集箱箱型',
    qxzcx: '请选择车型',
    jxxx1: '20英尺通用标准箱',
    jxxx2: '20英尺干散货箱',
    jxxx3: '20英尺液体罐',
    jxxx4: '20英尺水泥罐',
    jxxx5: '20英尺石油沥青罐',
    jxxx6: '20英尺35吨通用箱',
    jxxx7: '20英尺35吨敞顶箱',
    jxxx8: '20英尺35吨干散箱',
    jxxx9: '20英尺35吨液体罐',
    jxxx10: '20英尺35吨隔热箱',
    jxxx11: '20英尺35吨锂电池冷藏箱',
    jxxx12: '20英尺35吨台架式卷钢箱',
    jxxx13: '20英尺其他标准箱',
    jxxx14: '20英尺其他非标箱',
    jxxx15: '40英尺通用标准箱',
    jxxx16: '40英尺柴电式冷藏箱',
    jxxx17: '40英尺供电式冷藏箱',
    jxxx18: '40英尺发电箱',
    jxxx19: '40英尺35吨通用箱',
    jxxx20: '40英尺35吨隔热箱',
    jxxx21: '40英尺35吨锂电池冷藏箱',
    jxxx22: '40英尺其他标准箱',
    jxxx23: '40英尺其他非标箱',
    jxxx24: '45英尺通用标准箱',
    jxxx25: '45英尺柴电式冷藏箱',
    jxxx26: '45英尺35吨通用箱',
    jxxx27: '45英尺35吨锂电池冷藏箱',
    jxxx28: '45英尺其他标准箱',
    jxxx29: '45英尺其他非标箱',
    yun: '运',
    ysxx: '运输信息',
    dunshu: '吨数',
    qsrdunshu: '请输入吨数',
    chez: '车种',
    ches: '车数',
    chests: '请输入吨数，请选择车型',
    chuk: '出口',
    zzjgcl: '装载加固材料',
    gnbx: '国内保险',
    cangchu: '仓储',
    bjys: '保价运输',
    jzsx: '记载事项',
    qsrjzsx: '请输入记载事项',
    tbfs: '提报方式',
    anche: '按车',
    andun: '按吨',
    fa: '发',
    fhxx: '发货信息',
    cyfhxx: '常用发货信息',
    tyr: '托运人',
    faz: '发站',
    jbr: '经办人',
    qsrfz: '请输入发站',
    faju: '发局',
    zcdd: '装车地点',
    zyx: '专用线',
    tlhc: '铁路货场',
    lxdh: '联系电话',
    qsrfhrdh: '请输入发货人电话',
    txdz: '通信地址',
    qsrfhrdz: '请输入发货人地址',
    shou: '收',
    shxx: '收货信息',
    cyshxx: '常用收货信息',
    ddgj: '到达国家',
    gjz: '国境站',
    qxzgjz: '请选择国境站',
    shr: '收货人',
    daoz: '到站',
    qsrdz: '请输入到站',
    xcdd: '卸车地点',
    qsrtxdz: '请输入通信地址',
    zzsxx: '增值税信息',
    zeng: '增',
    fplx: '发票类型',
    qxzfplx: '请选择发票类型',
    ptfp: '普通发票',
    zyfp: '专用发票',
    spfmc: '受票方名称',
    qsrspfmc: '请输入受票方名称',
    khh: '开户行',
    qsrkhhmc: '请输入开户行名称',
    nsrsbh: '纳税人识别号',
    qsrnsrsbh: '请输入纳税人识别号',
    zhanhao: '账号',
    qsrzhhzh: '请输入开户行账号',
    dizhi: '地址',
    qsrzcdz: '请输入注册地址',
    dianhua: '电话',
    qsrlxdh: '请输入联系电话',
    bc: '保存',
    qk: '清空',
    dtbxx: '待提报信息',
    yyh: '预约号',
    qzrq: '起止日期',
    zhi: '至',
    hwtz: '货物特征',
    tbds: '提报吨数',
    tbcs: '提报车数',
    bxys: '保险运输',
    mdj: '磨丁(境)',
    dz_xcdd: '到站/卸车地点',
    lxdh_txdz: '联系电话/通信地址',
    fz_zcdd: '发站/装车地点',
    zzs: '增值税',
    cz: '操作',
    xg: '修改',
    sc: '删除',
    qlsc: '批量删除',
    fh: '返回',
    tj: '提交',
    daochu: '导出',
    lsxq: '历史需求',
    cyfhr: '常用发货人',
    cyshr: '常用收货人',
    qxzchez: '请选择车种',
    qxzksrq: '请选择开始日期',
    qxzjsrq: '请选择结束日期',

    ybtyxq: '已提报月需求',
    ljck: '立即查看',
    jbrzjh: '经办人证件号',
    qhdz: '取货地址',
    zcdz: '装车地址',
    xiangs: '箱数',
    hwjz_mx: '货物价值（每箱）',
    hwjz_mc: '货物价值（每车）',
    qt: '其他',
    bggs: '报关公司',
    cfl: '出发路',
    ddl: '到达路',
  },
  phaseTransportDemandResult: {
    crumbs0: '运输服务',
    crumbs1: '阶段需求',
    crumbs2: '需求新建结果'
  },
  phaseTransportDemandDetail: {
    crumbs0: '运输服务',
    crumbs1: '阶段需求',
    crumbs2: '详情信息',
    ysrq: '运输日期',
    zhi: '至',
    hwxx: '货物信息',
    hwpm: '货物品名',
    hwtz: '货物特征',
    frl: '发热量(kcal/kg)',
    hwms: '货物描述',
    jxxx: '集箱箱型',
    ysfs: '运输方式',
    zhenc: '整车',
    jzx: '集装箱',
    beiz: '备注',
    ysxx: '运输信息',
    dunshu: '吨数',
    chex: '车型',
    ches: '车数',
    fuw: '服务',
    zzjgcl: '装载加固材料',
    bjys: '保价运输',
    cangchu: '仓储',
    wu: '无',
    jzsx: '记载事项',
    fhxx: '发货信息',
    tyr: '托运人',
    faz: '发站',
    faju: '发局',
    zcdd: '装车地点',
    lxdh: '联系电话',
    txdz: '通信地址',
    shxx: '收货信息',
    ddgj: '到达国家',
    jwz: '境外站',
    daoz: '到站',
    shr: '收货人',
    xcdd: '卸车地点',
    zzsxx: '增值税信息',
    fplx: '发票类型',
    spfmc: '受票方名称',
    nsrsbh: '纳税人识别号',
    zhangh: '账号',
    khh: '开户行',
    dianh: '电话',
    dizhi: '地址',
    fh: '返回',
  },
  phaseDemandInfoSupple: {
    crumbs0: '运输服务',
    crumbs1: '阶段需求',
    crumbs2: '阶段需求修改',
    xqlx: '需求类型',
    qxzxqlx: '请选择需求类型',
    gjly: '国际联运',
    ptys: '普通运输',
    ysyf: '运输月份',
    qxzyf: '请选择月份',
    tjrq: '提交日期',
    ysrq: '运输日期',
    ksrq: '开始日期',
    jsrq: '结束日期',
    tis: '提示：请于本月15号以前提报国联运单',
    huo: '货',
    hwxx: '货物信息',
    hwpm: '货物品名',
    qxzhwpm: '请选择货物品名',
    hwts: '没有这个货物品名',
    blzb: '办理种别',
    qxz: '请选择',
    zhenc: '整车',
    jzx: '集装箱',
    pashi: '怕湿',
    bups: '不怕湿',
    sdz: '散堆装',
    fsdz: '非散堆装',
    hwbz: '货物包装',
    qsr: '请输入',
    zdjzl: '最大件重量(kg)',
    jxxx: '集箱箱型',
    qxzcx: '请选择车型',
    jxxx1: '20英尺通用标准箱',
    jxxx2: '20英尺干散货箱',
    jxxx3: '20英尺液体罐',
    jxxx4: '20英尺水泥罐',
    jxxx5: '20英尺石油沥青罐',
    jxxx6: '20英尺35吨通用箱',
    jxxx7: '20英尺35吨敞顶箱',
    jxxx8: '20英尺35吨干散箱',
    jxxx9: '20英尺35吨液体罐',
    jxxx10: '20英尺35吨隔热箱',
    jxxx11: '20英尺35吨锂电池冷藏箱',
    jxxx12: '20英尺35吨台架式卷钢箱',
    jxxx13: '20英尺其他标准箱',
    jxxx14: '20英尺其他非标箱',
    jxxx15: '40英尺通用标准箱',
    jxxx16: '40英尺柴电式冷藏箱',
    jxxx17: '40英尺供电式冷藏箱',
    jxxx18: '40英尺发电箱',
    jxxx19: '40英尺35吨通用箱',
    jxxx20: '40英尺35吨隔热箱',
    jxxx21: '40英尺35吨锂电池冷藏箱',
    jxxx22: '40英尺其他标准箱',
    jxxx23: '40英尺其他非标箱',
    jxxx24: '45英尺通用标准箱',
    jxxx25: '45英尺柴电式冷藏箱',
    jxxx26: '45英尺35吨通用箱',
    jxxx27: '45英尺35吨锂电池冷藏箱',
    jxxx28: '45英尺其他标准箱',
    jxxx29: '45英尺其他非标箱',
    yun: '运',
    ysxx: '运输信息',
    dunshu: '吨数',
    qsrds: '请输入吨数',
    chez: '车种',
    ches: '车数',
    chests: '请输入吨数，请选择车型',
    chuk: '出口',
    zzjgcl: '装载加固材料',
    gnbx: '国内保险',
    gjys: '保价运输',
    cangchu: '仓储',
    jzsx: '记载事项',
    qsrjzsx: '请输入记载事项',
    tbfs: '提报方式',
    anche: '按车',
    andun: '按吨',
    fa: '发',
    fhxx: '发货信息',
    cyfhxx: '常用发货信息',
    tyr: '托运人',
    faz: '发站',
    qsrfz: '请输入发站',
    faj: '发局',
    zcdd: '装车地点',
    zyx: '专用线',
    tlhc: '铁路货场',
    lxdh: '联系电话',
    qsrfhrdh: '请输入发货人电话',
    txdz: '通信地址',
    qsrtxdz: '请输入通信地址',
    shou: '收',
    shxx: '收货信息',
    cyshxx: '常用收货信息',
    ddgj: '到达国家',
    gjz: '国境站',
    qxzgjz: '请选择国境站',
    shr: '收货人',
    daoz: '到站',
    qsrdz: '请输入到站',
    xcdd: '卸车地点',
    zeng: '增',
    zzsxx: '增值税信息',
    fplx: '发票类型',
    qxzfplx: '请选择发票类型',
    ptfp: '普通发票',
    zyfp: '专用发票',
    spfmc: '受票方名称',
    qsrspfmc: '请输入受票方名称',
    khh: '开户行',
    qsrkhhmc: '请输入开户行名称',
    nsrsbh: '纳税人识别号',
    qsrnsrsbh: '请输入纳税人识别号',
    zhanh: '账号',
    qsrkhhzh: '请输入开户行账号',
    dizhi: '地址',
    qsrzcdd: '请输入注册地址',
    dianh: '电话',
    qsrlxrdh: '请输入联系电话',
    fanhui: '返回',
    tijiao: '提交',
    cyfhr: '常用发货人',
    cyshr: '常用收货人'
  },
  wayBillInfo: {
    jlsxsb: ' 记录事项失败',
    jlsxcg: ' 记录事项成功',
    yyhbyz: '预约号不一致!',
    bgxqbyz: '变更需求不一致!',
    bgsb: ' 变更失败',
    bgcg: ' 变更成功',
    crumbs0: '运输服务',
    crumbs1: '运单管理',
    hph: '货票号',
    qsr: '请输入',
    xqh: '需求号',
    hwmc: '货物名称',
    zcrq: '装车日期',
    ksrq: '开始日期',
    jsrq: '结束日期',
    tyr: '托运人',
    qsrshf: '请输入收货方',
    faz: '发站',
    tbrq: '提报日期',
    shf: '收货人',
    shr: '收货人',
    daoz: '到站',
    ztai: '状态',
    dsl: '待受理',
    sltc: '受理通过',
    yzc: '已装车',
    yfc: '已发车',
    ydd: '已到达',
    yxc: '已卸车',
    yjf: '已交付',
    chax: '查询',
    qink: '清空',
    ydzt: '运单状态',
    xqdh: '需求单号',
    cheh: '车号',
    chengz: '成组',
    fou: '否',
    hwpm: '货物品名',
    hqhw: '货区货位',
    yunf: '运费',
    zaf: '杂费',
    xcrq: '卸车日期',
    jfrq: '交付日期',
    hwyd: '货物运单',
    hwzz: '货物追踪',
    gjck: '轨迹查看',
    sfbg: '是否变更',
    ybg: '已变更',
    bgdz: '变更到站',
    pldyyd: '批量打印运单',
    back: '返回',
    huoq: '货区',
    huow: '货位',
    tbsx: '事项填报',
    hwdcsj: '货物到场时间',
    qued: '确定',
    chak: '查看',
    ydaoz: '原到站',
    yshr: '原收货人',
    bgxxtx: '变更信息填写',
    ddmlh: '调度命令号',
    bgyqr: '变更要求人',
    xshr: '新收货人',
    xdaoz: '新到站',
    bgyy: '变更原因',
    sctp: '上传图片',
    hwysbgqqs: '货物运输变更要求书',
    zhangy: '印章',
    jbrsfxx: '经办人身份信息',
    khtj: '客户填记',
    bgsx: '变更事项',
    yhwydjzsx: '原货物运单记载事项',
    ydhm: '运单号码',
    blzb: '办理种别',
    czch: '车种车号',
    jianshu: '件数',
    zhongliang: '重量',
    cyrq: '承运日期',
    cyrtj: '承运人填记',
    jzsx: '记载事项',
    wslyy: '未受理原因',
    bgclz: '变更处理站',
    jbr: '经办人',
    chez: '车站',
    dzsj: '到站时间',
    czsj: '出站时间',
    xxxl: '箱型箱类',
  },
  myboard: {
    crumbs0: '运输服务',
    crumbs1: '我的工作台',
    crumbs2: '我的留言板',
    htzs: '话题总数',
    htlx: '话题类型',
    qxzhtlx: '请选择话题类型',
    mtgj: '煤炭供给',
    mtxq: '煤炭需求',
    wuliu: '物流',
    qit: '其它',
    sous: '搜索',
    xjht: '新建话题',
    huati: '话题',
    qsrht: '请输入话题',
    htnr: '话题内容',
    qsrhtnr: '请输入话题内容',
    fjlb: '附件列表',
    scfj: '上传附件',
    jwjcdcc: '将文件拖到此处，或',
    djsc: '点击上传',
    qx: '取消',
    fabu: '发布',
    huifu: '回复',
    gkl: '观看量',
    tshu: '10条/页'
  },
  msgboardetail: {
    crumbs0: '运输服务',
    crumbs1: '留言板',
    crumbs2: '留言板详情',
    huif: '回复',
    shanchu: '删除',
    louzhu: '楼主',
    xiazai: '下载',
    gkl: '观看量',
    tshu: '10条/页',
    qygw: '企业官网',
    sqhf: '收起回复',
    oneLou: '1楼',
    qsrhfnr: '请输入回复内容',
    fabu: '发布',
    ckgd: '查看更多',
    tiao_ye: '条/页',
    fbhf: '发布回复',
    scfj: '上传附件',
    jwjcdcc: '将文件拖到此处，或',
    djsc: '点击上传',
    xght: '相关话题'
  },
  msgboard: {
    crumbs0: '运输服务',
    crumbs1: '留言板',
    htlx: '话题类型',
    qxzhtlx: '请选择话题类型',
    mtgj: '煤炭供给',
    mtxq: '煤炭需求',
    wuliu: '物流',
    qita: '其它',
    quanbu: '全部',
    qsrgjcss: '请输入关键词搜索',
    sousuo: '搜索',
    xjht: '新建话题',
    huati: '话题',
    qsrht: '请输入话题',
    htnr: '话题内容',
    qsrhtnr: '请输入话题内容',
    fjlb: '附件列表',
    scfj: '上传附件',
    jwjcdcc: '将文件拖到此处，或',
    djsc: '点击上传',
    quxiao: '取消',
    fabu: '发布',
    zuixin: '最新',
    remen: '热门',
    whf: '未回复',
    htzs: '话题总数',
    huif: '回复',
    gkl: '观看量',
    tiaoshu: '10条/页'
  },
  complaintsSuggestions: {
    tjsb: '提交失败',
    tjcgcx: '提交成功，请在历史投诉建议中进行查询！',
    dqxzsc20: '上传文件总大小大于20M，请检查后重新上传',
    dqxzsc5: '当前限制上传 5 个文件',
    tsjy: '投诉建议',
    lstsjycx: '历史投诉建议查询',
    tsz: '投诉站',
    zt: '状态:',
    cx: '查询',
    fh: '返回',
    zxyl: '在线预览',
    xz: '下载',
    qxz: '请选择',
    scsj: '上传时间',
    fjlx: '附件类型',
    wjmc: '文件名称',
    cz: '操作',
    fjlb: '附件列表',
    sljg: '受理结果',
    tsrxm: '投诉人姓名',
    lxfs: '联系方式',
    yx: '邮箱',
    yb: '邮编',
    tsrsfzh: '投诉人身份证号',
    tssj: '投诉时间',
    fj: '附件',
    tsrdz: '投诉人地址',
    tszt: '投诉主题',
    tsnr: '投诉内容',
    scfj: '上传附件',
    tj: '提交',
    qk: '清空',
    jbxx: '基本信息',
    tsxx: '投诉信息'
  },
  cargoService: {
    hxsj: '还箱时间',
    ddh: '订单号',
    dlr: '代理人',
    ddyw: '到达业务',
    yylx: '预约领货',
    xcsj: '卸车时间',
    plyy: '批量预约',
    lhsj: '领货时间',
    qxzlhsj: '请选择领货时间',
    lhm: '领货码',
    sclhm: '生成领货码',
    qdjsclhm: '请点击生成领货码',
    sclhmm: '生成6位领货密码',
    fhdwdh: '发货单位电话',
    czjwfm: '本时段车站较为繁忙',
    qggyysj: '车站过于繁忙请更改预约时间',
    qxzytsj: '请选择至少选择一条数据进行操作',
    yyhx: '预约还箱',
    hxz: '还箱站',
    jcmdh: '进出门单号',
    qxnts: '期限内天数',
    lhrq: '领货日期',
    hxm: '还箱码',
    schxm: '生成还箱码',
    qdjschxm: '请点击生成还箱码',
    schxmm: '生成6位还箱密码',
    sysl: '使用数量',
    fzzxf: '发站装卸费',
    bxf: '保险费',
    jzxsyf: '集装箱使用费',
    jcfyhj: '基础费用合计',
    bzzdys: '备注（最大运输吨数与体积）',
    hwlp: '货物理赔',
    tpjd: '提赔进度',
    lpxqh: '理赔需求号',
    hsxs: '货损箱数',
    fqlp: '发起理赔',
    pllp: '批量理赔',
    slcz: '受理车站',
    ssxh: '受损箱号',
    ssxs: '受损箱数',
    hwssqk: '货物损失情况',
    yqpcje: '要求赔偿金额',
    slz: '受理站',
    czslyj: '车站受理意见',
    czslr: '车站受理人',
    czslsj: '车站受理时间',
    lpsqs: '理赔申请书',
    swjldc: '商务记录导出',
    hyjldc: '货运记录导出',
    wanc: '完成',
    lpsq: '理赔申请',
    qxzzsyt: '请选择至少一条记录',
    qxzzsyt1: "请选择至少一条待提交记录",
    hwjz: '货物价值',
    mxbxje: '（每箱货物的保险金额）',
    jdxqxzts: "请选择发运日期所在月份的月需求，如果当月月底提箱，发运日期在下个月初，则需选择下个月的月需求，若选错会造成无法提出日需求",
    qfh: '去发货',
    sfszbx: '是否是自备箱',
    hwzlkg: '货物重量（kg）',
    dxzdzz: '单箱最大载重（吨）',
    sscs: '受损车数',
    ssch: '受损车号',
    hwlpxq: '货物理赔详情',
    hyjllb: '货运记录列表',
    swjllb: '商务记录列表',
    yyjl: '预约记录',
    qxzhxsj: '请选择还箱时间',
    qsrch: '请输入车号',
    qsrssxh: '请输入受损箱数',
    qsrhwssqk: '请输入货物损失情况',
    qscfj: '请上传附件',
    lhmtx: '请保存好，领货时使用',
    qxzxtshr: '请选择相同的收货人',
    znqxzxtshr: '只能选择相同的收货人，请先选择一条',
  },
  myOrders: {
    dqye: '当前余额',
    kyye: '可用余额',
    cjje: '迟交金额',
    djye: '冻结金额',
    fylx: '费用类型',
    jyje: '交易金额',
    pzh: '凭证号',
    range7d: '最近7天',
    range10d: '最近10天',
    range30d: '最近30天',
    periodfirst: '上旬',
    periodsecond: '中旬',
    periodthird: '下旬',
    zxje: '最小金额',
    zdje: '最大金额',
    yzn: '选择年',
    jylsh: '交易流水号',
    loading: '拼命加载中',
  },
  processMap: {
    crumbs0: '办理指南',
    crumbs1: '业务办理流程',
    crumbs2: '车辆信息',
    czjbxx: '车站基本信息',
    jzxxx: '集装箱信息',
    yjfl: '运价费率',
    yunf: '运费',
    zaf: '杂费',
    flfgjxgwj: '法律法规及相关文件',
    tbxz: '投保须知',
    bxtk: '保险条款',
    hyblwt: '货运办理问题',
    fhlc: '发货流程',
    lhlc: '领货流程',
    sfych: '是否有叉车',
    fwdh: '服务电话',
    yysj: '营业时间',
    xzpl: '限制品类',
    dz: '地址',
    qtyq: '其他要求',
    zfzl: '最大载重(t)',
    hc: '换长',
    rj: '容积（m³）',
    zht: '自重(t)',
    fb: '费别',
    fblx: '费别类型',
    tdjb: '梯度级别',
    fjbd: '附加变动',
    wjm: '文件名',
    fbdw: '发布单位',
    wt: '问题',
    xwzx: '新闻咨询',
    xwbt: '新闻标题',
    xwxq: '新闻详情',
    ggbt: '公告标题',
    ggxq: '公告详情',
    meiyou: '无',
    you: '有',
    yjlx: '运价类型',
    bzyj: '标准运价',
    tzyj: '调整运价',
    tfmx: '梯度明细',
    tdks: '梯度开始',
    tddj: '梯度等级',
    tdjs: '梯度结束',
    sfatdjs: '是否按梯度计算',
    jfgz: '计费规则',
    tddw: '梯度单位',
    bzqh: '币种切换',
    wtd: '无梯度',
    wtxqym: '问题详情页面',
    zwxz: '正文下载',
    fjxz: '附件下载',
    bjzzt: '标记载重（t）',
    nbcc: '内部尺寸(长×宽×高)（mm）',
    wbcc: '外部尺寸(长×宽×高)（mm）',
    qtcz: '其他车种',
    cncc: '车内（长×宽×高）（mm）',
    ctcz: '车体材质',
    zxjzxj: '转向架中心距（mm）',
    dmzgmgd: '地面至轨面高度（mm）',
    kczxgd: '空车重心高度（mm）',
    cmcc: '车门尺寸（宽×高）（mm）',
    gtcc: '罐体尺寸（长×直径）（mm）',
    ytu: '用途',
    ted: '特点',
    syss: '商业速度（km/h）',
    clzdkg: '车辆最大（宽×高）（mm）',
    mianj: '面积（m²）',
  },
  settings: {
    ysmm: '原始密码',
    xz: '新增',
    dxdz: '短信定制',
    dzqz: '电子签章USBKEY',
    xgfhxx: '修改发货信息',
    cpxqxxxg: '产品需求信息修改',
    qyzcmc: '企业注册名称',
    jbrsj: '经办人手机',
    cpgyxx: '产品供应信息',
    kcwd: '库存(万吨)',
    xzmm: '新置密码',
    ql: '全硫(%)',
    cpxqxxxj: '产品需求信息新建',
    yx: '邮箱',
    lxdh: '联系电话',
    xgshxx: '修改收货信息',
    qy: '企业logo',
    hff: '挥发分(%)',
    txdz: '通信地址',
    zh: '账号',
    qxz: '请选择',
    jgyd: '价格(元/吨)',
    qsrnr: '请输入内容',
    qygwlj: '企业官网链接',
    jbr: '经办人',
    cmqy: '产煤企业',
    fbsj: '发布时间',
    jg: '价格',
    mtlx: '煤炭类型',
    scxgzj: '上传相关证件:',
    sfzhm: '身份证号码',
    js: '角色',
    tyfmc: '托运方名称',
    sc: '删除',
    zcdd: '装车地点',
    sj: '手机',
    qyjj: '企业简介',
    qsrmm: '请输入密码',
    kyts: '可用天数',
    ck: '查看',
    xgdsly: '修改多式联运',
    jbrsfz: '经办人身份证',
    qyyx: '企业邮箱',
    ggsx: '规格属性',
    spfmc: '受票方名称',
    tj: '提交',
    cz: '操作',
    qsrshf: '请输入收货方',
    tp: '图片',
    qylx: '企业类型',
    shfmc: '收货方名称',
    dh: '电话',
    xjdsly: '新建多式联运',
    hskmx: '哈式可磨性',
    khxmc: '开户行名称',
    qsf: '全水分(%)',
    cptp: '产品图片',
    qydz: '企业地址',
    qymc: '企业名称',
    mhrrx: '煤灰熔融性(℃)',
    ccbc: '车次/班次',
    qsr: '请输入',
    xcdd: '卸车地点',
    zgjqzxsdhlw: '最高精确至小数点后两位',
    dz: '地址',
    qydh: '企业电话',
    gdthl: '固定碳含量(%)',
    yhjbxx: '用户基本信息',
    grsz: '个人设置',
    fzfg: '发站/发港',
    nsrsbh: '纳税人识别号',
    shj: '审核局',
    qrmm: '确认密码',
    yxzh: '银行账号',
    qyxcz: '企业宣传照',
    dzdg: '到站/到港',
    rhwd: '日耗(万吨)',
    khx: '开户行',
    mmxg: '密码修改',
    fsxx: '发收信息',
    ssqy: '所属企业',
    fh: '返回',
    kgdsd: '可供吨数(吨)',
    qyjbxx: '企业基本信息',
    cpgxxx: '产品供需信息',
    fz: '发站',
    xjshxx: '新建收货信息',
    kgds: '可供吨数',
    qsrdxyzm: '请输入短信验证码',
    hmqy: '耗煤企业',
    yhmc: '用户名称',
    dxyzm: '短信验证码',
    cpgyxxxj: '产品供应信息新建',
    fplx: '发票类型',
    xg: '修改',
    xh: '序号',
    lylb: '联运类别',
    xj: '新建',
    cpxqxx: '产品需求信息',
    xm: '姓名',
    zjxm: "证件姓名",
    xgmm: '修改密码',
    gysj: '供应时间',
    xzrq: '选择日期',
    hf: '灰分(%)',
    xjfhxx: '新建发货信息',
    yyzz: '营业执照',
    zzjgdmz: '组织机构代码证',
    swdjz: '税务登记证',
    zzsxx: '增值税信息',
    message: '您的申请已提交，请耐心等待审批！',
    cyfhxx: '常用发货信息',
    xjcg: '新建成功',
    xgcg: '修改成功',
    cyshxx: '常用收货信息',
    cydsly: '常用多式联运',
    mm: '密码',
    hwggsx: '货物规格属性',
    sctp: '上传图片',
    cpgyxxxg: '产品供应信息修改',
    z: '至',
    yh: '用户',
    xx: '信息',
    sfzzmz: '身份证正面照',
    sfzbmz: '身份证背面照',
    qy1: '企业',
    jbxx: '基本信息',
    xyb: '下一步',
    fhdz: '发货地址',
    shouq: '收起',
    gduo: '更多',
    tiaoj: '条件',
    shdz: '收货地址',
    qtxxm: '请填写姓名',
    guoj: '国籍',
    qxzgj: '请选择国籍',
    hzhm: '护照号码',
    sfzyxq: '身份证有效期',
    hzyxq: '护照有效期',
    qsrsfzhm: '请输入身份证号码',
    qsrhzhm: '请输入护照号码',
    qxzsfzyxq: '请选择身份证有效期',
    qxzhzyxq: '请选择护照有效期',
    sfzzmzp: '身份证正面照片',
    sfzbmzp: '身份证背面照片',
    grscsfz: '个人手持身份证正面照片',
    hzxxyzp: '护照信息页照片',
    grschzxx: '个人手持护照信息页照片',
    sfzdq: '身份证有效期还有10天，请及时更新',
    hzdq: '护照有效期还有10天，请及时更新',
    qsryzm: '请输入验证码',
    qsrxsjh: '请输入新手机号',
    yzmcw: '验证码错误',
    xsjhyzc: '新手机号已注册',
    qysh: '企业税号',
    yyzzbh: '营业执照编号',
    zczj: '注册资金（万元）',
    bz: '币种',
    jp: '基普',
    rmb: '人民币',
    meij: '美金',
    qxzbz: '请选择币种',
    sshy: '所属行业',
    jjxz: '经济性质',
    qyzh: '企业性质',
    jglx: '机构类型',
    qyyhzh: '企业银行账户',
    jyfw: '经营范围',
    fddbr: '法定代表人',
    frgj: '法人国籍',
    ffsfzhm: '法人身份证号码',
    ffsfzyxq: '法人身份证有效期',
    frhzhm: '法人护照号码',
    frhzyxq: '法人护照有效期',
    sjgs: '上级公司',
    zjxx: '证件信息',
    zjxxts: '证件推荐上传扫描文件；拍照请尽量降低反光；请确保图片所有信息清晰可见，内容真实有效，无任何修改；文件大小不超过5MB，格式支持：.jpg  .jpeg  .bmp  .png',
    wtzm: '委托证明',
    yyzzyxq: '营业执照有效期',
    wtzmyxq: '委托证明有效期',
    frsfzzmz: '法人身份证正面照片',
    frsfzbmz: '法人身份证背面照片',
    frscsfzzmz: '法人手持身份证正面照片',
    zzzmcl: '资质证明材料',
    syb: '上一步',
    ymzzzm: '运煤资质证明',
    tdzzws: '替代种植文书',
    ymzzzmyxq: '运煤资质证明有效期',
    tdzzwsyxq: '替代种植文书有效期',
    yksydzm: '铁矿石移动证明',
    yksydzmyxq: '铁矿石移动证明有效期',
    jzxsyxy: '集装箱使用协议',
    jzxsyxyyxq: '集装箱使用协议有效期',
    jzxsyxysy: '集装箱使用协议首页照片',
    qscjzxsyxysy: '请上传集装箱使用协议首页照片',
    jzxsyxywy: '集装箱使用协议双方盖章页照片',
    qscjzxsyxywy: '请上传集装箱使用协议双方盖章页照片',
    qscyxdzbxxy: "请上传有效的自备箱协议",
    zbxsyxy: '自备箱使用协议',
    zbxsyxyyxq: '自备箱使用协议有效期',
    zbxsyxysy: '自备箱使用协议首页照片',
    qxzzbxsyxyyxq: '请选择自备箱使用协议有效期',
    qsczbxsyxysy: '请上传自备箱使用协议首页照片',
    zbxsyxywy: '自备箱使用协议尾页照片',
    qsczbxsyxywy: '请上传自备箱使用协议尾页照片',
    qtcl: '其他材料',
    qtclyxq: '其他材料有效期',
    jbrxx: '经办人信息',
    jbrxxts: '由于您在填写企业基本信息时设置了法人为经办人，相关信息已为您自动显示。',
    sjyzm: '手机验证码',
    jsjhyzm: '旧手机号验证码',
    xsjh: '新手机号',
    xsjhyzm: '新手机号验证码',
    ghsjh: '更换手机号',
    qscsfzzmz: '请上传身份证正面照片',
    qscsfzbmz: '请上传身份证背面照片',
    qscgrscsfzzmz: '请上传个人手持身份证正面照片',
    qschuxxy: '请上传护照信息页照片',
    qscgrschzxxy: '请上传个人手持护照信息页照片',
    frhzxxy: '法人护照信息页照片',
    frschzxxy: '法人手持护照信息页照片',
    yhqh: '用户切换',
    yhxxwh: '用户信息维护',
    qhqy: '切换企业',
    sskh: '所属客户',
    khlx: '客户类型',
    sskhxx: '所属客户信息',
    khgx: '客户关系',
    guanx: '关系',
    gjhdq: '国家/地区',
    sqyw: '授权业务',
    qx: '期限',
    jlrq: '建立日期',
    baog: '报关',
    dl: '代理',
    bdl: '被代理',
    zc: '正常',
    stop: '终止',
    gq: '过期',
    slzt: '受理状态',
    ysh: '已审核',
    shlb: '审核列表',
    sqdl: '申请代理',
    ywfw: '业务范围',
    dlkh: '代理客户',
    sqqx: '授权期限',
    sm: '说明',
    sqkh: '申请客户',
    sqjl: '申请记录',
    sqrq: '申请日期',
    khxq: '客户详情',
    zzf: '终止方',
    zzrq: '终止日期',
    zzsm: '终止说明',
    yq: '延期',
    bg: '变更',
    djckkhxq: '客户详情，点击查看',
    zjlx: '证件类型',
    zjh: '证件号',
    yyzzh: '营业执照号',
    jbrgl: '经办人管理',
    jzrq: '截止日期',
    glqx: '关联期限',
    xzjbr: '新增经办人',
    bjjbr: '编辑经办人',
    accept: '接受',
    jbrsjh: '经办人手机号',
    glzt: '关联状态',
    tslx: '投诉类型',
    clzt: '处理状态',
    tjjs: '提交时间',
    cx: '撤销',
    xztsjy: '新增投诉建议',
    bjtsjy: '编辑投诉建议',
    tppz: '图片凭证',
    tjxx: '提交信息',
    slxx: '受理信息',
    ddcx: '订单查询',
    fhwt: '发货问题',
    shwt: '收货问题',
    slz: '受理中',
    ycx: '已撤销',
    qxzytsj: '请选择一条数据进行确定',
    zzyy: '终止原因',
    qsrzzyy: '请输入终止原因',
    qsrjjyy: '请输入拒绝原因',
    qsrdlkh: '请输入代理客户',
    qzsxzyxywfw: '请至少选择一项业务范围',
    qxzsqqx: '请选择授权期限',
    huz: '护照',
    qyxq: '企业详情',
    ygl: '已关联',
    yzz: '已终止',
    sjhgh: '手机号更换',
    yzmyfs: '验证码已发送',
    dxssh: '待线上审核',
    dxxqr: '待线下确认',
    dyhxg: '待用户修改',
    shwb: '审核完毕',
    dgx: '待更新',
    yyq: '已逾期',
    tsr: '投诉人',
    mmxgcg: '密码修改成功，请重新登陆！',
    mrshxx: '默认收货信息设置成功!',
    mrfhxx: '默认发货信息设置成功!',
    qgxyscdh: '请勾选要删除的行',
    qtxjbrsjh: '请填写经办人手机号',
    sjhghcg: '手机号更换成功!',
    qxzglqx: '请选择关联期限',
    qsrjbrxm: '请输入经办人姓名',
    xxshzt: '信息审核状态',
    qsrysmm: '请输入原始密码',
    qqrdlmm: '请确认登录密码',
    jmmcw: '旧密码错误',
    jxxz: '继续新增',
    tcbj: '退出编辑',
    gxqr: '关系确认',
    qyqz: '企业签章',
    jqsdsjgl: '接取送达司机管理',
    qzlx: '签章类型',
    qztsy: '签章待审核中，新上传签章暂时无法办理业务/审核未通过，请重新上传签章',
    qztsyShz: '签章待审核中，新上传签章暂时无法办理业务',
    qztsyWtg: '审核未通过，请重新上传签章',
    cxsc: '重新上传',
    zwqzxx: '暂无签章信息！',
    ljsc: '立即上传',
    scqz: '上传签章',
    qscqztp: '请上传签章图片',
    qxzqzlx: '请选择签章类型',
    sjxm: '司机姓名',
    csrq: '出生日期',
    zhuzhi: '住址',
    jszzp: '驾驶证照',
    xzsjxx: '新增司机',
    cksjxx: '查看司机信息',
    bjsjxx: '编辑司机信息',
    qsrsjxm: '请输入司机姓名',
    qsrzjhm: '请输入证件号码',
    gjqh: '国际区号',
    qsrgjqh: '请输入国际区号',
    kchwh: '卡车号维护',
    hdzz: '额定载重(t)',
    ztsy: '暂停使用',
    trsy: '投入使用',
    jk20: '20集卡',
    jk40: '40集卡',
    fjk: '非集卡',
  },
  transportConsultation: {
    fh: '返回',
    dqwz: '当前位置',
    xq: '详情',
    jgcx: '价格查询',
    sy: '首页',
    tbjdxq: '提报阶段需求',
    ywbllc: '业务办理流程',
    flfgjgfxwj: '法律法规及规范性文件',
    fwcszhxx: '服务场所综合信息',
    zxfw: '咨询服务',
    jmjm: '竞买竞卖',
    clcs: '车辆参数',
    gdyd: '挂单应单',
    hyblcjwt: '货运办理常见问题',
    gd: '更多 >',
    cc: '敞车',
    tlzfsfxmhbz: '铁路杂费收费项目和标准',
    hwzzfjzflybjfv: '货物装卸费基准费率与保价费率',
    hwyjl: '货物运价率',
    yyzfwxxcx: '营业站服务信息查询',
    yyzlstxzgg: '营业站临时停限装公告',
    gbjg: '公布结果',
    qdht: '签订合同',
    zjjs: '资金结算',
    jj: '竞价',
    fqxm: '发起项目',
    fqjyd: '发起交易单',
    qdjyd: '确定交易单',
    dxjy: '定向交易',
    qryd: '确认应单',
    gxyd: '购销应单',
    gxgd: '购销挂单',
    hwjf: '货物交付',
    hwzz: '货物追踪',
    yfzf: '运费支付',
    tbrxq: '提报日需求',
    ysfw: '运输服务',
    smjy: '商贸交易'
  },
  legalDocument: {
    dqwz: '当前位置',
    zxfw: '咨询服务',
    flfgjgfxwj: '法律法规及规范性文件',
    xq: '详情',
    xz: '下载',
    fh: '返回',
    t: '条',
    y: '页'
  },
  stationinfo: {
    yyzlstxzgg: '营业站临时停限装公告',
    qsrfbdw: '请输入发布单位',
    zyxsx: '专用线属性',
    fsplpm: '发送品类/品名',
    qsr: '请输入',
    qc: '全称',
    qznl: '起重能力',
    bt: '标题',
    fz: '发站',
    fwcszhxx: '服务场所综合信息',
    qxzs: '请选择省',
    dz: '到站',
    yyzfwxx: '营业站服务信息',
    yyz: '营业站:',
    shdw: '收货单位',
    cc: '叉车',
    qxzyyz: '请选择营业站',
    fbdw: '发布单位：',
    ddplpm: '到达品类/品名',
    qxzq: '请选择区',
    tzsj: '停装时间',
    tzlyj: '停装理由间',
    yyzfwxxcx: '营业站服务信息查询',
    s: '省:',
    shi: '市:',
    cx: '查询',
    zxfw: '咨询服务',
    xq: '县(区):',
    fbsj: '发布时间：',
    pm: '品名',
    fh: '返回',
  },
  containerDayDemand: {
    crumbs0: '集装箱',
    crumbs1: '提出日需求',
    tbrq: '填报日期',
    jsrq: '结束日期',
    kssj: '开始日期',
    jssj: '结束日期',
    tyr: '托运人',
    srdmhmcjzcx: '输入代码或名称精准查找',
    faz: '发站',
    ydh: '预订号',
    ydxqh: '运单需求号',
    shouhr: '收货人',
    shouhf: '收货方',
    tuoyf: '托运方',
    daoz: '到站',
    qsr: '请输入',
    chax: '查询',
    qink: '清空',
    xuhao: '序号',
    ydztbm: '运单状态编码',
    ydlxbm: '运单类型编码',
    ysfsbm: '运输方式编码',
    ysfs: '运输方式',
    wxpbsbm: '危险品标识编码',
    yxpbz: '危险品标志',
    zyrq: '装运日期',
    xqtcfs: '需求提出方式',
    jdxqh: '阶段需求号',
    rxqzt: '日需求状态',
    pinm: '品名',
    zdaoz: '终到站',
    daoj: '到局',
    ssqymc: '所属企业名称',
    xianh: '箱号',
    biaoz: '标志',
    zcdd: '装车地点',
    xcdd: '卸车地点',
    tcrxq: '提出日需求',
    ydcx: '运单查询',
    yun: '运',
    ydxx: '运单信息',
    hpiaoh: '货票号',
    ssqy: '所属企业',
    tbqy: '提报企业',
    tyrjzsx: '托运人记载事项',
    cyrjzsx: '承运人记载事项',
    ding: '订',
    dcxx: '订车信息',
    ydcs: '预定车数',
    dcfs: '订车方式',
    checi: '车次',
    yuyueh: '预约号',
    dczt: '订车状态',
    zcrq: '装车日期',
    huo: '货',
    hwxx: '货物信息',
    xianx: '箱型',
    xianl: '箱类',
    kongz: '空重',
    shifh: '施封号',
    hwmc: '货物名称',
    hwpm: '货物品名',
    hwjg: '货物价格',
    tyrtbzl: '托运人填报重量',
    cyrqdzl: '承运人确定重量',
    wu: '物',
    wulxx: '物流信息',
    wl_mdz: '物流-门到站',
    lxrxm: '联系人姓名',
    dianh: '电话',
    qhdz: '取货地址',
    lic: '里程',
    xqsm: '需求说明',
    qtsm: '其他说明',
    guanb: '关闭',
    xzjdxqh: '选择阶段需求号',
    qsrjdxqh: '请输入阶段需求号',
    yslx: '运输类型',
    gjly: '国际联运',
    ptys: '普通运输',
    ches: '车数',
    slcs: '受理车数',
    caoz: '操作',
    xz: '选择'
  },
  containerCartonNo: {
    ddxx: "订单信息",
    crumbs0: '集装箱',
    crumbs1: '装箱',
    tbrq: '开始日期',
    jsrq: '结束日期',
    to: '至',
    ydxqh: '运单需求号',
    yundh: '预订号',
    xianx: '箱型',
    qxr: '请选择',
    xianl: '箱类',
    xianh: '箱号',
    chax: '查询',
    qink: '清空',
    xuhao: '序号',
    ydId: '预订ID',
    ydhy: '预订号(原)',
    rxqh: '日需求号',
    xh1: '箱号1',
    xh2: '箱号2',
    ydzztbm: '运单状态编码',
    ydzt: '运单状态',
    rxqzt: '日需求状态',
    ydlxbm: '运单类型编码',
    ydlx: '运单类型',
    ysfsbm: '运输方式编码',
    ysfs: '运输方式',
    wxpbsbm: '危险品标识编码',
    wxpbs: '危险品标识',
    tjrq: '提交日期',
    danx: '单箱',
    xianshu: '箱属',
    shi: '是',
    sfwz: '是否完整',
    sfdx: '是否单箱',
    sfzp: '是否制票',
    tbkhm: '提报客户名称',
    sskhmc: '所属客户名称',
    ssqy: '所属企业',
    faz: '发站',
    daoz: '到站',
    tyr: '托运人',
    shr: '收货人',
    tbqymc: '提报企业名称',
    tibqy: '提报企业',
    yyh: '预约号',
    zysj: '作业时间',
    hwjs: '货物件数',
    caoz: '操作',
    ydcx: '运单查询',
    butxh: '补填箱号',
    yun: '运',
    ydxx: '运单信息',
    zzjgcl: '装载加固材料',
    canchu: '仓储',
    lcbw: '冷藏(保温)',
    bxys: '保险运输',
    hph: '货票号',
    zcdd: '装车地点',
    xcdd: '卸车地点',
    tyrjzsx: '托运人记载事项',
    cyrjzsx: '承运人记载事项',
    ding: '订',
    dingcxx: '订车信息',
    ydcs: '预定车数',
    dcfs: '订车方式',
    chec: '车次',
    dczt: '订车状态',
    zcrq: '装车日期',
    huo: '货',
    hwxx: '货物信息',
    kongz: '空重',
    sfh: '施封号',
    hwmc: '货物名称',
    hwjg: '货物价格',
    tyrtbzl: '托运人填报重量',
    cyrqdzl: '承运人确定重量',
    qsrjdxqh: '请输入阶段需求号',
    guanb: '关闭',
    btyd: '补填运单',
    ke: '客',
    kehxx: '客户信息',
    fa: '发',
    fhxx: '发货信息',
    faj: '发局',
    tlhc: '铁路货场',
    yddh: '移动电话',
    txdz: '通信地址',
    jbr: '经办人',
    sfzh: '身份证号',
    lxrxm: '联系人姓名',
    dianh: '电话',
    dzyd: '电子运单',
    xzdzyd: '选择电子运单，不需要盖章纸质运单，发货更加便捷',
    yjxmh: '运价项目号',
    jtxcd: '具体卸车点',
    jzsx: '记载事项',
    zhi: '支',
    zfsz: '支付设置',
    zffs: '支付方式',
    yfk: '预付款',
    xianjin: '现金',
    zhip: '支票',
    yhk: '银行卡',
    hzzf: '汇总支付',
    bizxz: '币种选择',
    jipu: '基普',
    rmb: '人民币',
    myuan: '美元',
    pinl: '品类',
    cpchx: '重去重回箱',
    tyrtbzlqk: '托运人填报重量(千克)',
    jiage: '价格(元)',
    liang: '两',
    ldwl: '两端物流',
    msg1: '可根据您的需求，选择录入发到站接取，送达，仓储等物流服务信息。',
    mdz: '门到站',
    smqh: '上门取货',
    zdm: '站到门',
    qhdz: '取货地址',
    qianmi: '千米',
    licheng: '里程(km)',
    tyrqdjs: '托运人确定件数',
    xuqsm: '需求说明',
    qhgsfy: '取货估算费用',
    smsh: '上门送货',
    shdz: '送货地址',
    tijiao: '提交',
    cywlxx: '常用物流信息'
  },
  containerInvoice: {
    crumbs0: '集装箱',
    crumbs1: '填写运单',
    ke: '客',
    kehxx: '客户信息',
    ssqy: '所属企业',
    fa: '发',
    fhxx: '发货信息',
    faz: '发站',
    tyr: '托运人',
    faj: '发局',
    qsr: '请输入',
    zcdd: '装车地点',
    qxz: '请选择',
    txdz: '通信地址',
    jbr: '经办人',
    sfzh: '身份证号',
    jbrsj: '经办人手机',
    sou: '收',
    shxx: '收货信息',
    daoz: '到站',
    shr: '收货人',
    zdaoz: '终到站',
    daoj: '到局',
    xcdd: '卸车地点',
    bllx: '班列类型',
    blcc: '班列车次',
    zobl: '中欧班列',
    zybl: '中亚班列',
    yun: '运',
    ysxx: '运单信息',
    zzjgcl: '装载加固材料',
    canchu: '仓储',
    lcbw: '冷藏(保温)',
    plky: '批量快运',
    bxys: '保险运输',
    jtxcd: '具体卸车点',
    jzsx: '记载事项',
    zhi: '支',
    zfsz: '支付设置',
    zffs: '支付方式',
    yfk: '预付款',
    xianjin: '现金',
    zhip: '支票',
    yhk: '银行卡',
    hzzf: '汇总支付',
    bizxz: '币种选择',
    jipu: '基普',
    rmb: '人民币',
    myuan: '美元',
    huo: '货',
    hwxx: '货物信息',
    dxyd: '单箱运单',
    plzjxs: '批量增加箱数',
    xzh: '新增行',
    sch: '删除行',
    xuhao: '序号',
    xzhwmc: '选择货物名称',
    pinl: '品类',
    twbh: '铁危编号',
    xianh: '箱号',
    qsrxh: '请输入箱号',
    xianshu: '箱属',
    tielux: '铁路箱',
    zibeix: '自备箱',
    xianx: '箱型',
    xianl: '箱类',
    kongz: '空重',
    kong: '空',
    zhong: '重',
    baozhuan: '包装',
    cpchx: '重去重回箱',
    tielcdx: '铁路敞顶箱',
    tezx: '特种箱',
    cquch: '重去重回',
    xiasch: '下水重回',
    sfh: '施封号',
    zhognlqk: '重量(千克)',
    jiage: '价格(元)',
    msg1: '*货物名称说明：若在货物品名中查找不到相应品名，可在下方填写品名，并选择相应品类。发送自备集装箱且箱内无货物，品名请选择自备集装箱（或集装箱）。',
    msg2: '填记其他品名（如：空箱、空自备箱等），系统将按重箱计费。',
    ri: '日',
    rysxq: '日运输需求',
    zyrq: '装运日期',
    xzrq: '选择日期',
    xqtcfs: '需求提出方式',
    zjtcrxq: '直接提出日需求',
    syjdxq: '使用阶段需求',
    jdxqh: '阶段需求号',
    qsrjdxqh: '请输入阶段需求号',
    ches: '车数',
    chec: '车次',
    liang: '两',
    ldwl: '两端物流',
    msg3: '可根据您的需求，选择录入发到站接取，送达，仓储等物流服务信息。',
    mdz: '门到站',
    smqh: '上门取货',
    zdm: '站到门',
    lxrxm: '联系人姓名',
    dianh: '电话',
    qhdz: '取货地址',
    qianmi: '千米',
    licheng: '里程(km)',
    tyrqdjs: '托运人确定件数',
    xuqsm: '需求说明',
    qhgsfy: '取货估算费用',
    smsh: '上门送货',
    shdz: '送货地址',
    tijiao: '提交',
    qink: '清空',
    chax: '查询',
    yslx: '运输类型',
    tuoyf: '托运方',
    souhf: '收货方',
    hwpm: '货物品名',
    slcs: '受理车数',
    caoz: '操作',
    xuanzhe: '选择',
    xzjdxqh: '选择阶段需求号',
    hwmc: '货物名称',
    fhrxx: '发货人信息',
    zjh: '证件号',
    jbrsjh: '经办人手机号',
    zzzmwj: '资质证明文件',
    bzjs: '标准记事',
    zyjs: '自由记事',
    zmwjmc: '证明文件名称',
    hm: '号码',
    fj: '附件',
    shrxx: '收货人信息',
    fkxx: '付款信息',
    fkr: '付款人',
    dxys: '单箱运输',
    ldwlts: '*可根据您的需求，选择录入发到站接取，送达物流服务信息',
    xqsm: '需求说明',
    lc: '里程',
    dh: '电话',
    qk: '清空',
    tj: '提交',
    jdxq: '阶段需求',
    realHzmc: '货主',
    xj: '现金',
    wlgs: '物流公司'
  },

  pathAnalysis: {
    crumbs0: '运输服务',
    crumbs1: '运输方案选择',
    kaishi: '始',
    jiesu: '终',
    zss: '最省时',
    zsq: '最省钱',
    huafei: '花费',
    haoshiyue: '耗时约'
  },
  industryInfo: {
    fbsj: '发布时间',
    xzsj: '选择日期',
    bt_nr: '标题 / 内容',
    chax: '查询',
    qink: '清空',
    smjy: '商贸交易',
    hyzx: '行业资讯',
    sy: '首页',
    tzgg: '通知公告',
    tlxw: '铁路新闻',
    dsly: '多式联运',
    fh: '返回',
  },
  newsDetail: {
    sy: '首页',
    smjy: '商贸交易',
    hyzx: '行业资讯',
    tzgg: '通知公告',
    tlxw: '铁路新闻',
    dsly: '多式联运',
    hyzx2: '行业咨讯',
    xq: '详情',
    xz: '下载',
    fh: '返回'
  },
  index_page: {
    ysxq: '运输需求',
    zhenc: '整车',
    jzx: '集装箱',
    guolian: '国联',
    yfcx: '运费查询',
    qsrcfz: '请输入出发站',
    qsrddz: '请输入到达站',
    qsrds: '请输入吨数',
    chax: '查询',
    faz: '发站',
    daoz: '到站',
    duns: '吨数',
    yunf: '运费',
    yuan: '元',
    qued: '确定',
    hwzz: '货物追踪',
    xqdh: '需求单号',
    qsrxqdh: '请输入需求单号',
    ywjs: '老中铁路业务介绍',
    ysfw: '货运服务',
    ysfw_msg: '中老铁路连接中国昆明和老挝万象， 铁路全长1000多公里， 为电气化客货混运铁路， 中国段正线全长508 .53 公里， 老挝境内全长414公里， 设计速度为每小时160公里的普速铁路， 为国铁I级电气化铁路。 ',
    jzx_msg: '集装箱运输具有发运快速、 装运便捷、 绿色环保、 综合运输成本低等多项优势。 2021 年， 云南铁路集装箱运输占比已达到40 % 以上， 占比全国第一； 通过集装箱运输货物超2371万吨， 同比增长28 .6 % ，增长率全国第一。 ',
    gjly: '国际联运',
    gjly_msg: '国际铁路联运是指使用一份统一的国际联运票据， 由铁路负责经过两国或两国以上的全程运送， 并由一国铁路向另一国铁路移交货物， 不需要发货人和收货人参加的货物运输组织方式。 国际货运列车通过云南磨憨口岸出境， 全程约2400公里， 预计7天后抵达老挝首都万象， 为“ 一带一路” 沿线国家、 地区送去“ 中国制造” 的本土优质产品。 ',
    jqsd: '接取送达',
    jqsdqr: '接取送达签认',
    jqsd_msg: '对货物从托运人约定交货地点至铁路车站公共装卸场所或货物从铁路车站公共装卸场所至收货人约定接货地点的短途或长途运输， 核收接取送达费用。 ',
    bjbx: '保价保险',
    bjbx_msg: '铁路保价运输是指托运人以托运货物价值及其有关利益为保险标的的一项经济保障活动。 参与保价运输的货主或旅客， 在托运时向承运人声朋其托货物、 包裹、 行李的实际价值， 并按规定缴纳保价费。 在足额投保的前提下， 一旦发生承运人责任损失， 将按实际损失得到足额的赔偿。 ',
    tzgg: '通知公告',
    tzgg_msg: '真实· 准时· 完整',
    gengduo: '更多',
    tlxw: '铁路新闻',
    tlxw_msg: '一手动态早知道',
    hyzx: '行业资讯',
    hyzx_msg: '掌控最新货运资讯',
    zltllt: '中老铁路论坛',
    jhwt: '精华问题',
    hzhb: '合作伙伴',
    bannertitle: "跨国运输 · 货运全球",
    zcwjgq: "注册文件已过期,当前页面不能进行提报",
    zhysd: "您的账号已锁定，请联系公司进行处理！",
    yxqbzygyjsgx: "以下证件有效期不足一个月，请及时更新",
    yxzjygq: "以下证件已过期,请及时更新"
  },
  jsLang: {
    zg: '中国',
    lw: '老挝',
    tg: '泰国',
    zw: '中文',
    ew: '俄文',
    yw: '英文'
  },
  hwydInfo: {
    xhsjy: '卸货时间-月-日-时到站收费票据号码',
    tzsjy: '通知时间-月-日-时领货人身份证号码',
    yebzqq: '余额不足，请前往预存款管理界面充值！',
    qqrxxw: '请确认信息无误，是否继续支付？',
    yfkdyt: '预付款抵用（退款）凭证',
    lkdwkh: '领款单位开户 领取退款',
    lkdwkh1: '领款单位开户领取退款',
    czjjhr: '车站接（交）货人签章',
    lcsrmm: '两次输入密码不一致。',
    zfcgcz: '支付成功/充值成功',
    zfsbcz: '支付失败/充值失败',
    qzsxzy3: '请至少选择一条单据',
    qhlckm: '取货里程(km)',
    qxzyzf: '请选择已支付单据',
    cyrqdzl: '承运人确定重量',
    qsrtxj: '请输入提现金额',
    zyxmcd: '专用线名称代码',
    zfzczz: '支付中/充值中',
    qsrymm: '请输入原密码。',
    qsrxmm: '请输入现密码。',
    gpjhwz: '该票据号未支付',
    gpjhyz: '该票据号已支付',
    qqrsft: '请确认是否退款',
    khhjzh: '开户行及账号',
    nsrsbh: '纳税人识别号',
    zzdjcl: '装载加固材料',
    crpzbh: '存入凭证编号',
    crpzbhColon: '存入凭证编号:',
    dyth: '抵用（退还）',
    yfkstj: '预付款时填记',
    jyjcsb: '交易检查失败',
    txshjj: '提现审核拒绝',
    pjhbzq: '票据号不正确',
    sfzhm: '身份证号码',
    spfmc: '受票方名称',
    xqdh: '需求单号:',
    jey: '金额（元）',
    yfkdw: '预付款单位',
    skdwh: '收款单位和',
    dyhth: '抵用或退还',
    yxjzh: '银行及账号',
    lqpzr: '领取凭证人',
    jzxxx: '集装箱箱型',
    yyspj: '原运输票据',
    jzxxh1: '集装箱箱号',
    cyrjs: '承运人记事',
    tyrjs: '托运人记事',
    czrqc: '车站日期戳',
    shrqz: '收货人签章',
    yfkzf: '预付款支付',
    yxkzf: '银行卡支付',
    bczf: '本次支付：',
    txshz: '提现审核中',
    yqxzf: '已取消支付',
    bjys: '保价运输',
    blzb: '办理种别',
    crumbs01: '货物运单',
    czcg: '操作成功',
    czch: '车种车号',
    fplx: '发票类型',
    fymx: '费用明细',
    hwjg: '货物价格',
    hwmc: '货物名称',
    hwpm: '货物品名',
    hwzl: '货物重量',
    hzzf: '汇总支付',
    lxdh: '联系电话',
    qhdd: '取货地址',
    shdd: '送货地址',
    smqh: '上门取货',
    smsh: '上门送货',
    smxc: '上门卸车',
    smzc: '上门装车',
    wxts: '温馨提示',
    yfzf: '运费支付',
    zcrq: '装车日期',
    zffs: '支付方式',
    jjyy: '拒绝原因',
    bjpz: '编辑凭证',
    lzgs: '老中公司',
    skdw1: '收款单位',
    skdw1Colon: '收款单位:',
    pjmc: '票据名称',
    dx: '（大写）',
    xjzf: '现金支付',
    tkcg: '退款成功',
    tksb: '退款失败',
    txcg: '提现成功',
    txsb: '提现失败',
    ptzc: '普通整车',
    zlyz: '自轮运转',
    lshw: '零散货物',
    plhw: '批量货物',
    pmdm: '品名代码',
    fffs: '付费方式',
    lhfs: '领货方式',
    zzlh: '纸质领货',
    dzlh: '电子领货',
    ydqx: '运到期限',
    fyhj: '费用合计',
    jfzl: '计费重量',
    pjlx: '票据类型',
    xxxl: '箱型箱类',
    sjhm: '手机号码',
    xzfw: '选择服务',
    qtfw: '其他服务',
    zdrq: '制单日期',
    fkdw: '付款单位',
    ssbz: '实收币种',
    ssje: '实收金额',
    zpzf: '支票支付',
    bjyf: '补缴运费',
    ztwm: '状态未明',
    crumbs02: '集装箱',
    dzf: '待支付',
    jbr: '经办人',
    qsr: '请输入',
    rmb: '人民币',
    sfh: '施封号',
    shouhr: '收货人',
    tuoyf: '托运方',
    tyr: '托运人',
    xqh: '需求号',
    ybg: '已变更',
    yfk: '预付款',
    yhk: '银行卡',
    ywc: '已完成',
    zyx: '专用线',
    zzs: '增值税',
    pjh: '票据号',
    hgr: '或个人',
    lkr: '领款人',
    tkz: '退款中',
    txz1: '提现中',
    yzf1: '已支付',
    fkr: '付款人',
    pbh1: '蓬布号',
    ptp1: '普通票',
    zyp: '专用票',
    hyy: '货运员',
    zdr: '制单人',
    fy: '费用：',
    yck: '预存款',
    address: '地址',
    back: '返回',
    baozhuan: '包装',
    bc: '保存',
    beiz: '备注',
    bz1: '标重',
    canchu: '仓储',
    ch: '车号',
    chak: '查看',
    daoz: '到站',
    dh: '电话',
    dy: '打印',
    faz: '发站',
    huoq: '货区',
    huow: '货位',
    jianshu: '件数',
    jipu: '基普',
    khhzh: '账号',
    my: '美元',
    name: '名称',
    qd: '确定',
    qink: '清空',
    qr: '确认',
    quxiao: '取消',
    tiji: '体积',
    ts: '提示',
    xh3: '箱号',
    xianjin: '现金',
    zaf: '杂费',
    zhip: '支票',
    zhongliang: '重量',
    cz: '充值',
    tx: '提现',
    bh: '编号',
    qh: '起号',
    zh: '止号',
    zs: '张数',
    ke: '款额',
    dw: '单位',
    je: '金额',
    tk: '退款',
    hj: '合计',
    fb: '费别',
    fl: '费率',
    fj: '附记',
    gs: '公司',
    fm: '费目',
    se: '税额',
    dx2: '大写',
    qz1: '签章',
    zf1: '支付',
    ri: '日',
    yuan: '元',
    y1: '亿',
    q: '仟',
    b: '佰',
    s1: '拾',
    w1: '万',
    q1: '千',
    b1: '百',
    s2: '十',
    j: '角',
    f: '分',
    n: '年',
    y2: '月',
    shlc: '送货里程',
    jzxsfh: '集装箱施封号',
    yjh: '运价号',
    lcbw: '冷藏（保温）',
    zcf: '装车方',
    sff: '施封方',
    qsrtyf: '请输入托运方',
    sxfk: '上项预付款于',
    sxtk: '上项退款于',
    rsdy: '如数抵用',
    yxjzp: '以现金/支票如数退讫',
    yh: '银行',
    sxyfkQ: '上项预付款于 月 日如数抵用',
    sxtkQ: '上项退款于 月 日以现金/支票如数退讫',
  },
  stagedemand: {
    qxzdzqxzfz: '请选择到站,如未选择发站,请先选择发站',
    qxzhwpm: '请选择货物品名',
    qxzysrq: '请选择运输日期',
    jdxqtb: '阶段需求提报的吨数范围是10万吨至50万吨',
    qdsfsc: '此操作将永久删除该数据, 是否继续?',
    hwtzfr: '货物特征:发热量(kcal/kg):',
    hwtz: '货物特征:发热量(kcal/kg)',
    hwtzColon: '货物特征:发热量(kcal/kg):',
    frlbnc: '发热量不能超过9999.99',
    qsrxcddszjy: '请输入2-400位卸车地点',
    qsrzcddszjy: '请输入2-400位装车地点',
    ghsjgsbzq: '固话或者手机号格式不正确',
    qnqdtb: '请您去待提报信息里提交。',
    qnqdtbxxtj: '请您去待提报信息提交！',
    qnqdtb1: '请您去待提报信息里提交',
    sctpjy5: ' 个文件，共选择了 ',
    dbcgqd: '代报成功，请等待受理',
    qsrnsrsbh: '请输入纳税人识别号',
    qsrspfmc: '请输入受票方名称',
    qsrhwms: '请输入货物描述',
    qsrxcdd: '请输入卸车地点',
    qsrzcdd: '请输入装车地点',
    qxzfplx: '请选择发票类型',
    qxzhwm: '请选择货物品名',
    qxzjzxx: '请选择集箱箱型',
    qxzqsrq: '请选择起始日期',
    qxzzzrq: '请选择终止日期',
    qxztbf: '请选择提报方式',
    frlbnw: '发热量不能为0',
    qxzdbx: '请选择代报信息',
    impLsxq: '导入历史需求',
    jdxqdb: '阶段需求代报',
    jdxqlx: '阶段需求类型',
    lsxqImp: '历史需求导入',
    lsxqImpColon: '历史需求导入:',
    qsrkhh: '请输入开户行',
    qsrshf: '请输入收货方',
    qsrtyf1: '请输入托运方',
    qsryhm: '请输入用户名',
    qyzyhm: '请验证用户名',
    cyshf: '常用收货方',
    jdqxh: '阶段需求号',
    mdj: '磨丁(境)',
    qsrbz: '请输入备注',
    qsrcs: '请输入车数',
    qsrcz: '请选择车型',
    qsrdh: '请输入电话',
    qsrds: '请输入吨数',
    qsrdz: '请输入地址',
    qsrdz1: '请输入到站',
    qsrfz: '请输入发站',
    qsrzh: '请输入账号',
    sfzhm: '身份证号码',
    yqxsc: '已取消删除',
    zzsxx: '增值税信息',
    cyfhf: '常用发货方',
    qsrsz: '请输入数字',
    bxwsz: '必须为数字',
    ysyf: '运输月份:',
    qxzcz1: '请选择车种',
    qsrcx: '请输入车型',
    dsd: '吨数(吨)',
    sccg: '删除成功!',
    crumbs19: '阶段需求',
    crumbs29: '需求新建',
    czcg: '操作成功',
    drcg: '导入成功',
    drwj: '导入文件',
    fhxx: '发货信息',
    fsdz: '非散堆装',
    gjly: '国际联运',
    hqhw: '货区货位',
    hwmc: '货物名称',
    hwms: '货物描述',
    hwmsColon: '货物描述:',
    hwpm1: '货物品名',
    hwxx: '货物信息',
    lsxq: '历史需求',
    lxdh1: '联系电话',
    ptys: '普通运输',
    qymc: '企业名称',
    shxx: '收货信息',
    tjrq1: '提交日期',
    txdz1: '通信地址',
    wccs: '完成车数',
    wpmc: '物品名称',
    wpqd: '物品清单',
    wxts: '温馨提示',
    xcdd1: '卸车地点',
    xgcg: '修改成功',
    xjcg: '新建成功',
    ysrq1: '运输日期',
    ysxx: '运输信息',
    zcdd1: '装车地点',
    zyrq: '装运日期',
    zyrqColon: '装运日期:',
    jjyy1: '拒绝原因',
    jjyy1Colon: '拒绝原因:',
    tyf1: '托运方:',
    khx1: '开户行：',
    crumbs02: '集装箱',
    frl: '发热量',
    gjz1: '国境站',
    jwz: '境外站',
    qhf: '收货方',
    qsr: '请输入',
    qxr: '请选择',
    sctpjy6: '个文件',
    tuoyf: '托运方',
    xqh: '需求号',
    yuyueh: '预约号',
    anc: '按车',
    anD: '按吨',
    baozhuan: '包装',
    beiz: '备注',
    beizColon: '备注:',
    caoz: '操作',
    chax: '查询',
    congzhi: '重置',
    daochu: '导出',
    daoz: '到站',
    faz: '发站',
    guolian: '国联',
    jg: '价格',
    jianshu: '件数',
    liangshi: '粮食',
    qd: '确定',
    qink: '清空',
    quxiao: '取消',
    sc: '删除',
    sl: '受理',
    tiji: '体积',
    tijiao: '提交',
    ts: '提示',
    xg: '修改',
    xh: '序号',
    xiazai: '下载',
    xz1: '新增',
    zhongliang: '重量',
    zt2: '状态',
    sp: '审批',
    md: '磨丁',
    ty1: '同意',
    jj1: '拒绝',
    chang: '敞',
    collect: '收',
    goods: '货',
    guan: '罐',
    peng: '棚',
    ping: '平',
    to: '至',
    w: '无',
    y: '页',

    //
    tsqyby: '提示：请于本月19号以前提报国联运单',
    lxdh_txdz: '联系电话/通信地址',
    qsrfhrdh: '请输入发货人电话',
    qsrfhrdz: '请输入发货人地址',
    qsrkhhmc: '请输入开户行名称',
    qsrkhhzh: '请输入开户行账号',
    dz_xcdd: '到站/卸车地点',
    excelImp: 'excel导入',
    excelImpColon: 'excel导入:',
    fz_zcdd: '发站/装车地点',
    qsrjzsx: '请输入记载事项',
    qsrlxdh: '请输入联系电话',
    qsrtxdz: '请输入通信地址',
    qsrzcdd1: '请输入注册地址',
    qxzxqlx: '请选择需求类型',
    qsrydd: '请输入移动电话',
    nsrsbh: '纳税人识别号:',
    nsrsbh1: '纳税人识别号：',
    qxzgjz: '请选择国境站',
    zzdjcl: '装载加固材料',
    spfmc: '受票方名称:',
    spfmc1: '受票方名称：',
    dtbxx: '待提报信息',
    qxzyf: '请选择月份',
    ysrq: '运输日期:',
    zdjzl: '最大件重量',
    zdjzlColon: '最大件重量:',
    xqlx: '需求类型:',
    tjrq: '提交日期：',
    hwpm: '货物品名:',
    hwbz: '货物包装：',
    jzsx: '记载事项:',
    tbfs1: '提报方式：',
    zcdd: '装车地点:',
    lxdh: '联系电话:',
    txdz: '通信地址:',
    ddgj: '到达国家：',
    xcdd: '卸车地点:',
    fplx: '发票类型:',
    fplx1: '发票类型：',
    bxys: '保险运输',
    crumbs0: '运输服务',
    ddgj1: '到达国家',
    gnbx: '国内保险',
    hwtz1: '货物特征',
    jsrq: '结束日期',
    jzsx1: '记载事项',
    ksrq: '开始日期',
    plsc: '批量删除',
    ptfp: '普通发票',
    qzrq: '起止日期',
    sltc: '受理通过',
    tbcs: '提报车数',
    tbds: '提报吨数',
    zyfp: '专用发票',
    gjz: '国境站:',
    shf: '收货方:',
    khx: '开户行:',
    bps: '不怕湿',
    ck: ' 出口',
    dsl: '待受理',
    sdz: '散堆装',
    yjj: '已拒绝',
    zzs: '增值税',
    ds: '吨数:',
    cz: '车种:',
    cs: '车数:',
    fz: '发站:',
    fj: '发局:',
    dz: '到站:',
    zh: '账号:',
    dz1: '地址:',
    dh: '电话:',
    zh1: '账号：',
    dh1: '电话：',
    dz2: '地址：',
    back: '返回',
    bc: '保存',
    canchu: '仓储',
    ches: '车数',
    chesColon: '车数:',
    chez: '车种',
    chezColon: '车种:',
    chuk: '出口',
    ds1: '吨数',
    ds1Colon: '吨数:',
    pashi: '怕湿',
    fa: '发',
    jie1: '阶',
    move: '运',
    zen: '增',

    //新增翻译
    fh: '发货',
    sh: '收货',
    myhwpm: '没有这个货物品名',
    ch: '中国',
    //new页面
    tbr: '提报人',
    dbr: '代报人',
    shsj: '审核时间',
    zcdz: '装车地址',
    xcdz: '卸车地址',
    ti: '提',
    tbrxx: '提报人信息',
    hwtzfhl: '货物特征:发热量(kcal/kg):',
    tlhc: '铁路货场',
    qxzblzb: '请选择办理种别',
    xzxz1: '当前限制选择 1 个文件，本次选择了',
    xzxz2: '个文件，共选择了',
    xzxz3: '个文件',
    jdxqhw: '阶段需求号为',
    qxzscnr: '请选择删除内容',
    scjg: '此操作将永久删除该数据, 是否继续?',
    scsb: '删除失败',
    yhxxcw: '用户信息不正确，请核对无误后再行代报。',
    qhdyhxx: '请核对用户信息无误后进行历史需求导入。',
    zg: '中国',

    qsrysyf: '请输入运输月份',
    qxzfkfs: '请选择付款方式',
    qxzbz: '请选择币种',
    qxzfkr: '请选择付款人',
    qsrzjh: '请输入证件号',
    bxwzs: '必须为整数',
    bnw0: '不能为 0',
    bncg9999: '不能超过 9999',
    bctip: '，请尽快到我的订单中进行提交!',
    tjtip: '提交成功,月需求号为：',
    tdtip: '本月退订次数已大于等于5次,不可新增月需求!',
    xybtip: '该条数据没有可进行的下一步操作!',

  },

  delivery: {
    sxtkyy: '上项退款于 月 日以现金/支票如数退讫。',
    xhsjy: '卸货时间-月-日-时到站收费票据号码',
    tzsjy: '通知时间-月-日-时领货人身份证号码',
    yebzqq: '余额不足，请前往预存款管理界面充值！',
    sxyfky: '上项预付款于 月 日如数抵用。',
    ryxjzp: '日以现金/支票如数退讫。',
    gxqdhb: '该需求单号不是已结清状态',
    yfkdyt: '预付款抵用（退款）凭证',
    lkdwkh: '领款单位开户 领取退款',
    sctpjy5: ' 个文件，共选择了 ',
    lkdwkh1: '领款单位开户领取退款',
    czjjhr: '车站接（交）货人签章',
    qzsxzy3: '请至少选择一条单据',
    qhlckm: '取货里程(km)',
    gxqdhy: '该需求单号已交付',
    qxzyjq: '请选择已结清数据',
    cyrqdzl: '承运人确定重量',
    nsrsbh1: '纳税人识别号：',
    qzxxzd: '请重新选择单据',
    khhjzh: '开户行及账号',
    zzdjcl: '装载加固材料',
    crpzbh: '存入凭证编号',
    crpzbhColon: '存入凭证编号:',
    dyth: '抵用（退还）',
    yfkstj: '预付款时填记',
    spfmc1: '受票方名称：',
    jzxsfh: '集装箱施封号',
    sxyfky2: '上项预付款于',
    rrsdy: '日如数抵用。',
    sfzhm: '身份证号码',
    jey: '金额（元）',
    yfkdw: '预付款单位',
    skdwh: '收款单位和',
    dyhth: '抵用或退还',
    yxjzh: '银行及账号',
    lqpzr: '领取凭证人',
    cyrjs: '承运人记事',
    tyrjs: '托运人记事',
    czrqc: '车站日期戳',
    shrqz: '收货人签章',
    bczf: '本次支付：',
    zffs: '支付方式：',
    jfzt: '交付状态:',
    dybjd: '打印补缴单',
    zhye: '账户余额：',
    yjfxq: '已缴费详情',
    fyje: '费用金额：',
    bjfxq: '补缴费详情',
    sxtky: '上项退款于',
    bjys: '保价运输',
    ckxq: '查看详情',
    crumbs01: '货物运单',
    czcg: '操作成功',
    czch: '车种车号',
    fplx2: '发票类型',
    fymx: '费用明细',
    hwjg: '货物价格',
    hwmc: '货物名称',
    hwpm1: '货物品名',
    hzzf: '汇总支付',
    jfrq: '交付日期',
    jfrqColon: '交付日期:',
    jsrq: '结束日期',
    ksrq: '开始日期',
    lxdh1: '联系电话',
    ptys: '普通运输',
    qhdd: '取货地址',
    shdd: '送货地址',
    sltc: '受理通过',
    smqh: '上门取货',
    smsh: '上门送货',
    smxc: '上门卸车',
    smzc: '上门装车',
    wxts: '温馨提示',
    xqdh1: '需求单号',
    ysfs: '运输方式',
    yslx: '运输类型',
    bjpz: '编辑凭证',
    lzgs: '老中公司',
    skdw1: '收款单位',
    skdw1Colon: '收款单位:',
    pjmc: '票据名称',
    dx: '（大写）',
    bjzf: '补缴杂费',
    fffs: '付费方式',
    lhfs: '领货方式',
    zzlh: '纸质领货',
    dzlh: '电子领货',
    ydqx: '运到期限',
    fyhj: '费用合计',
    jfzl: '计费重量',
    pjlx: '票据类型',
    xxxl: '箱型箱类',
    sjhm: '手机号码',
    xzfw: '选择服务',
    qtfw: '其他服务',
    zdrq: '制单日期',
    tyf1: '托运方:',
    shf: '收货方:',
    yyh: '预约号:',
    bccg: '保存成功',
    jfz: '交付中：',
    jfsj: '交付时间',
    jfqr: '交付确认',
    shlc: '送货里程',
    zfr: '支付人：',
    crumbs02: '集装箱',
    dsl: '待受理',
    hph: '货票号',
    jbr: '经办人',
    qhf: '收货方',
    qsr: '请输入',
    rmb: '人民币',
    sctpjy6: '个文件',
    sfh: '施封号',
    shouhr: '收货人',
    tuoyf: '托运方',
    tyr: '托运人',
    xqh: '需求号',
    ydd1: '已到达',
    ydh: '运单号',
    yfc: '已发车',
    yfk: '预付款',
    yhk: '银行卡',
    yjf: '已交付',
    yjj: '已拒绝',
    yxc: '已卸车',
    yzc: '已装车',
    zyx: '专用线',
    zzs: '增值税',
    pjh: '票据号',
    hgr: '或个人',
    lkr: '领款人',
    fkr: '付款人',
    pbh1: '蓬布号',
    ptp1: '普通票',
    zyp: '专用票',
    hyy: '货运员',
    zdr: '制单人',
    fy: '费用：',
    yck: '预存款',
    fz: '发站:',
    dz: '到站:',
    dh1: '电话：',
    djf: '待交付',
    yjq: '已结清',
    zj: '总计：',
    yjf1: '已缴费',
    bjf: '补缴费',
    zcf: '装车方',
    sff: '施封方',
    yjh: '运价号',
    address: '地址',
    back: '返回',
    baozhuan: '包装',
    bc: '保存',
    beiz: '备注',
    bz1: '标重',
    canchu: '仓储',
    chax: '查询',
    daoz: '到站',
    dy: '打印',
    faz: '发站',
    huoq: '货区',
    huow: '货位',
    jianshu: '件数',
    jipu: '基普',
    khhzh: '账号',
    my: '美元',
    name: '名称',
    qd: '确定',
    qink: '清空',
    tiji: '体积',
    xh3: '箱号',
    xianjin: '现金',
    yunf: '运费',
    zaf: '杂费',
    zc: '整车',
    zhip: '支票',
    zhongliang: '重量',
    zt2: '状态',
    bh: '编号',
    qh: '起号',
    zh2: '止号',
    zs: '张数',
    ke: '款额',
    dw: '单位',
    je: '金额',
    hj: '合计',
    gs: '公司',
    fm: '费目',
    se: '税额',
    dx2: '大写',
    qz1: '签章',
    yt: '运退',
    zt3: '杂退',
    jk1: '进口',
    fc: '发车',
    ri: '日',
    t: '条',
    w: '无',
    yuan: '元',
    y1: '亿',
    q: '仟',
    b: '佰',
    s1: '拾',
    w1: '万',
    q1: '千',
    b1: '百',
    s2: '十',
    j: '角',
    f: '分',
    n: '年',
    y2: '月',
    sctpjy3: '上传文件总共不能超过20M',
    qxzfyj: '请选择非已结清运单',
    gwjycz: '该文件已存在！',
    jfqrcg: '交付确认成功',
    jfqrsb: '交付确认失败',
    qxzyd: '请选择运单',
    yd: '运单:',
    //goodsOrder
    dwjfbz: '的未交付备注尚未填写，请填写后提交！',
    zltlgf: '中老铁路股份有限公司',
    zyxmcd: '专用线名称(代码)',
    fkdwhx: '付款单位或姓名',
    jzxxx: '集装箱箱型',
    yyspj: '原运输票据',
    jzxhm: '集装箱号码',
    qrcg: '确认成功！',
    blzb1: '办理种别',
    hwzl: '货物重量',
    pmdm: '品名代码',
    zprq: '制票日期',
    zpr: '制票人',
    bjd: '补缴单',
    sbm: '识别码',
    dhw: '单号为',
    fb: '费别',
    fl: '费率',
    fj1: '附记',
    dm: '代码',
    //新增
    lcbw: '冷藏（保温）',
    qdyc: '确定移除',
    dqxzxz3: '当前限制选择 3 个文件，本次选择了',
    xqdh1Colon: '需求单号:',
    zyxmcdm: '专用线名称(代码)',
  },
  parrent: {
    qsrsjhm: '请输入手机号码',
    qxzjxxx: '请选择集箱箱型',
    qsrhwms: '请输入货物描述',
    qsryhm: '请输入用户名',
    qyzyhm: '请验证用户名',
    qxzysrq: '请选择运输日期',
    qxzhwpm: '请选择货物品名',
    qsrcs: '请输入车数',
    xqcsbnw0: '需求车数不能为0',
    xqds0_99: '需求吨数0~9999999',
    xqdsbnw0: '需求吨数不能为0',
    xqdsbncg9999: '需求吨数不能超过9999',
    qsrtyf: '请输入托运方',
    qxzfz: '请选择发站',
    qsrzcdd: '请输入装车地点',
    qsr2_400wzcdd: '请输入2-400位装车地点',
    qsrjbr: '请输入经办人',
    qsr15h18wsfzhm: '请输入15或18位身份证号码',
    qsrshf: '请输入收货方',
    qxzgjz: '请选择国境站',
    qxzdz: '请选择到站',
    qsrxcdd: '请输入卸车地点',
    qsr2_400wxcdd: '请输入2-400位卸车地点',
    qsrdz: '请输入地址',
    qsrmz: '请输入名字',
    qsrtyrqdjs: '请输入托运人确定件数',
    qsrqhfygs: '请输入取货费用估算',
    qsrlc: '请输入里程',
    //11.24
    qsrds: '请输入吨数',
    dtblbzd: '待提报列表最多保存20条数据，请对现有数据做处理后再进行提报',
    qnqdtbxxltj: '请您去待提报信息里提交。',
    xgcg: '修改成功',
    xqdhw: '需求单号为',
    xjcg: '新建成功',
    qd: '确定',
    qxdjyfss: '请先点击运费试算',
    dqbzw: '当前币种为',
    czcg: '操作成功！',
    wxts: '温馨提示',
    qx: '取消',
    ts: '提示',
    //1125
    sfscckhxx: '是否删除此客户信息',
    sccc: '删除成功!',
    yqxsc: '已取消删除',
    sfbdckhmc: '是否绑定此客户名称',
    bdcg: '绑定成功',
    //1125
    qxzycdsj: '请选择移除的数据',
    cczjyjscgwj: '此操作将永久删除该文件, 确认是否移除?',
    yhxxbcz: '用户信息不存在',
    yhjs: '用户角色',
    js: '角色',
    // 1127
    dqglydhw: '当前国联运单号为',
    qzsxzytsj: '请至少选中一条数据',
    sfscxzyd: '是否删除选中运单',
    qxztbnr: '请选择提报内容',
    //jzx
    tjkxydcg: '提交空箱预订成功：',
    tjtxydcg: '提交填写运单成功：',
    ydhw: '预订号为',
    xxts: '信息提示',
    qrtjm: '确认提交吗？',
    bcmbbxtxmbmc: '保存模板必须填写模板名称',
    qxzybtxhdyd: '请选择已补填箱号的运单',
    qrzfsxjlm: '确认作废所选记录吗？',
    zfcg: '作废成功',

    zsxzytjl: '至少选择一条记录',
    zdxz60tjl: '最多选择60条记录',
    d: '第',
    tzyrqbnwk: '条装运日期不能为空',
    ttcrxqfsbnwk: '条提出日需求方式不能为空',
    qxztcrxqfs: '请选择提出日需求方式',
    tzdwgjz: '条到站为国境站，必须使用阶段需求！',
    qxzjdxq: '请选择阶段需求',
    tjdxqhbkwk: '条阶段需求号不可为空',
    qxzjdxqh: '请选择阶段需求号',
    qxzxt: "请选择相同",
    drxqjxtj: '的日需求进行提交！',
    qxztyz: '请选择同一种',
    xqtcfs: '需求提出方式',
    jxtj: '进行提交！',
    qxztyg: '请选择同一个',
    tcbkwk: '条车次不可为空!',
    qxzblcc: '请选择班列车次',
    dsjcssyrxq: '的实际车数少于所选日需求提报总车数！请重新选择阶段需求号',
    qdjxrxqtbm: '确定进行日需求提报吗?',
    tcrxqcg: '提出日需求成功',
    tcrxqsb: '提出日需求失败',
    hgbgdwj: "海关报关单文件",
    xghgbgd: '修改海关报关单',
    czsdbgwjsj: "车站收到报告文件时间",
    qxzzcdd: "请选择装车地点",
    qxzxcdd: '请选择卸车地点',
    dzbnyfzyz: '到站不能与发站一致',
    zsytjythwxx: '至少要添加一条货物信息',
    ycxdxsbndy120: '20英尺箱的箱数不能大于120',
    xsbndy60: '40英尺箱的箱数不能大于60',
    qxzfkxx: '请选择付款信息',
    qsrffhm: '请输入付费号码',
    qxzbzxx: '请选择币种信息',
    cjxsxh: '出境下水箱号不可为空，请填写箱号',
    qsryxqy: '请输入用箱企业',
    yxqyyw: '用箱企业有误，无相关提箱单号，请重新输入',
    qxzxqtcfs: '请选择需求提出方式',
    hhwxxbwk: '行货物信息不为空',
    zhwmc: '则货物名称、箱号、箱型、箱类、箱属、空重都不能为空',
    zhwmckc: '则货物名称、箱号、箱型、箱类、箱属、空重、卡车号、司机都不能为空',
    zy20yc: '只有20英尺箱型才能选择单箱运单',
    bcmbbxtx: '保存模板必须填写模板名称',
    txydbxyyxhsj: '填写运单必须要有箱号数据',
    gjzdz: '国境到站必须有箱号数据',
    gjzdzbxyxh: '国境到站必须有箱号数据',
    txzbnwk: '提箱站不能为空',
    qxztxrq: '请选择提箱日期',
    qwztxbd: '请完整填写表单',
    wwlgs: '无物流公司',
    q5xyz: '请选择数据的发站,到站,货物品名,托运人,收货人,5项一致',
  },
  billTypesFile: {
    ptfp: '普通发票',
    zyfp: '专用发票'
  },
  advancePayCustomer: {
    grmc: '个人名称',
    qsrgrmc: '请输入个人名称',
    yckje: '预存款金额（元）',

  },
  state: {
    czz: '充值中',
    czcg: '充值成功',
    czsb: '充值失败',
    yfkkz: '运费扣款中',
    yfkkcg: '运费扣款成功',
    yfkksb: '运费扣款失败',
    dsh: '待审核'
  },
  customer: {
    dzzh: '到账账户',
    skrxm: '收款人姓名',
    ssyh: '所属银行',
    txyy: '提现原因',
    jjyy: '拒绝原因',
    sbyy: '失败原因',
    tg: '通过',

  },
  enterpriseRegister: {
    xybh: '协议编号',

  },
  lp: {
    tpr: '提赔人',
    hwsssl: '货物损失数量',
    tprq: '提赔日期',
    tpje: '提赔金额',
    sjpcje: '实际赔偿金额',
    ajh: '案卷号',
    jlhm: '记录号码',
    bzrq: '编制日期',
    jlbzz: '纪录编制站',
    hyjl: '货运记录',
    hwssfcs: '货物损失查复书',
    hwssdztzs: '货物损失定责通知书',
    aj: '案卷',
    fs: '发送',
    hyjlh: '货运记录号',
    dzrq: '定责日期',
    zsz: '主送站',
    bzz: '编制站',
    dsgs: '定损公司',
    z: '站',
    tbr: '填表人',
    tzh: '通知号',
    clz: '处理站',
    sgdw: '收购单位',
    yjrq: '移交日期',
    lcsj: '列车时间',
    fgs: '发公司',
    dgs: '到公司',
    djcz: '登记车站',
    djrq: '登记日期',
    zt: '中铁',
    lt: '老铁'
  },
  register: {
    md: '磨丁',
    nd: '纳堆',
    lblb: '琅勃拉邦',
    wxn: '万象南',
    qyxx: '企业信息',
    qyzcmc: '企业注册名称',
    wljlqyda: '为了建立企业档案，以及商贸交易平台企业展示，请详细填写企业简介。',
    xyb: '下一步',
    qy: '企业',
    gr: '个人',
    scsfz: '上传身份证',
    tjrmx: '添加人面像',
    tjfrmx: '添加非人面像',
    dlmm: '登录密码',
    wsqyxxh: '完善企业信息后，可享受以下服务：',
    gdxwzx: '更多新闻资讯',
    tbysxq: '提报运输需求',
    ydyszy: '预定运输资源',
    hwqcgz: '货物全程追踪',
    bjgt: '便捷沟通，优质服务',
    yhxx: '用户信息',
    gly: '管理员',
    zhcy: '综合企业',
    cmqy: '产煤企业',
    hmqy: '耗煤企业',
    xjqyxx: '新建企业信息',

    yhzc: '用户注册',
    zcwtgxg: '注册未通过信息修改',
    gryh: '个人用户',
    qyyh: '企业用户',
    zcshwtg: '注册审核未通过',
    ljxg: '立即修改',
    ckshwtgyy: '查看审核未通过原因',
    txqyjbxx: '填写企业基本信息',
    sczjzl: '上传证件资料',
    txjbrxx: '填写经办人信息',
    xzfwcz: '选择服务车站',
    hz: '货主',
    hd: '货代',
    frzjlx: '法人证件类型',
    sfz: '身份证',
    huzhao: '护照',
    djsc: '点击上传',
    clsm: '材料说明',
    zjlx: '证件类型',
    fsyzm: '发送验证码',
    fwcz: '服务车站',
    fwcztext: '请选择服务车站，当线上审核完成后，需携带相关材料前往该车站完成线下确认审核。',
    tj: '提交',
    txgrjbxx: '填写个人基本信息',
    cksl: '查看示例',
    zcxxtjcg: '注册信息提交成功',
    zcjg1: '线上审核结果将在48小时之内通过手机短信/邮件方式发送至',
    zcjg2: '手机/邮箱，请注意查收！',
    zcsj: '注册手机',
    jbr: '经办人',
    qd: '确定',
    apptext: '货运综合服务APP',
    apptext1: '为了提升您的货运业务办理体验，请扫描上方二维码，下载货运综合服务APP',
    qyxxxg: '企业信息修改',
    jbrsjh: '经办人手机号',
    zcmm: '注册密码',
    yzm: '验证码',
    grxxxg: '个人注册信息修改',
    khfwxy: '客户服务协议',
    ji: '及',
    ysqzc: '隐私权政策',
    sltp: '示例图片',
    qxzyxgdyhlx: '请选择要修改的用户类型',
    qtxqymc: '请填写企业名称',
    qtxtyshxydm: '请填写统一社会信用代码',
    qtxqyyyzzhm: '请填写企业营业执照号码',
    qtxzczj: '请填写注册资金',
    qxzzczjbz: '请选择注册资金币种',
    qxzsshy: '请选择所属行业',
    qxzjjxz: '请选择经济性质',
    qtxjjxzms: '请填写经济性质描述',
    qxzqyxz: '请选择企业性质',
    qxzjglx: '请选择机构类型',
    qtxjyfw: '请填写经营范围',
    qtxfddbr: '请填写法定代表人',
    qxzfrzjlx: '请选择法人证件类型',
    qxzfrgj: '请选择法人国籍',
    qtxfrsfzhm: '请填写法人身份证号码',
    qxzfrsfzyxq: '请选择法人身份证有效期',
    qtxfrhzhm: '请填写法人护照号码',
    qxzfrhzyxq: '请选择法人护照有效期',
    sshy1: '农、林、牧、渔业',
    sshy2: '采矿业',
    sshy3: '制造业',
    sshy4: '电力、燃气及水的生产和供应业',
    sshy5: '建筑业',
    sshy6: '交通运输、仓储和邮政业',
    sshy7: '信息传输、计算机服务和软件业',
    sshy8: '批发和零售业',
    sshy9: '住宿和餐饮业',
    sshy10: '金融业',
    sshy11: '房地产业',
    sshy12: '租赁和商务服务业',
    sshy13: '租赁和科学研究、技术服务和地质勘查业商务服务业',
    sshy14: '水利、环境和公共设施管理业',
    sshy15: '居民服务和其他服务业',
    sshy16: '教育',
    sshy17: '卫生、社会保障和社会福利业',
    sshy18: '文化、体育和娱乐业',
    jjxz1: '私营企业',
    jjxz2: '国有企业',
    jjxz3: '混合所有制企业',
    jjxz4: '集体企业',
    jjxz5: '其他',
    jjlx1: '企业法人',
    jjlx2: '企业非法人',
    jjlx3: '事业法人',
    jjlx4: '事业非法人',
    jjlx5: '社团法人',
    jjlx6: '社团非法人',
    jjlx7: '机关法人',
    jjlx8: '机关非法人',
    jjlx9: '个体',
    jjlx10: '工会法人',
    jjlx11: '民办非企业组织',
    jjlx12: '其他类型',
    qscyyzz: '请上传营业执照',
    qscwtzm: '请上传委托证明',
    qxzyzzzyxq: '请选择营业执照有效期',
    qscfrsfzzmzp: '请上传法人身份证正面照片',
    qscfrsfzbmzp: '请上传法人身份证背面照片',
    qscfrscsfzzp: '请上传法人手持身份证照片',
    qscfrhzxxyzp: '请上传法人护照信息页照片',
    qscfrschzxxyzp: '请上传法人手持护照信息页照片',
    qxzymzzzmyxq: '请选择运煤资质证明有效期',
    qxztdzzwsyxq: '请选择替代种植文书有效期',
    qxztksydzmyxq: '请选择铁矿石移动证明有效期',
    qxzjzxxxyxq: '请选择集装箱使用协议有效期',
    yxqnycdnfwd: '有效期不能超过当年范围',
    ksrqdnyxqjsrq: '开始日期不能晚于结束日期',
    jsrqdnyxqksrq: '结束日期不能早于开始日期',
    qxjzxxxyxq: '请选择集装箱协议有效期',
    qxzscclyxq: '请选择上传材料有效期',
    qtxscclms: '请填写上传材料描述',
    qtxxm: '请填写姓名',
    qxzgj: '请选择国籍',
    qxzzjlx: '请选择证件类型',
    qtxsfzhm: '请填写身份证号码',
    qxzsfzyxq: '请选择身份证有效期',
    qtxhzhm: '请填写护照号码',
    qxzhzyxq: '请选择护照有效期',
    qtxdlmm: '请填写登录密码',
    qtxqrmm: '请填写确认密码',
    lcsrdmmbyz: '两次输入的密码不一致',
    qxzdhgjqh: '请选择电话国际区号',
    qsrsjh: '请输入手机号',
    sjhyzc: '手机号已注册',
    qsryzm: '请输入验证码',
    qscsfzzmzp: '请上传身份证正面照片',
    qscgrscsfzzmzp: '请上传个人手持身份证正面照片',
    qschzxxyzp: '请上传护照信息页照片',
    qscgrschzxxyzp: '请上传个人手持护照信息页照片',
    qxzfwcz: '请选择服务车站',
    qtxzcmm: '请输入注册密码',
    tis0: '该账号无注册信息或检查填写信息是否有误',
    tis1: '上传图片只能是 JPG、JPEG、BMP、PNG 格式!',
    tis2: '上传图片大小不能超过 5MB!',
    tis3: '上传图片只能是 JPG、JPEG、BMP、PNG、DOC/DOCX、TXT、PDF 格式!',
    frdbsfzzmzp: '法人代表身份证正面照片',
    frdbsfzbmzp: '法人代表身份证背面照片',
    frdbscsfzzm: '法人代表手持身份证正面照片',
    frdbhzzp: '法人代表护照信息页照片',
    frdbschzzp: '法人代表手持护照信息页照片',
    text1: '欢迎注册!',
    text2: '请选择您要注册的用户类型',
    text3: '注册',
    text4: '企业',
    text5: '个人',
    text6: '去注册',

    yzx: '已知晓',
    ycxzdtj5wj: '一次性最多添加5个文件',
    cksltip1: '请上传原件的照片或扫描照片，并保证照片清晰可见',
    cksltip2: '下载委托证明模板后，打印并加盖企业公章，扫描或拍照上传',
    sfjbr: '是否经办人',
    zccghts: '注册成功后，经办人负有维护企业信息、申请/审核服务代理、添加其他经办人等职责。',
  },
  jkck: {
    jjsj: '交接时间',
    gd: '股道',
    hybx: '货运保险',
    hccljjd: '货车车辆交接单',
    cxdh: '查询单号',
    be: '保额',
    bf: '保费',
    zc: '正常',
  },
  reg: {
    qsrqymc: '请输入2-50位企业名称',
    qxzshj: '请选择审核局',
    qydz: '请输入4-100位企业地址',
    qylx: '请勾选企业类型',
    qyjj: '请输入企业简介',
    qsrzqsz: '请输入正确的1-20位数字',
    qsrmc: '请输入4-50位名称',
    qsrljdz: '请输入1-50位链接地址',
    qsrqydh: '请输入企业电话',
    qsryx: '请输入以com或com.cn结尾的正确的电子邮箱',
    qsrzh: '请输入2-20位纯字母或纯数字或者数字加字母组合',
    qxzssqy: '请选择所属企业',
    qxzyhjs: '请选择用户角色',
    qsrxm: '请输入2-20位姓名',
    qxzjglx: '请选择机构类型',
    qzcsrmm: '请再次输入密码',
    qscyyzz: '请上传营业执照',
    qscjg: '请上传组织机构代码证',
    qscsw: '请上传税务登记证',
    qsclogo: '请上传企业的LOGO',
    qsctp: '请上传大小小于2M的图片',
  },
  header: {
    xxzx: '消息中心',
    yjjc: '预警决策',
    ngxt: '内管系统',
    czsc: '操作手册',
    sz: '设置',
    tc: '退出',
    zc: '注册',
  },
  consultation: {
    chengshi: '城市',
    zm: '站名',
    czjj: '车站简介',
    yyzdz: '营业站地址',
    slfwdh: '受理服务电话',
    bllbmc: '办理类别名称',
    jij1: '基价1',
    jij2: '基价2',
    bz: '标准',
    hwzxjzfl1: '货物装卸基准费率(元/吨)',
    czzxfl: '车站装卸费率',
    smzxfl: '上门装卸费率',
    bjfl: '保价费率%',
    xh: '序号',
    sfbz: '收费标准',
    sfxm: '收费项目',
    sfyj: '收费依据',
    czcx: '车种车型:',
    qxzczcx: '请选择车种车型',
    zz: '自重(t):',
    qtxzz: '请填写自重',
    zaiz: '载重(t):',
    qtxzaiz: '请填写载重',
    czdm: '车种代码',
    zs: '轴数',
    syyxsd: '商业运行速度(km/h)',
    yxrj: '有效容积(m³)',
    clzdkg: '车辆最大（宽×高）(mm)',
    cnckg: '车内（长×宽×高）(mm)',
    ctcz: '车体材质',
  },
  trackStateQuery: {
    wlgs_wpdMsg: '当前接取送达单未派单，请先派单后再继续打印提箱单！',
    wpdMsg: '物流公司未派单，请先联系物流公司！',
    dqwz: '当前位置',
    track: '全路追踪',
    blztcx: '办理状态查询',
    qsr: '请输入',
    qxz: '==请选择==',
    xqh: '需求号',
    qsrxqh: '请输入需求号',
    zcrq: '装车日期',
    ksrq: '开始日期',
    zhi: '至',
    jsrq: '结束日期',
    hwmc: '货物名称',
    qsrhwmc: '请输入货物名称',
    tyr: '托运人',
    fz: '发站',
    zcdd: '装车地点',
    zyx: '专用线',
    tlhc: '铁路货场',
    shr: '收货人',
    dz: '到站',
    xcdd: '卸车地点',
    ch: '车号',
    xh: '箱号',
    fkfs: '付款方式',
    yck: '预存款',
    xj: '现金',
    zhip: '支票',
    yhk: '银行卡',
    hzzf: '汇总支付',
    ydh: '运单号',
    zdsj: '制单时间',
    kssj: '开始时间',
    jssj: '结束时间',
    ydlx: '运单类型',
    gjly: '国际联运',
    ptys: '普通运输',
    zfzt: '支付状态',
    dzf: '待支付',
    yzhif: '已支付',
    zfz: '支付中',
    yjs: '已结算',
    ydzt: '运单状态',
    dsl: '待受理',
    dddsl: '待调度受理',
    sltg: '受理通过',
    slwtg: '受理未通过',
    yzc: '已装车',
    yzd: '已制单',
    yfc: '已发车',
    ydd: '已到达',
    yxc: '已卸车',
    hwyjf: '货物已交付',
    yzuof: '已作废',
    chax: '查询',
    qingk: '清空',
    syrxqcx: '使用日需求查询',
    zhank: '展开',
    shouq: '收起',
    zj: '总计',
    t: '条',
    ckxq: '查看详情',
    ybg: '已变更',
    chak: '查看',
    bgdz: '变更到站',
    pldy: '批量打印',
    daochu: '导出',
    yyh: '预约号',
    ddmlh: '调度命令号',
    bgyqr: '变更要求人',
    xshr: '新收货人',
    xdaoz: '新到站',
    bgyy: '变更原因',
    sctp: '上传图片',
    qd: '确 定',
    zdsctp3: '最多上传三张图片',
    ydxx: '运单信息',
    bllb: '办理类别',
    yslx: '运输类型',
    fhxx: '发货信息',
    tuoyf: '托运方',
    txdz: '通信地址',
    dianh: '电话',
    fj: '发局',
    rxsjz: '入线时间（装）',
    kzsj: '开装时间',
    zwsj: '装完时间',
    cxsjz: '出线时间（装）',
    shxx: '收货信息',
    shouhf: '收货方',
    daoj: '到局',
    rxsjx: '入线时间（卸）',
    kxsj: '开卸时间',
    xwsj: '卸完时间',
    cxsjx: '出线时间（卸）',
    jfsjx: '交付时间（卸）',
    hwxx: '货物信息',
    hwjs: '货物件数',
    hwtz: '货物特征:',
    sfh: '施封号',
    pbh: '篷布号',
    hwms: '货物描述',
    ysxx: '运输信息',
    chez: '车种',
    chengz: '成组',
    dzbg: '电子变更',
    jzsx: '记载事项',
    bx: '保险',
    zffs: '支付方式',
    bz: '币种',
    dzzfyhfzf: '到站杂费由何方支付',
    back: '返回',
    zt: '状态',
    ytb: '已提报',
    dccg: '订车成功',
    dcwcg: '订车未成功',
    qcfs: '请车方式',
    crxq: '次日需求',
    bcxq: '补充需求',
    yunf: '运费',
    fksj: '付款时间',
    fccc: '发车车次',
    fcsj: '发车时间',
    dzsj: '到站时间',
    jfsj: '交付时间',
    ddmlm: '调度命令码',
    cyrqdzl: '承运人确定重量（kg）',
    cyjs: '承运件数',
    slh: '受理号',
    hwpl: '货物品类',
    xqcs: '需求车数',
    xqds: '需求吨数',
    dccgs: '订车成功车数',
    dccgds: '订车成功吨数',
    wccs: '完成车数',
    ystz: '运输特征',
    tbsj: '提报时间',
    tbqy: '提报企业',
    quanx: '全选',
    zhanwusj: '暂无数据',
    caoz: '操作',
    qxzyd: '请选择运单',
  },
  trackGlyd: {
    ytblb: "已提报列表",
    wdyxq: "我的月需求",
    fzdm: "发站代码",
    ddldm: "到达路代码",
    dzdm: "到站代码",
    cyrjc: "承运人简称",
    ffdm: "付费代码",
    zfrmc: "支付人名称",
    jianc: "简称",
    qidian: "起点",
    zhongdian: "终点",
    daima: "代码",
    wjlx: "文件类型",
    fenshu: "份数",
    wwmc: "外文名称",
    wjhm: "文件号码",
    bzrq: "编制日期",
    djyshtdrq: "缔结运输合同的日期",
    glhwzz: '国联货物追踪',
    ckyd: '出口运单',
    jkyd: '进口运单',
    chax: '查询',
    qingk: '清空',
    zhank: '展开',
    shouq: '收起',
    ckgj: '查看轨迹',
    hwgj: '货物轨迹',
    hwjz: '货物进站',
    zche: '装车',
    fche: '发车',
    zait: '在途',
    dz: '到站',
    xche: '卸车',
    xqh: '需求号',
    fz: '发站',
    tuoyf: '托运方',
    ch: '车号',
    ydh: '运单号',
    shouhf: '收货方',
    hwmc: '货物名称',
    chuj: '出境',
    yjddsj: '预计到站时间',
    yjsylc: '预计剩余里程',
    back: '返回',
    pjlx: '票据类型',
    dzpj: '电子票据',
    dzhp: '电子货票',
    dzyzf: '电子运杂费',
    glyd: '国联运单',
    ydhbcz: '运单号不存在',
    qb: '全部',
    dy1: '第一联',
    dy2: '第二联',
    dy3: '第三联',
    dy4: '第四联',
    dy5: '第五联',
    dy6: '第六联',
    dy7: '第七联',
    dy: '打印',
    zprq: '制票日期',
    ksrq: '开始日期',
    zhi: '至',
    jsrq: '结束日期',
    gjz: '国境站',
    bllx: '办理类型',
    qsr: '请输入',
    qxz: '==请选择==',
    zhengc: '整车',
    jzx: '集装箱',
    xh: '箱号',
    mdj: '磨丁(境)',
    qxzzprq: '请选择制票日期',
    qxzgjz: '请输入国境站',
    xh1: '箱号:',
    xx: '箱型:',
    xl: '箱类:',
    ziz: '自重:',
    yyh: '预约号',
    xqdh: '需求单号',
    tbrq: '提报日期',
    ph: '批号',
    ydzt: '运单状态',
    dsl: '待受理',
    dddsl: '待调度受理',
    sltg: '受理通过',
    slwtg: '受理未通过',
    yzp: '已制票',
    zjf: '已交付',
    yzc: '已装车',
    yzd: '已制单',
    yfc: '已发车',
    ydd: '已到达',

    yddkaz: '已到达口岸站',
    ycj: '已出境',
    mdrj: '磨丁入境',

    yxc: '已卸车',
    hwyjf: '货物已交付',
    yzuof: '已作废',
    bllb: '办理类别',
    fhr: '发货人',
    daoj: '到局',
    tbqy: '提报企业',
    jzxxx: '集装箱信息',
    slbtgyy: '受理不通过原因',
    hggj: '海关过境',
    kadl: '口岸代理',
    jianshu: '件数',
    hwzl: '货物重量',
    hth: '合同号',
    tyfjs: '托运方记事',
    xcdd: '卸车地点',
    lxfs: '联系方式',
    md: '磨丁',

    yrj: '已入境',
    fzw: '发站为',
    ccw: '车次为',
    hwjg: '货物经过',
    dzw: '到站为',
    xqdhbcz: '需求单号不存在',


  },
  trackGoods: {
    hwddyc: '货物到达预测',
    fdlx: '发到类型',
    fh: '发货',
    shouh: '收货',
    dz: '到站',
    shouhf: '收货方',
    xcdd: '卸车地点',
    ydsj: '预到时间',
    hwmc: '货物名称',
    chez: '车种',
    ksrq: '开始日期',
    qsr: '请输入',
    qxz: '==请选择==',
    zyx: '专用线',
    tlhc: '铁路货场',
    guanc: '罐车',
    pengc: '棚车',
    changc: '敞车',
    pingc: '平车',
    lengcc: '冷藏车',
    jzxc: '集装箱车',
    kuangsc: '矿石车',
    changhdwc: '长货大物车',
    dupc: '毒品车',
    jiacc: '家畜车',
    sanzlsc: '散装粮食车',
    tezc: '特种车',
    qit: '其他',
    qsrdz: '请输入到站',
    qsrshf: '请输入收货方',
    fz: '发站',
    tuoyf: '托运方',
    zcdd: '装车地点',
    qsrfz: '请输入发站',
    qsrfhf: '请输入发货方',
    hwpl: '货物品类',
    ches: '车数',
    hwyjddqk1: '站>',
    hwyjddqk: '站货物预计到达情况',
    nengy: '能源',
    kuangs: '矿石',
    gcqx: '钢材及器械',
    jzx: '集装箱',
    lsnf: '粮食及农副',
    shyp: '生活用品',
    qthzhw: '其他混装货物',
    chax: '查询',
    qingk: '清空',
    zhank: '展开',
    shouq: '收起',
    ckdt: '查看地图',
  },
  myMessage: {
    xxxq: '信息详情',
    qbxx: '全部消息',
    ysfw: '运输服务',
    daib: '待办',
    qb: '全部',
    yd: '已读',
    wd: '未读',
    back: '返回',
    title: '标题',
    sous: '搜索',
    plyd: '批量已读',
    plsc: '批量删除',
    sj: '时间',
    lx: '类型',
    title1: '此操作将永久删除该数据, 是否继续?',
    title2: '信息提示',
    yes: '是',
    no: '否',
    yqxsc: '已取消删除',
    czcg: '操作成功',
    sccg: '删除成功',
  },

  jzxwork: {
    qscwj: "请上传文件",
    dqscxz: "当前限制上传 10 个文件",
    cftpsc: "重复图片上传",
    qsczdgs: "请上传.jpg,.bmp,.jpeg,.png等图片格式照片",
    dytxd: "打印提箱单",
    txd: "提箱单",
    tip61: '到达日期',
    gdmc: '股道',
    tip380: '请输入股道名称',
    tip37: '全部车',
    swh: '顺位号',
    czch: '车种/车号',
    tip492: '需求单号1',
    tip493: '需求单号2',
    tip494: '需求单号3',
    tip431: '车次/班列',
    ddsj: '到达时间',
    xh3: '箱号3',
    tip343: '装车计划',
    rxsj: '入线时间',
    xzrxsj: '选择入线时间',
    xzkzsj: '选择开装时间',
    xzzwsj: '选择装完时间',
    rxbnzydd: '入线时间不能早于到达时间',
    kzbnzyrx: '开装时间不能早于入线时间',
    zwbnzykz: '装完时间不能早于开装时间',
    rxsjbnwk: '入线时间不能为空',
    kzsjbnwk: '开装时间不能为空',
    zwsjbnwk: '装完时间不能为空',
    qxzgd: '请选择股道',
    qdtjgxx: '确定提交该信息',
    tip163: '提交成功，请及时进行"出线确认"操作',
    tip5: '不可重复提交已装车的计划数据!!!',
    tip544: '请车批准',
    tip545: '请车未批准',
    tip200: '未选中数据！',
    tip272: '箱信息存在缺失！',
    tip351: '请不要选未批准需求单！',
    qbyxcfxh: '请不要选重复箱号！',
    tip378: '请输入箱号1！',
    tip211: '此车剩余空间不足装下该箱！',
    tip209: '此箱到站为【',
    tip2: '】与箱号1到站不一致！',
    tip210: '此箱号与箱号1重复！',
    tip212: '此车剩余空间不足！',
    qxzzsyt: '请选择至少一条记录',
    tip4: '不可撤销未提交的数据!!!',
    qdcxm: '确定撤销吗?',
    yqxcx: '已取消撤销',
    tip489: '集装箱装车计划',
    tip486: '集装箱卸车计划',
    tip416: '调入日期',
    tip501: '预接',
    ydh: '运单号',
    tip155: '承运重量',
    tip398: '请选择开始时间',
    tip410: '请选择结束时间',
    cxsj: '出线时间',
    tip395: '请选择出线时间',
    tip17: '作业类别',
    tip308: '类别1',
    tip393: '请选择作业类别',
    tip14: '作业方式',
    tip186: '方式1',
    tip392: '请选择作业方式',
    tip328: '装卸人',
    tip381: '请输入装卸人',
    tip230: '监装卸人',
    tip231: '监装卸人不能为空',
    tip375: '请输入监装卸人',
    tip331: '装卸工组',
    tip332: '装卸工组不能为空',
    tip383: '请输入装卸工组',
    tip66: '卸车',
    tip127: '开始时间不能早于入线时间',
    tip314: '结束时间不能早于开始时间',
    tip46: '出线时间不能早于结束时间',
    tip63: '到达时间不能为空',
    tip126: '开始时间不能为空',
    tip313: '结束时间不能为空',
    tip45: '出线时间不能为空',
    tip329: '装卸人不能为空',
    tip405: '请选择箱位！',
    tip240: '确定卸车吗?',
    tip48: '出线状态',
    tip498: '顺位',
    xzcxsj: '选择出线时间',
    lx: '类型',
    tip10: '件数',
    tip44: '出线时间不得早于装完时间',
    tip239: '确定出线确认吗?',
    tip115: '已取消操作',
    tip113: '已出线的数据不可重复提交!!!',
    tip49: '出线确认',
    tip82: '取票',
    tip568: '未出线',
    tip569: '已出线',
    tip318: '股道信息',
    ch: '车号',
    tip502: '预接车标志',
    tip438: '运单号3',
    tip427: '车型/种/号',
    tip418: '货物重量',
    tip35: '入线确认',
    tip197: '未匹配到装卸清单',
    tip140: '所选箱号重复',
    tip56: '到发别',
    tip396: '请选择到发别',
    tip104: '始发',
    tip310: '终到',
    tip467: '通知取车',
    wtz: '未通知',
    ytz: '已通知',
    tip468: '通知取车状态',
    tip522: '车站',
    tip327: '装/卸时间',
    tip413: '请选择需要通知的记录',
    tip354: '请先选择到发别',
    tip214: '清单',
    tip121: '已经成功通知，无需重复操作！',
    tip134: '当前箱',
    tip348: '记录缺少清单号，无法进行取车操作！',
    tip470: '通知成功',
    tip135: '当前记录已通知取车，无需重复操作！',
    tip136: '当前记录缺少清单号，无法进行取车操作！',
    tip469: '通知失败',
    lhrq: '领货日期',
    jssj: '结束时间',
    dxtzbz: '短信通知标志',
    cz: '重置',
    lhid: '领货ID',
    xxdh: '需求单号',
    shjbr: '收货经办人',
    shjbrdh: '收货经办人电话',
    fhjbr: '发货经办人',
    fhjbrdh: '发货经办人电话',
    tznr: '通知内容',
    tzfs: '通知方式',
    lhdh: '领货电话',
    xcsj: '卸车时间',
    zsxzytjl: '至少选择一条记录',
    qxzwtzsj: '请选择未通知的数据进行提交',
    ts: '提示',
    czcg: '操作成功',
    jflx: '交付类型',
    xsxh: '箱属箱号',
    txfs: '掏箱方式',
    sfhm: '施封号码',
    pszt: '破损状态',
    qxztxdd: '请选择掏箱地点！',
    qxzwjf: '请选择未交付的记录',
    hyid: '货运ID',
    yudh: '预定号',
    ydxs: '预订箱数',
    hsxs: '核实箱数',
    pxs: '配箱数',
    tdxs: '退订箱数',
    ytxs: '已提箱数',
    apkx: '预定空箱',
    pxsj: '配箱时间',
    lkzr: '落空责任',
    lkyy: '落空原因',
    tx: '退箱',
    hx: '换箱',
    zxdd: '装箱地点',
    tuid: '退订',
    khtxhx: '客户提箱--换箱',
    khtxtx: '客户提箱--退箱',
    ddh: '订单号',
    jzsj: '进站时间',
    yxxx: '原箱信息',
    xxxx: '新箱信息',
    qdtjtxd: '确定提交该提箱单信息',
    xzxhyw: '选择的箱号有误，请重新选择',
    xzxhbcz: '选择的箱号不存在，请重新选择',
    xhbncf: '箱号不能重复',
    xtdxsbx: '20英尺箱退订箱数必须为偶数',
    xtdxsbx1: "20英尺箱型必须是双数",
    qdtdcz: '确定退订操作吗?',
    qdtxm: '确定退箱吗?',
    xxhbncf: '新箱号不能与原箱号重复',
    qdhxm: '确认换箱吗?',
    qsrxqdh: '请输入需求单号',
    cyrzl: '承运人重量（千克）',
    tyrzl: '托运人重量（千克）',
    qsrxhzz: '请输入箱货总重',
    qsrtyrzl: '请输入托运人重量',
    qsrcyrzl: '请输入承运人重量',
    qsrsfh: '请输入施封号',
    jyyxc: '检验已卸车',
    qrtj: '确认提交吗?',
    qrxg: '确认修改吗?',
    xhzlbnwk: '箱货总重不能为空',
    tyrzlts: '托运人重量不能为空',
    cyrzlts: '承运人重量不能为空',
    xhzzts: '箱货总重不能小于承运人重量',
    sfhts: '施封号不能为空',
    kzxxlb: '可装信息列表',
    yznzxlb: '已站内装箱列表',
    fhdwmc: '发货单位名称',
    shdwmc: '收货单位名称',
    fzmc: '发站名称',
    dzmc: '到站名称',
    xlmc: '箱类名称',
    xsmc: '箱属名称',
    xxmc: '箱型名称',
    tip122: '已装箱列表无需重复装箱',
    tip190: '是否确定提交',
    zc: '装车',
    qxzxh1: '请选择箱号1',
    qxzxh2: '请选择箱号2',
    qxzxh3: '请选择箱号3',
    jg: '局管',
    fjg: '非局管',
    cxbnzyzw: '出线时间不能早于装完时间',
    dzmcbcz: '到站名称不存在，请重新选择',
    dzbnwk: '到站不能为空',
    dlhbnwk: '调令号不能为空',
    qdzcm: '确定装车吗?',
    qdcxdqhs: '确定要撤销当前回送装车记录吗?',
    tip221: '的箱号1与箱号2相同',
    tip222: '的箱号1与箱号3相同',
    tip223: '的箱号1与顺位号',
    tip224: '的箱号1相同',
    tip225: '的箱号2与箱号3相同',
    tip226: '的箱号2与顺位号',
    tip227: '的箱号2相同',
    tip228: '的箱号3与顺位号',
    tip229: '的箱号3相同',
    tip199: '未添加任何箱号',
    xhbcz: '箱号不存在，请重新添加',
    wei: '为',
    wzcbktj: '为重车，不可进行提交!!!',
    tip323: '英尺通用箱，不能与',
    tip322: '英尺通用箱',
    tip334: '装在一起',
    tip92: '同一车只能装载通用20尺箱2个',
    clwls: '车辆未落实，不可进行装车',
    tip3: '不可撤销未出线的数据!!!',
    tip120: '已经卸完车，不可撤销!!!',
    tip564: '待检斤',
    tip565: '已检斤',
    tip566: '待外交付',
    tip567: '已外交付',
    jzxwjf: '集装箱外交付',
    zntx: '站内掏箱',
    tzqh: '通知取货',
    kxhs: '空箱回送',
    jjyh: '检斤验货',
    znzx: '站内装箱',
    txlr: '提箱录入',
    tip196: '未制票，不可进行出线操作',
    xhzz: '箱号追踪',
    xq: '详情',
    yianpai: '已安排',
    sbxhw: '接取送达公司对部分集装箱已派单，不允许撤销该部分集装箱的预约进站'
  },
  confirmationBill: {
    qrzt: '确认状态',
    dqr: '待确认',
    yqr: '已确认',
    qrpj: '确认票据',
    qztitle: '确定之后会自动为您签字及加盖印章，请您确认',
  },
  jqsd: {
    yssl: '运输量',
    dh: '单号',
    dpd: '待派单',
    ypd: '已派单',
    pdsj: '派单时间',
    pdzt: '派单状态',
    jqsdxq: '接取送达详情',
    cxpd: '重新派单',
    cxpdbnpl: '重新派单的数据不能批量提交',
    jqsdqrzt: '签认状态',
    yqr: '已签认',
    wqr: '未签认',
    qianren: '签认',
    qrsj: '签认时间',
    yxzt: '有效状态',
    wxnj: '万象南(境)',
    hscl: '货损处理',
    plzf: '批量作废',
    slzx: '受理中心',
    qxzslcz: '请选择受理车站',
    slcztext: '请选择受理车站，当线上审核完成后，需携带相关材料前往该车站完成线下确认审核。',
    q7tndlxt: '请7天内登录系统查看审核进度',
    qxdzzwjjxsh: "请携带注册时上传的所有附件的纸质文件，到受理中心进行审核",
    shjd: '审核进度',
    wcsj: '完成时间',
    jg: '结果',
    sjzt: '数据状态',
    czry: '操作人员',
    wwc: '未完成',
    ygx: '已更新',
    zjygx: '证件已更新',
    qxg: '去修改',
    scxy: "上传协议",
    frsfz: '法人身份证',
    frhz: '法人护照',
    jbrhz: '经办人护照',
    yfkxy: '预付款协议',
    yfkxysy: '预付款协议首页照片',
    qscyfkxysy: '请上传预付款协议首页照片',
    yfkxywy: '预付款协议双方盖章页照片',
    qscyfkxywy: '请上传预付款协议双方盖章页照片',
    yfkxyyxq: '预付款协议有效期',
    qxzyfkxyyxq: '请选择预付款协议有效期',
    cxtb: "重新提报",
    xgrqyyrqyz: "修改的日期与原日期一致",
    tddjj: "提报调度拒绝",
    jjnr: "拒绝内容",
    xgnr: "修改内容",
    jsrqdayksrq: "结束日期必须大于开始日期",
    gwjbspdf: "该文件不是pdf格式，不支持预览",
    xglc: "修改里程",
    wlgsjjzt: "物流公司拒绝状态"
  },
  wtlh: {
    qxzqh: "请选择区号",
    qh: "区号",
    czslzt: "车站受理状态",
    wtlh: '委托领货',
    lhcz: '领货车站',
    cxdlhw: '查询代领货物',
    lhphone: '领货手机号',
    jbrzjz: '经办人证件照',
    dlhw: "待领货物",
    qsc: '请上传',
    qtwj: '其他文件',
    benren: '本人',
    weituo: '委托',
    dqxzsc1: '当前限制上传 1 个文件',
    zhuxiao: "注销",
    qdzxdqzhm: "确定注销当前账户吗？",
    zcqrzxdqzh: '注销会删除当前企业用户，且无法登录，是否确认？',
    cgnzfbxyfydsj: "此功能作废的是不需要发运的订箱数据，请再次确认！",
    czyxglyd: "存在有效状态的国联运单,不允许作废",
    zuid8ws: "最少8位数字",

    zdtj: "折叠条件",
    gdtj: "更多条件",
    dl: "登录"
  },
  guide: {
    czsdbgwjsj: "车站收到报告文件时间",
    jsqOnly: "仅办理JSQ",
    gccyOnly: "仅办理到达20英尺罐式集装箱装运的柴油"
  },
  jqsdtj: {
    yilian: '乙联',
    binglian: '丙联',
    dywlpsd: '打印物流配送单',
    wlpsd: "物流配送单",
    pddw: "派单单位",
    pdr: "派单人",
    pdsj: "派单时间",
    jhsj: "交货时间",
    khdw: "客户单位",
    sqhxxdz: "送(取)货详细地址",
    gls: "公里数",
    cxch: "车型车号",
    gbdd: "过磅地点",
    qhshwzk: "取货时货物状况",
    jhshwzk: "交货时货物状况",
    zxap: "装卸安排",
    hwysyq: "货物运输要求",
    wtqcysgs: "委托汽车运输公司",
    khdfwzlpj: "客户对服务质量评价",
    fcmy: "非常满意",
    my: "满意",
    bmy: "不满意",
    yr: "易燃",
    yb: "易爆",
    ys: "易碎",
    ps: "怕湿",
    yw: "异味",
    yc: "扬尘",
    jzfg: "禁止覆盖",
    jzzy: "禁止重压",
    zzfx: "装载方向",
    fzhd: "防止滑动",
    fzpz: "防止碰撞",
    hwjfr: "货物交付人",
    jsy: "驾驶员",
    fwlgs: '发物流公司',
    dwlgs: '到物流公司',
    tks: "铁矿石",
    tks1: "铁矿砂",
    tkf: "铁矿粉",
    tjk: "铁精矿",
    tjkf: "铁精矿粉",
    qttks: "其他铁矿石"

  },
  zcxz: {
    zcxz1: "老中铁路国际物流平台注册须知",
    zcxz2: "欢迎您注册成为老中铁路国际物流平台用户！在您开始注册之前，请仔细阅读以下内容，以了解我们的服务和用户权责。",
    zcxz3: "用户注册和登录",
    zcxz4: "您必须年满19岁或根据您所在国家/地区的法律规定达到法定年龄，才能进行用户注册。您需要提供准确、完整和真实的企业或个人信息，并确保及时更新以保持信息的准确性。",
    zcxz5: "注册所需材料：",
    zcxz6: "个人用户：姓名、国籍、通信地址、身份证/护照号码及有效期、手机号、邮箱、身份证正面/护照信息页照片、个人手持身份证正面/护照信息页照片。",
    zcxz7: "企业用户：企业名称、企业税号、营业执照编号、注册资金、所属行业、经济性质、企业性质、机构类型、企业银行账户、开户行、企业电话、企业邮箱、经营范围、企业地址、法人姓名、法人国籍、法人身份证/护照号码及有效期、上级公司名称、上级公司税号、上级公司营业执照编号、营业执照图片及有效期、法人身份证正面/护照信息页照片、法人手持法人身份证正面/护照信息页照片、资质正面材料图片及有效期、委托证明图片及有效期（当法人不是经办人时需提交）、经办人姓名、经办人国籍、经办人通信地址、经办人身份证/护照号码及有效期、经办人手机号、经办人邮箱、经办人身份证正面/护照信息页照片、经办人手持身份证正面/护照信息页照片。",
    zcxz8: "注册流程：",
    zcxz9: "个人用户：1、填写个人基本信息；2、选择服务车站；3、通过线上审核；4、携带注册材料完成线下确认。",
    zcxz10: "企业用户：1、填写企业基本信息；2、上传证件资料；3、填写经办人信息；4、选择服务车站；3、通过线上审核；4、携带注册材料及企业公章完成线下确认。对于企业用户，您需要提供唯一的经办人信息，一旦注册成功，该经办人则具备该企业货运业务办理的全部权限。",
    zcxz11: "登录流程：",
    zcxz12: "个人用户：登录界面输入注册手机号和注册密码，完成首次登录。",
    zcxz13: "企业用户：登录界面输入经办人手机号和注册密码，完成首次登录。",
    zcxz14: "账户安全",
    zcxz15: "您有责任保护您的账户安全，请设置长度为8-15位，包括数字、大小写字母的密码，并定期更改密码。",
    zcxz16: "请妥善保管您的账户信息，并不要与他人分享或泄露。如发现任何异常或疑似未授权使用您的账户，请立即联系官方电话。",
    zcxz17: "用户权益",
    zcxz18: "作为注册用户，在相关证件及证明的有效期内，您享有办理货运服务的权益，相关详情请阅读《老中铁路货运办理平台客户服务协议》。",
    zcxz19: "我们将严格保护您的个人信息，并遵循适用的隐私政策和法律规定。",
    zcxz20: "用户责任",
    zcxz21: "您有责任对使用您的账户进行的所有活动承担全部责任。",
    zcxz22: "您不得利用账户从事任何非法、违规或侵犯他人权益的行为",
    zcxz23: "请遵守平台的使用规范和行为准则，维护平台的正常运营。",
    zcxz24: "隐私政策",
    zcxz25: "我们的《隐私权政策》详细说明了我们如何收集、使用、存储和保护您的个人信息。请阅读《隐私权政策》，了解您的个人信息如何被处理和使用。",
    zcxz26: "联系方式",
    zcxz27: "若您有其他任何意见和建议，请联系856-2026887846。",
    cyjbr: "常用经办人",
    sfblzcyw: "是否办理整车业务",
    sfbljzxyw: "是否办理集装箱业务",
    sfswxp: "是否是危险品",
    lfm: "立方米",
    dun: "吨",
    xj: "橡胶",
    lseahf: "磷酸二铵(化肥)",
    sf: "薯粉",
    ms: "木薯",
    tks: "铁矿石",
    tksha: "铁矿砂",
    dg: "带钢",
    xsg: "鲜水果",
    ly: "龙眼",
    xsc: "鲜蔬菜",
    lwg: "螺纹钢",
    scwj: "上传文件",
    spxs: '审批箱数',
    hyz: '货运站',
    zdqznl: "最大起重能力",
    ccqznl: "叉车起重能力",
    jzxqznl20: "20英尺集装箱起重能力",
    jzxqznl40: "40(45)英尺集装箱起重能力",
    hwzzxdbjzz: "箱货总重必须小于等于标记总重",
    blfw: "办理范围",
    zcblfw: '整车办理范围',
    blfspl: "办理发送品类",
    blddpl: "办理到达品类",
    bblfspl: "不办理发送品类",
    bblddpl: "不办理到达品类",
    blhwtz: '办理货物特征',
    cz: "超重",
    cx: '超限',
    jzxblfw: "集装箱办理范围",
    ycx20: "20英尺箱",
    ycx40: "40(45)英尺箱",
    gsx20: '20英尺干散箱',
    sng20: "20英尺水泥罐式箱",
    ytg20: '20英尺液体罐式箱',
    lqg20: '20英尺石油沥青罐式箱',
    jgx20: '20英尺台架式卷钢箱',
    tcd35: "20英尺35t敞顶箱",
    wxpblfw: '危险品办理范围',
    fspm: "发送品名",
    ddpm: "到达品名",
    xxxx: '详细信息',
    yidao: '已到',
    cong: '从',
    dao: '到',
    dydy0dzs: "请输入大于等于0的整数",
    yty: "已同意",
    ysx: '已失效',
    qxmr: '取消默认',
    ddmfzf: "等待买方支付",
    qrsh: '确认收货',
    ddmfqrsh: "等待买方确认收货",
    jiaofu: '交付',
    ckjgd: '查看交割单',
    smzx: '上门装箱',
    wl_zdm: '物流-站到门',
    smtx: '上门掏箱',
    max40000: '最大值限制为40000kg',
    ydyjtjbnxg: '运单一经提交，不能修改，您确认提交？',
    ydgxcg: "运单更新成功",
    qxzybgdsj: "请选择要变更到站的数据!",
    lpxx: "理赔信息",
    pctzs: '赔偿通知书',
    tpcg: "提赔成功",
    myd: '满意度',
    jicha: "极差",
    shiwang: "失望",
    yiban: "一般",
    chaozan: "超赞",
    tipei: "提赔",
    wstpxz: "网上提赔须知",
    cxhyjl: "查询货运记录",
    tjlpsqs: "提交理赔申请书",
    tpsqcg: '提赔申请成功',
    hyjlbzzjhm: "货运记录编制站及号码：",
    kuche: '库车，王家营192839，1929384',
    tpr: "提赔人(单位或姓名)",
    yqpcke: "要求赔偿款额(元)",
    xxtxdz: "详细通信地址",
    lkfs: "领款方式",
    yhzzzf: '银行转账支付',
    czlqxj: "车站领取现金",
    skr: "收款人(单位或姓名)",
    skyh: "收款银行",
    skzh: "收款账号",
    qxzslz: "请选择受理站",
    zysx: "注意事项",
    zysx1: "填写内容应清楚、准确。",
    zysx2: "提赔单位、姓名必须与货物运单或快运货票记载的收货方或托运方相符。",
    zysx3: "领款方式选择“银行转账支付”，收款人（单位或姓名）、收款银行、收款账号信息必须填写完整。",
    zysx4: "建议您上传理赔的相关资料，并确保资料真实、有效，网上提交资料将加快理赔办理进度。",
    zysx5: "您提交的相关资料仅用于本次理赔办理，我们承诺不会向第三方提供。",
    dlm: "动力煤",
    ljm: "炼焦煤",
    wym: "无烟煤",
    pcm: "喷吹煤",
    kmei: "块煤",
    lant: "兰炭",
    lplc: "理赔流程",
    spxz: "索赔须知",
    spxz1: '尊敬的客户：',
    spxz2: "在铁路运输过程中，货物发生灭失、短少或者损坏，您可自领到货运记录的次日起180日内，向到站或发站提出赔偿要求。 如果货物超过运到期限，经过30日铁路部门仍不能向您交付货物时，您可以按货物灭失向到站或发站提出赔偿要求。 下列原因造成的货物损失,铁路不承担赔偿责任:",
    spxz3: "1.不可抗力;",
    spxz4: "2.货物本身的自然属性或者合理损耗;",
    spxz5: "3.托运方、收货方或押运人的过错。",
    spxz6: "您向铁路提出赔偿要求时，请准确、清楚填写《理赔申请书》，其中提赔单位、姓名必须与货物运单记载的收货方或托运方相符。需转账的，提供的开户行、户名和账号信息必须一致。同时，还需提供以下证明材料：",
    spxz7: "1.货运记录（货主页）原件;",
    spxz8: "2.货物运单原件;",
    spxz9: "3.物品清单（发站没有填制的除外);",
    spxz10: "4.其他必要的证明材料。",
    spxz11: '如委托他人代理时，还须提供委托书、委托人和被委托人的身份证明复印件。',
    spxz12: '办理保价运输的货物，全批货物损失时，赔偿金额最高不超过保价金额；部分损失时，赔偿金额按损失货物占全批货物的比例乘以保价金额赔偿。',
    spxz13: "未办理保价运输的货物，按照实际损失赔偿，但最高不超过规定的赔偿限额。",
    spxz14: '办理保险运输的货物，您可凭车站出具的货运记录，按照保险合同的约定，到保险公司办理赔偿。',
    spxz15: "您在网上提出赔偿要求时，如您已在到站领取货运记录，请您提供货运记录货主页原件的清晰扫描件或照片。",
    spxz16: "如您委托他人代理时，还须提供委托书、委托人和被委托人的身份证明原件的清晰扫描件或照片。",
    spxz17: "您所提交的资料应真实有效。铁路部门将对您提供的资料进行审核。",
    spxz18: '如您需要详细了解有关货物损失赔偿方面的具体事宜，请与车站联系。',
    bty: "不同意",
    lptzs: "理赔通知书",
    hao: "号",
    guanyu: "关于",
    you: "由",
    zcyd: "站承运到",
    hydh: "货运单号",
    fasheng: '发生',
    hwsspcyqry: '货物损失，赔偿要求人于',
    yqtlpc: "要求铁路赔偿",
    yiche: "一车，",
    yu: "于",
    sljshtypc: "受理，经审核同意赔偿",
    lqcz: "领取车站",
    skrdwhxm: "收款人（单位或姓名）",
    bclpdmyd: "本次理赔的满意度",
    sfyjtzs: '是否邮寄通知书',
    youji: "邮寄",
    buyouji: "不邮寄",
    jinyi: "建议",
    qtcchdl: "请退出重新登录",
    yhzz: "银行转账",
    czlxj: "车站领现金",
    buchong: "补充",
    sbd: "所编第",
    jilu: "记录",
    yshm: "运输号码",
    chengyun: "承运",
    zcdw: '装车单位',
    xcdw: '卸车单位',
    chezlx: "车种类型",
    clcdd: "次列车到达",
    ksxc: '开始卸车',
    xiewan: '卸完',
    fysfdw: "封印：施封单位",
    sfbh: "施封编号",
    pbpbhm: '篷布：篷布号码',
    baojia: "保价",
    xiangmu: "项目",
    cyf: "承运方",
    pjyjz: '票据原记载按照实际货物损失详细情况',
    gcrxhjh: "该车入线货检好，封施有效，开启车门卸见上货码7-9个高，实卸1153件，较王家营站2015年2月9日编1545101号货运记录实装1160件不足7件，车容未满，能容少件，全车卸空无残。",
    cjrqz: "参加人签章",
    czfzr: "车站负责人",
    bzr: "编制人",
    gary: "公安人员",
    qtry: "其他人员",
    zhuangxie: "装卸",
    fengyin: '封印',
    jfhwsshryj: "交付货物时收货人意见",
    yijian: "意见",
    kmtlj: "昆明铁路局",
    bianzhi: "编制",
    qsrzqcxtj: "请输入正确的查询条件",
    lingtan: "零摊",
    htgl: '合同管理',
    ptslzt: "平台受理状态",
    qxzxthwmcsh: '请选择相同货物名称数据',
    qxzxthwfwsh: '请选择相同货物范围数据',
    jzxyjhz: "集装箱押金回执",
    jzxyjhzzp: "集装箱押金回执照片",
    jzxyjhzyxq: "集装箱押金回执有效期",
    xzdqxqdjxywqqhdsj: "选择当前需求单进行月需求切换的数据有：",
    xytcbqwczjjzt: '已提出并且为车站拒绝状态的日需求数据：',
    wtcrxqdxqdsj: '未提出日需求的需求单数据有：',
    zdksr300: "(最多可输入300字)",
    htqsrq: '合同起始日期',
    htjzrq: "合同截止日期",
    ydlcxqsctxzm: "预订冷藏箱，请上传提箱证明",
    gjhgyqydhbtfpbl: "根据海关要求，预定号不同的货物分批办理报关手续",
    xgyxqh: "修改月需求号",
    zbxxx: "自备箱信息",
    lwbg: "老挝报关：",
    mhbggs: "磨憨报关公司：",
    pjys: "票据样式"
  }
};